(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabecalho-em-branco"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-header-blank')) {
    class StickyHeaderBlank extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionRoot = this.closest('.section-header-blank');
        this.headerWrapper = this.querySelector('.header-wrapper');

        if (!this.sectionRoot || !this.headerWrapper) return;

        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';

        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;

        this.setHeaderHeight = this.setHeaderHeight.bind(this);
        this.onScrollHandler = this.onScroll.bind(this);

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight);

        if (this.headerIsAlwaysSticky) {
          this.sectionRoot.classList.add('shopify-section-header-sticky');
        }

        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      setHeaderHeight() {
        if (!this.headerWrapper) return;
        const h = this.headerWrapper.offsetHeight;
        document.documentElement.style.setProperty('--blank-header-height', `${h}px`);
        document.documentElement.style.setProperty('--header-height', `${h}px`);
      }

      createObserver() {
        if (!this.sectionRoot) return;

        let observer = new IntersectionObserver((entries, observerInstance) => {
          if (!entries || !entries.length) return;
          this.headerBounds = entries[0].intersectionRect;
          observerInstance.disconnect();
        });

        observer.observe(this.sectionRoot);
      }

      onScroll() {
        if (!this.sectionRoot || !this.headerWrapper) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.sectionRoot.classList.add('scrolled-past-header');
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.sectionRoot.classList.add('scrolled-past-header');
          requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop <= this.headerBounds.top) {
          this.sectionRoot.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (!this.sectionRoot || this.headerIsAlwaysSticky) return;
        this.sectionRoot.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }

      reveal() {
        if (!this.sectionRoot || this.headerIsAlwaysSticky) return;
        this.sectionRoot.classList.add('shopify-section-header-sticky', 'animate');
        this.sectionRoot.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (!this.sectionRoot || this.headerIsAlwaysSticky) return;
        this.sectionRoot.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    customElements.define('sticky-header-blank', StickyHeaderBlank);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      /* evita erro quando o header não foi renderizado nesta página */
      if (!this.header) return;

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;

      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.header || this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header || this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header || this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      if (!this.header) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-only-homepage-d-unt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-header-dunt')) {
    class StickyHeaderDunt extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionRoot = this.closest('.section-header-dunt');
        this.headerWrapper = this.querySelector('.header-wrapper');

        if (!this.sectionRoot || !this.headerWrapper) return;

        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';

        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.preventHide = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.setHeaderHeight = this.setHeaderHeight.bind(this);
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight);

        if (this.headerIsAlwaysSticky) {
          this.sectionRoot.classList.add('shopify-section-header-sticky');
        }

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      setHeaderHeight() {
        if (!this.headerWrapper) return;
        document.documentElement.style.setProperty('--header-height', `${this.headerWrapper.offsetHeight}px`);
      }

      createObserver() {
        if (!this.sectionRoot) return;

        let observer = new IntersectionObserver((entries, observerInstance) => {
          if (!entries || !entries.length) return;
          this.headerBounds = entries[0].intersectionRect;
          observerInstance.disconnect();
        });

        observer.observe(this.sectionRoot);
      }

      onScroll() {
        if (!this.sectionRoot || !this.headerWrapper) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.sectionRoot.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.sectionRoot.classList.add('scrolled-past-header');

          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.sectionRoot.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (!this.sectionRoot || this.headerIsAlwaysSticky) return;
        this.sectionRoot.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (!this.sectionRoot || this.headerIsAlwaysSticky) return;
        this.sectionRoot.classList.add('shopify-section-header-sticky', 'animate');
        this.sectionRoot.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (!this.sectionRoot || this.headerIsAlwaysSticky) return;
        this.sectionRoot.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        if (!this.headerWrapper) return;
        this.disclosures = this.disclosures || this.headerWrapper.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => {
          if (typeof disclosure.close === 'function') disclosure.close();
        });
      }

      closeSearchModal() {
        if (!this.headerWrapper) return;
        this.searchModal = this.searchModal || this.headerWrapper.querySelector('details-modal');
        if (this.searchModal && typeof this.searchModal.close === 'function') {
          this.searchModal.close(false);
        }
      }
    }

    customElements.define('sticky-header-dunt', StickyHeaderDunt);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sola-main-product-downsell-b"] && !Shopify.designMode) return;
  try {
    
  /* Sintaxe conservadora de propósito: 74% do tráfego desta LP está no webview do
     Instagram, e o Clarity já registra erro de JS ali. Sem arrow, sem optional
     chaining, sem template literal. Se este script falhar, o <noscript> com o
     <select name="id"> ainda permite comprar. */
  (function () {
    function iniciar(raiz) {
      if (!Prazo) Prazo = criarPrazo();   /* DOM pronto: o relogio ainda da tempo */
      if (raiz.getAttribute('data-mp-pronto')) return;
      raiz.setAttribute('data-mp-pronto', '1');

      var dados = raiz.querySelector('[data-mp-variantes]');
      var variantes = [];
      try { variantes = JSON.parse(dados.textContent); } catch (e) { return; }

      var inputs = raiz.querySelectorAll('[data-mp-input]');
      var campoId = raiz.querySelector('[data-mp-id]');
      var cta = raiz.querySelector('[data-mp-cta]');
      var ctaTxt = raiz.querySelector('[data-mp-cta-txt]');
      var elPix = raiz.querySelector('[data-mp-pix]');
      var elUn = raiz.querySelector('[data-mp-un]');
      var elTotal = raiz.querySelector('[data-mp-total]');
      var elVeste = raiz.querySelector('[data-mp-veste]');
      var tabelaVeste = {};
      var bruta = raiz.querySelector('[data-mp-veste-tabela]');
      if (bruta) {
        try {
          var linhas = String(JSON.parse(bruta.textContent) || '').split('\n');
          for (var t = 0; linhas.length > t; t++) {
            var partes = linhas[t].split('|');
            if (partes.length >= 2) tabelaVeste[partes[0].trim()] = partes.slice(1).join(' · ').trim();
          }
        } catch (e) {}
      }
      var ligacaoVeste = raiz.getAttribute('data-mp-veste-lig') || 'costuma servir em quem tem';
      var textoCta = ctaTxt ? ctaTxt.textContent : 'Adicionar ao carrinho';

      /* ---- Combo: "2 Pretas | 2 Brancas" -> variantes avulsas ---------------
         O mapa vem do Liquid como `cor|tamanho|gola` -> id, só com disponíveis.
         Devolve null a qualquer sinal de dúvida — e null significa "usa o fluxo
         antigo", nunca "não vende". */
      var mapaCombo = null;
      var brutoCombo = raiz.querySelector('[data-mp-combo-mapa]');
      if (brutoCombo) { try { mapaCombo = JSON.parse(brutoCombo.textContent); } catch (e) { mapaCombo = null; } }

      function corDoCatalogo(nome) {
        if (!mapaCombo) return null;
        var alvo = String(nome).trim().toLowerCase();
        /* "Pretas" e "Preta" são a mesma cor; o kit escreve no plural */
        var semS = alvo.replace(/s$/, '');
        for (var k in mapaCombo) {
          var c = k.split('|')[0].toLowerCase();
          if (c === alvo || c === semS) return k.split('|')[0];
        }
        return null;
      }

      function montarCombo(qtdKits) {
        if (!mapaCombo) return null;
        var kits = parseInt(qtdKits, 10) || 1;
        var sel = escolhidos(), cor = null, tam = null, gola = null;
        for (var i = 0; inputs.length > i; i++) {
          if (!inputs[i].checked) continue;
          var nome = (inputs[i].name || '').toLowerCase();
          if (nome.indexOf('cor') >= 0) cor = inputs[i].value;
          else if (nome.indexOf('tamanho') >= 0) tam = inputs[i].value;
          else if (nome.indexOf('gola') >= 0) gola = inputs[i].value;
        }
        if (!cor || !tam || !gola) return null;

        /* a gola da avulsa é "Gola O"; o kit guarda só "O" */
        var golas = [gola, 'Gola ' + gola];
        var partes = String(cor).split('|'), itens = [], total = 0;
        for (var j = 0; partes.length > j; j++) {
          var m = partes[j].trim().match(/^(\d+)\s+(.+)$/);
          if (!m) return null;
          var qtd = parseInt(m[1], 10);
          var nomeCor = corDoCatalogo(m[2]);
          if (!nomeCor || !qtd) return null;
          var par = null;
          for (var g = 0; golas.length > g && !par; g++) par = mapaCombo[nomeCor + '|' + tam + '|' + golas[g]] || null;
          if (!par) return null;
          total += qtd;
          /* _combo_produto/_combo_variante: o produto de VITRINE desta página e a variante
             escolhida dele — o carrinho lateral agrupa o combo com o nome e a foto dele
             (snippets/cart-combo-grupo). Não entram em desconto nenhum. */
          var vitrineProps = { _kit_variant_id: String(par[0]) };
          if (raiz.getAttribute('data-mp-vitrine')) vitrineProps._combo_produto = raiz.getAttribute('data-mp-vitrine');
          if (campoId && campoId.value) vitrineProps._combo_variante = String(campoId.value);
          /* nome e foto da linha de kit do checkout (Cart Transform kit-agrupado) */
          if (raiz.getAttribute('data-mp-vitrine-titulo')) vitrineProps._combo_titulo = raiz.getAttribute('data-mp-vitrine-titulo');
          if (raiz.getAttribute('data-mp-vitrine-img')) vitrineProps._combo_img = raiz.getAttribute('data-mp-vitrine-img');
          /* kit FECHADO (metacampo custom.agrupar_bundle da vitrine) */
          if (raiz.getAttribute('data-mp-agrupar') === '1') vitrineProps._agrupar = '1';
          itens.push({ id: par[0], quantity: qtd * kits, properties: vitrineProps,
                       preco: par[1], qtd: qtd });
        }
        /* a composição tem que fechar o slot, senão a Function não desconta e a
           página estaria prometendo um preço que o checkout não daria */
        if (total !== (parseInt(raiz.getAttribute('data-mp-combo-qtd'), 10) || 4)) return null;
        return { itens: itens, kits: kits };
      }

      /* Preço do combo, com a MESMA conta do checkout (moonapps, ADR 0005): a % sobre a
         soma das peças da composição, arredondada UMA vez, meio centavo para o cliente.
         4 × 169,90 a 25,2% = 679,60 − 171,26 = R$ 508,34 (pix 493,09). Peça a peça davam
         508,36, que era o que a Function cobrava até 10/2026. A mesma conta mora em
         snippets/combo-desconto-centavos — mudar junto. */
      function dinheiro(centavos) {
        return 'R$ ' + (centavos / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      var comboPct = parseFloat(raiz.getAttribute('data-mp-combo-pct'));
      function totalCombo() {
        if (!mapaCombo || isNaN(comboPct)) return null;
        var c = montarCombo(1);
        if (!c) return null;
        var cheio = 0;
        for (var i = 0; c.itens.length > i; i++) cheio += c.itens[i].preco * c.itens[i].qtd;
        /* em inteiros: a % com até 4 casas, mesmo teto de 50% da Function */
        var n = cheio * Math.round(Math.min(comboPct, 50) * 10000);
        var desconto = Math.floor((2 * n + 1000000) / 2000000);
        return { cheio: cheio, total: cheio - desconto, pecas: c.itens.reduce(function (a, x) { return a + x.qtd; }, 0) };
      }

      function escolhidos() {
        var fora = [];
        for (var i = 0; inputs.length > i; i++) {
          if (inputs[i].checked) fora[Number(inputs[i].getAttribute('data-mp-pos'))] = inputs[i].value;
        }
        return fora;
      }

      function acha(sel) {
        for (var i = 0; variantes.length > i; i++) {
          var v = variantes[i], bate = true;
          for (var k = 0; sel.length > k; k++) { if (v.op[k] !== sel[k]) { bate = false; break; } }
          if (bate) return v;
        }
        return null;
      }

      /* marca as opções que não existem em estoque para a combinação atual */
      function marcarIndisponiveis(sel) {
        for (var i = 0; inputs.length > i; i++) {
          var inp = inputs[i], pos = Number(inp.getAttribute('data-mp-pos'));
          var teste = sel.slice(); teste[pos] = inp.value;
          var v = acha(teste);
          var rot = raiz.querySelector('label[for="' + inp.id + '"]');
          if (rot) rot.setAttribute('data-esgotado', (v && v.d) ? '0' : '1');
        }
      }

      function atualizar() {
        var sel = escolhidos();
        var v = acha(sel);
        marcarIndisponiveis(sel);
        atualizarFotoBarra();

        for (var i = 0; inputs.length > i; i++) {
          if (inputs[i].checked) {
            var alvo = raiz.querySelector('[data-mp-valor="' + inputs[i].getAttribute('data-mp-pos') + '"]');
            if (alvo) alvo.textContent = inputs[i].value;
          }
        }

        /* A linha embaixo do seletor. Ela dizia "PP veste 55 a 65 kg", uma afirmação
           que a grade não sustenta: as faixas de peso se sobrepõem e a mesma pessoa
           cabe em dois tamanhos. O verbo agora é de tendência, não de decreto — quem
           decide é o provador, e o convite para ele está na faixa logo abaixo. */
        if (elVeste) {
          for (var t = 0; inputs.length > t; t++) {
            if (inputs[t].checked && tabelaVeste[inputs[t].value]) {
              elVeste.innerHTML = '<b>' + inputs[t].value + '</b> ' + ligacaoVeste + ' ' + tabelaVeste[inputs[t].value];
            }
          }
        }

        if (!v) {
          if (cta) { cta.disabled = true; }
          if (ctaTxt) { ctaTxt.textContent = 'Combinação indisponível'; }
          return;
        }
        if (campoId) campoId.value = v.id;
        var tc = totalCombo();
        if (tc && tc.total > 0) {
          /* o preço vem da composição real que vai para o carrinho, não do
             produto do módulo — é o mesmo número que o checkout vai cobrar */
          var pixPct = parseFloat(raiz.getAttribute('data-mp-pix-pct'));
          if (isNaN(pixPct)) pixPct = 0;
          var pix = Math.round(tc.total * (1 - pixPct / 100));
          if (elPix) elPix.textContent = dinheiro(pix);
          if (elUn) elUn.textContent = dinheiro(Math.round(pix / (tc.pecas || 1)));
          var elDe = raiz.querySelector('.sola-mp__de');
          if (elDe) elDe.textContent = dinheiro(tc.cheio);
        } else {
          if (elPix) elPix.textContent = v.pix;
          if (elUn) elUn.textContent = v.un;
        }
        if (typeof atualizarTotal === 'function') atualizarTotal();
        if (cta) cta.disabled = !v.d;
        if (ctaTxt) ctaTxt.textContent = v.d ? textoCta : 'Esgotado';
      }

      for (var i = 0; inputs.length > i; i++) inputs[i].addEventListener('change', atualizar);
      atualizar();

      /* galeria: miniatura leva o palco até a foto, e o arrasto marca a miniatura */
      var palco = raiz.querySelector('[data-mp-tira]');
      var minis = raiz.querySelectorAll('[data-mp-mini]');
      function marcarMini(i) {
        for (var k = 0; minis.length > k; k++) {
          if (k === i) minis[k].setAttribute('aria-current', 'true');
          else minis[k].removeAttribute('aria-current');
        }
      }
      for (var m = 0; minis.length > m; m++) {
        (function (btn, idx) {
          btn.addEventListener('click', function () { irPara(idx); });
        })(minis[m], m);
      }
      if (palco && minis.length) {
      }

      /* ─── um passo por gesto ───
         scroll-snap sozinho não impede o embalo do trackpad de pular 5 fotos.
         A roda é interceptada e move exatamente um; o toque é limitado a ±1
         em relação ao índice onde o gesto começou. */
      var trilho = raiz.querySelector('[data-mp-trilho]');
      var idxPalco = 0;
      function idxAtual() { return idxPalco; }
      function desenhar(px) {
        if (!trilho) return;
        var base = -idxPalco * 100;
        trilho.style.transform = px
          ? 'translate3d(calc(' + base + '% + ' + Math.round(px) + 'px), 0, 0)'
          : 'translate3d(' + base + '%, 0, 0)';
      }
      /* O vídeo toca quando o slide dele entra, e para quando sai. Sempre mudo:
         navegador nenhum deixa tocar com som sem gesto, e o play falharia calado. */
      function tocarDoSlide(i) {
        if (!trilho || raiz.getAttribute('data-mp-autoplay') !== '1') return;
        var itens = trilho.children;
        for (var k = 0; itens.length > k; k++) {
          var v = itens[k].querySelector('video');
          if (!v) continue;
          if (k === i) {
            v.muted = true;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});   /* política do navegador: segue a vida */
          } else if (!v.paused) {
            v.pause();
          }
        }
      }
      function irPara(i) {
        var max = minis.length - 1;
        if (i > max) i = max;
        if (0 > i) i = 0;
        idxPalco = i;
        desenhar(0);
        marcarMini(i);
        atualizarSetas();
        tocarDoSlide(i);
      }
      /* setas: mesma função do gesto, então uma coisa só decide o índice */
      var setas = raiz.querySelectorAll('[data-mp-seta]');
      function atualizarSetas() {
        if (!setas.length) return;
        var i = idxAtual(), max = minis.length - 1;
        for (var s = 0; setas.length > s; s++) {
          var passo = parseInt(setas[s].getAttribute('data-mp-seta'), 10);
          setas[s].disabled = (0 > passo && 0 >= i) || (passo > 0 && i >= max);
        }
      }
      for (var s2 = 0; setas.length > s2; s2++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            irPara(idxAtual() + parseInt(btn.getAttribute('data-mp-seta'), 10));
            setTimeout(atualizarSetas, 460);
          });
        })(setas[s2]);
      }

      /* Zoom seguindo o ponteiro. Marcamos com atributo em vez de estilo inline para
         a transição de saída existir — tirar o transform inline cortaria a volta. */
      function ligarZoom(alvo) {
        if (!alvo || alvo.getAttribute('data-zoom-pronto')) return;
        alvo.setAttribute('data-zoom-pronto', '1');
        alvo.addEventListener('mousemove', function (e) {
          var img = alvo.querySelector('img');
          if (!img) return;
          var c = alvo.getBoundingClientRect();
          img.style.transformOrigin =
            (((e.clientX - c.left) / c.width) * 100) + '% ' + (((e.clientY - c.top) / c.height) * 100) + '%';
        });
        alvo.addEventListener('mouseenter', function () {
          if (alvo.querySelector('img')) alvo.setAttribute('data-zoom', '1');
        });
        alvo.addEventListener('mouseleave', function () { alvo.removeAttribute('data-zoom'); });
      }
      if (raiz.getAttribute('data-mp-zoom') === '1') {
        var itens = raiz.querySelectorAll('.sola-mp__item');
        for (var z2 = 0; itens.length > z2; z2++) ligarZoom(itens[z2]);
      }

      if (palco) {
        atualizarSetas();
        var travaRoda = false;
        palco.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   /* rolagem vertical: deixa passar */
          e.preventDefault();
          if (travaRoda) return;
          travaRoda = true;
          irPara(idxAtual() + (e.deltaX > 0 ? 1 : -1));
          setTimeout(function () { travaRoda = false; }, 430);
        }, { passive: false });

        /* Arrasto próprio. `arrastando` só vira true quando o movimento é claramente
           horizontal, senão a pessoa não consegue mais rolar a página com o dedo em
           cima da foto. A decisão sai no touchend e é sempre ±1: distância acima do
           limiar OU velocidade alta (flick curto e rápido também tem que virar página). */
        var x0 = 0, y0 = 0, t0 = 0, dx = 0, arrastando = false, decidiu = false;
        palco.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
          t0 = Date.now(); dx = 0; arrastando = false; decidiu = false;
        }, { passive: true });

        palco.addEventListener('touchmove', function (e) {
          if (e.touches.length !== 1) return;
          var ax = e.touches[0].clientX - x0, ay = e.touches[0].clientY - y0;
          if (!decidiu) {
            if (6 > Math.abs(ax) && 6 > Math.abs(ay)) return;   /* ainda não dá para saber */
            decidiu = true;
            arrastando = Math.abs(ax) > Math.abs(ay);
            if (arrastando && trilho) trilho.setAttribute('data-arrastando', '1');
          }
          if (!arrastando) return;
          e.preventDefault();                     /* segura a rolagem da página */
          dx = ax;
          /* resistência nas pontas, para a foto não descolar do fim do carretel */
          if ((0 >= idxPalco && dx > 0) || (idxPalco >= minis.length - 1 && 0 > dx)) dx = dx * 0.32;
          desenhar(dx);
        }, { passive: false });

        function soltar() {
          if (!arrastando) return;
          arrastando = false;
          if (trilho) trilho.removeAttribute('data-arrastando');
          var larg = palco.clientWidth || 1;
          var vel = Math.abs(dx) / Math.max(1, Date.now() - t0);   /* px por ms */
          var passou = Math.abs(dx) > larg * 0.18 || vel > 0.45;
          irPara(idxPalco + (passou ? (0 > dx ? 1 : -1) : 0));
          dx = 0;
        }
        palco.addEventListener('touchend', soltar, { passive: true });
        palco.addEventListener('touchcancel', soltar, { passive: true });
      }

      /* ─── vídeo: play/pause e volume próprios ─── */
      function ligarVideo(caixa) {
        var vid = caixa.querySelector('video');
        var btn = caixa.querySelector('[data-mp-play]');
        var mudo = caixa.querySelector('[data-mp-mudo]');
        var faixa = caixa.querySelector('[data-mp-volume]');
        if (!vid) return;
        vid.muted = true; vid.volume = 0;
        if (mudo) mudo.setAttribute('data-mudo', '1');

        function pintar() {
          if (!btn) return;
          if (vid.paused) btn.removeAttribute('data-tocando');
          else btn.setAttribute('data-tocando', '1');
          btn.setAttribute('aria-label', vid.paused ? 'Reproduzir vídeo' : 'Pausar vídeo');
        }
        function alternar(e) {
          if (e) { e.preventDefault(); e.stopPropagation(); }
          if (vid.paused) vid.play(); else vid.pause();
        }
        /* No palco, clicar no vídeo abre o lightbox — quem dá play/pause é a bolinha.
           Dentro do lightbox não há para onde expandir, então o clique alterna. */
        if (btn) btn.addEventListener('click', alternar);
        if (caixa.closest('.sola-mp-lb')) vid.addEventListener('click', alternar);
        vid.addEventListener('play', pintar);
        vid.addEventListener('pause', pintar);
        vid.addEventListener('ended', pintar);
        if (mudo) {
          mudo.addEventListener('click', function (e) {
            e.stopPropagation();
            vid.muted = !vid.muted;
            if (!vid.muted && vid.volume === 0) vid.volume = 0.7;
            if (faixa) faixa.value = vid.muted ? 0 : Math.round(vid.volume * 100);
            if (vid.muted) mudo.setAttribute('data-mudo', '1'); else mudo.removeAttribute('data-mudo');
            mudo.setAttribute('aria-label', vid.muted ? 'Ativar som' : 'Silenciar');
          });
        }
        if (faixa) {
          faixa.addEventListener('click', function (e) { e.stopPropagation(); });
          faixa.addEventListener('input', function () {
            vid.volume = faixa.value / 100;
            vid.muted = vid.volume === 0;
            if (mudo) { if (vid.muted) mudo.setAttribute('data-mudo', '1'); else mudo.removeAttribute('data-mudo'); }
          });
        }
        pintar();
      }
      var caixasVideo = raiz.querySelectorAll('.sola-mp__item--video');
      for (var cv = 0; caixasVideo.length > cv; cv++) ligarVideo(caixasVideo[cv]);

      /* ─── lightbox ─── */
      var lb = raiz.parentElement && raiz.parentElement.querySelector('[data-mp-lb]');
      var midia = [];
      var fonteMidia = raiz.querySelector('[data-mp-midia]');
      if (fonteMidia) { try { midia = JSON.parse(fonteMidia.textContent); } catch (e) {} }

      if (lb && midia.length) {
        lb.removeAttribute('hidden');
        var lbPalco = lb.querySelector('[data-mp-lb-palco]');
        var lbConta = lb.querySelector('[data-mp-lb-contador]');
        var lbIdx = 0, focoAnterior = null;

        var retomar = null;   /* {t: segundos, tocando: bool} vindo do palco */

        var lbParado = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        function montarLb(i, de) {
          var m = midia[i];
          if (!m) return;
          lbIdx = i;
          lbPalco.innerHTML = '';
          var caixa = document.createElement('div');
          caixa.className = 'sola-mp-lb__midia';
          if (m.t === 'img') {
            var img = document.createElement('img');
            img.src = m.src; img.alt = m.alt || '';
            caixa.appendChild(img);
          } else if (m.t === 'video') {
            var v = document.createElement('video');
            v.setAttribute('playsinline', ''); v.preload = 'metadata';
            if (m.poster) v.poster = m.poster;
            for (var f = 0; m.srcs.length > f; f++) {
              var src = document.createElement('source');
              src.src = m.srcs[f].u; src.type = m.srcs[f].m;
              v.appendChild(src);
            }
            if (retomar) {
              var alvoT = retomar.t, deveTocar = retomar.tocando;
              retomar = null;
              v.addEventListener('loadedmetadata', function () {
                try { v.currentTime = alvoT; } catch (e) {}
                if (deveTocar) v.play();
              }, { once: true });
              v.preload = 'auto';
            }
            caixa.appendChild(v);
            caixa.insertAdjacentHTML('beforeend', raiz.querySelector('[data-mp-play]') ?
              raiz.querySelector('[data-mp-play]').outerHTML : '');
            var vol = raiz.querySelector('[data-mp-vol]');
            if (vol) caixa.insertAdjacentHTML('beforeend', vol.outerHTML);
          } else if (m.t === 'externo') {
            caixa.innerHTML = m.html;
          }
          lbPalco.appendChild(caixa);
          if (m.t === 'video') ligarVideo(caixa);
          /* o lightbox é montado a cada abertura, então o zoom se liga aqui e não
             junto com o palco — a caixa nem existia quando a página carregou */
          else if (raiz.getAttribute('data-mp-zoom') === '1') ligarZoom(caixa);
          if (lbConta) lbConta.textContent = (i + 1) + ' / ' + midia.length;
          /* A que entra chega do lado de onde veio o gesto. Vale tambem para as setas
             e para o teclado: um so caminho decide o movimento, entao os tres andam igual. */
          if (de && !lbParado) {
            var larg = lb.clientWidth || 1;
            caixa.style.transform = 'translate3d(' + Math.round(de * larg * 0.55) + 'px,0,0)';
            caixa.style.opacity = '0';
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                caixa.setAttribute('data-lb-solto', '1');
                caixa.style.transform = '';
                caixa.style.opacity = '';
              });
            });
          }
        }
        function abrirLb(i) {
          /* pausa o vídeo do palco e leva o ponto dele para o lightbox */
          var itensV = raiz.querySelectorAll('.sola-mp__item');
          if (itensV[i]) {
            var vp = itensV[i].querySelector('video');
            if (vp) {
              retomar = { t: vp.currentTime || 0, tocando: !vp.paused };
              vp.pause();
            }
          }
          focoAnterior = document.activeElement;
          montarLb(i);
          lb.setAttribute('data-aberto', '1');
          document.documentElement.style.overflow = 'hidden';
          var fechar = lb.querySelector('[data-mp-lb-fechar]');
          if (fechar) fechar.focus();
        }
        function fecharLb() {
          var v = lbPalco.querySelector('video'); if (v) v.pause();
          lb.removeAttribute('data-aberto');
          document.documentElement.style.overflow = '';
          lbPalco.innerHTML = '';
          if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
        }
        function andar(d) {
          var v = lbPalco.querySelector('video'); if (v) v.pause();
          var i = lbIdx + d;
          if (0 > i) i = midia.length - 1;
          if (i > midia.length - 1) i = 0;
          montarLb(i, d);
        }

        var itens = raiz.querySelectorAll('.sola-mp__item');
        for (var it = 0; itens.length > it; it++) {
          (function (el, idx) {
            el.addEventListener('click', function (e) {
              /* a bolinha de play tem o clique dela; o resto do vídeo expande */
              if (e.target.closest && e.target.closest('[data-mp-play]')) return;
              e.preventDefault();
              abrirLb(idx);
            });
          })(itens[it], it);
        }
        var fecharBtn = lb.querySelector('[data-mp-lb-fechar]');
        if (fecharBtn) fecharBtn.addEventListener('click', fecharLb);
        var antBtn = lb.querySelector('[data-mp-lb-ant]');
        if (antBtn) antBtn.addEventListener('click', function () { andar(-1); });
        var proxBtn = lb.querySelector('[data-mp-lb-prox]');
        if (proxBtn) proxBtn.addEventListener('click', function () { andar(1); });
        lb.addEventListener('click', function (e) { if (e.target === lb) fecharLb(); });

        /* ─── arrastar para o lado ───
           O palco monta uma midia por vez, entao nao existe trilho para deslizar:
           quem segue o dedo e a propria caixa. Ponteiro em vez de toque porque assim
           o mesmo codigo atende dedo e mouse, que era o pedido. Limiar igual ao do
           carrossel do palco: 16% da largura OU um flick rapido — um puxao curto e
           veloz tambem tem que virar a foto. */
        var gX0 = 0, gY0 = 0, gT0 = 0, gDx = 0, gArr = false, gDec = false;
        var gId = null, gMoveu = 0, gOcupado = false;
        function gCaixa() { return lbPalco.querySelector('.sola-mp-lb__midia'); }

        lbPalco.addEventListener('pointerdown', function (e) {
          if (gOcupado) return;
          if (e.button && e.button !== 0) return;
          /* o controle de volume tem o arrasto dele */
          if (e.target.closest && e.target.closest('[data-mp-volume]')) return;
          gId = e.pointerId; gX0 = e.clientX; gY0 = e.clientY; gT0 = Date.now();
          gDx = 0; gArr = false; gDec = false;
          var c = gCaixa();
          if (c) { c.removeAttribute('data-lb-solto'); c.style.transition = ''; }
        });

        lbPalco.addEventListener('pointermove', function (e) {
          if (gId === null || e.pointerId !== gId) return;
          var ax = e.clientX - gX0, ay = e.clientY - gY0;
          if (!gDec) {
            if (6 > Math.abs(ax) && 6 > Math.abs(ay)) return;   /* ainda nao da para saber */
            gDec = true;
            gArr = Math.abs(ax) > Math.abs(ay);
            if (gArr) {
              try { lbPalco.setPointerCapture(gId); } catch (err) {}
              var cz = gCaixa();
              if (cz) cz.removeAttribute('data-zoom');   /* zoom e arrasto nao convivem */
            }
          }
          if (!gArr) return;
          e.preventDefault();
          gDx = ax;
          var c = gCaixa();
          if (c) c.style.transform = 'translate3d(' + Math.round(gDx) + 'px,0,0)';
        });

        function gSoltar(e) {
          if (gId === null) return;
          var eraArr = gArr;
          try { if (lbPalco.releasePointerCapture) lbPalco.releasePointerCapture(gId); } catch (err) {}
          gId = null; gArr = false;
          var c = gCaixa();
          if (!eraArr) { if (c) c.style.transform = ''; return; }
          gMoveu = Date.now();                       /* engole o clique que vem atras do arrasto */
          var larg = lb.clientWidth || 1;
          var vel = Math.abs(gDx) / Math.max(1, Date.now() - gT0);   /* px por ms */
          var passou = Math.abs(gDx) > larg * 0.16 || vel > 0.4;
          if (!passou) {
            if (c) { c.setAttribute('data-lb-solto', '1'); c.style.transform = ''; }
            gDx = 0;
            return;
          }
          var d = 0 > gDx ? 1 : -1;
          gDx = 0;
          if (c && !lbParado) {
            /* a que sai continua o movimento do dedo ate a borda, e so entao a
               proxima e montada. `gOcupado` segura um segundo gesto nesse meio. */
            gOcupado = true;
            c.style.transition = 'transform .16s ease-out, opacity .16s ease-out';
            c.style.transform = 'translate3d(' + Math.round(-d * larg * 0.7) + 'px,0,0)';
            c.style.opacity = '0';
            setTimeout(function () { gOcupado = false; andar(d); }, 150);
          } else {
            andar(d);
          }
        }
        lbPalco.addEventListener('pointerup', gSoltar);
        lbPalco.addEventListener('pointercancel', gSoltar);

        /* Sem isto o fim de um arrasto vira clique: fecharia o lightbox se soltasse
           sobre o veu, ou daria play no video se soltasse sobre ele. */
        /* No `document` e nao no proprio lightbox: quando o clique cai no veu, o alvo
           E o lightbox, e no alvo os ouvintes disparam por ordem de registro — o que
           fecha foi registrado antes e passaria na frente. Um degrau acima resolve. */
        document.addEventListener('click', function (e) {
          if (!lb.hasAttribute('data-aberto')) return;
          if (320 > Date.now() - gMoveu) { e.preventDefault(); e.stopPropagation(); }
        }, true);

        document.addEventListener('keydown', function (e) {
          if (!lb.hasAttribute('data-aberto')) return;
          if (e.key === 'Escape') fecharLb();
          if (e.key === 'ArrowLeft') andar(-1);
          if (e.key === 'ArrowRight') andar(1);
        });
      }

      /* Barra fixa: aparece quando o botão principal NÃO está na tela.
         Tem que ser "não visível", não "já passou": para a maior parte deste
         tráfego o botão está ABAIXO e nunca é alcançado. */
      var barra = (raiz.parentElement && raiz.parentElement.querySelector('[data-mp-barra]')) || null;
      if (barra) {
        barra.removeAttribute('hidden');
        /* O gatilho pode ser um seletor (a seção que a barra deve seguir) ou, sem
           seletor, a enésima seção da página. E o disparo não é "a seção saiu inteira
           da tela": é ela passar de um ponto configurável da própria altura — assim a
           barra chega enquanto a pessoa ainda está saindo da seção, não depois. */
        var sel = barra.getAttribute('data-mp-gatilho');
        var gatilho = sel ? document.querySelector(sel) : null;
        if (!gatilho) {
          var aposN = parseInt(barra.getAttribute('data-mp-apos'), 10) || 2;
          var secoes = document.querySelectorAll('#MainContent [id^="shopify-section-"], main [id^="shopify-section-"]');
          gatilho = secoes.length >= aposN ? secoes[aposN - 1] : null;
        }
        var ponto = parseInt(barra.getAttribute('data-mp-ponto'), 10);
        if (isNaN(ponto)) ponto = 100;

        var moduloNaTela = false;
        var elModulo = document.querySelector('.sola-mp__grid');
        if (elModulo && 'IntersectionObserver' in window) {
          /* Enquanto o módulo está à vista, a barra flutuante some: os dois oferecem a
             mesma ação no mesmo instante e disputam a atenção. Ela volta assim que ele sai. */
          new IntersectionObserver(function (ent) {
            moduloNaTela = ent[0].isIntersecting;
            avaliarBarra();
          }, { rootMargin: '-70px 0px -40px 0px', threshold: 0 }).observe(elModulo);
        }
        function avaliarBarra() {
          if (!gatilho) return;
          if (moduloNaTela) { barra.removeAttribute('data-visivel'); return; }
          var cx = gatilho.getBoundingClientRect();
          /* ponto = 50 significa "quando metade da seção já subiu além do topo" */
          var passou = cx.top + (cx.height * ponto / 100) <= 0;
          var gav = document.querySelector('cart-drawer');
          var gavAberta = gav && /active|is-open/.test(gav.className);
          if (passou && !gavAberta) barra.setAttribute('data-visivel', '1');
          else barra.removeAttribute('data-visivel');
        }
        var irBarra = barra.querySelector('[data-mp-barra-btn]');
        if (irBarra) irBarra.addEventListener('click', function () {
          var alvo = document.querySelector(barra.getAttribute('data-mp-barra-ir') || '#modulo');
          if (!alvo) return;
          var topo = alvo.getBoundingClientRect().top + window.pageYOffset
            - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mp-topo'), 10) || 96);
          window.scrollTo({ top: topo, behavior: 'smooth' });
        });

        window.addEventListener('scroll', avaliarBarra, { passive: true });
        window.addEventListener('resize', avaliarBarra);
        avaliarBarra();

        var gav2 = document.querySelector('cart-drawer');
        if (gav2 && 'MutationObserver' in window) {
          new MutationObserver(avaliarBarra).observe(gav2, { attributes: true, attributeFilter: ['class'] });
        }
      }

      /* "2.419 avaliações" leva para a seção de avaliações da página */
      var irAval = raiz.querySelector('[data-mp-ir-avaliacoes]');
      if (irAval) {
        irAval.addEventListener('click', function () {
          var sel = raiz.getAttribute('data-mp-alvo-avaliacoes');
          var alvo = sel ? document.querySelector(sel) : null;
          if (!alvo) {
            var todas = document.querySelectorAll('[id^="shopify-section-"]');
            for (var z = 0; todas.length > z; z++) {
              if (/review|avalia|konfidency|judge|loox/i.test(todas[z].id + ' ' + todas[z].className)) { alvo = todas[z]; break; }
            }
          }
          if (!alvo) return;
          var topo = parseInt(getComputedStyle(raiz).getPropertyValue('--mp-topo'), 10) || 96;
          var y = alvo.getBoundingClientRect().top + window.pageYOffset - topo;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      }

      /* "+N" revela as combinações restantes */
      var btnMais = raiz.querySelector('[data-mp-mais]');
      if (btnMais) {
        var caixaSw = raiz.querySelector('[data-mp-swatches]');
        var tempoFecha = null;
        var tempoAltura = null;

        /* Anima a altura da grade: sem isto o total, o botão e a galeria dão um
           salto quando a segunda linha entra ou sai. */
        /* medir: função que deixa a caixa no estado FINAL só para ler a altura.
           aplicar: função que deixa a caixa no estado que deve ficar durante a animação. */
        function animarAltura(medir, aplicar, dur) {
          var antes = caixaSw.offsetHeight;
          medir();
          caixaSw.style.height = 'auto';
          var depois = caixaSw.offsetHeight;
          aplicar();
          if (antes === depois) { caixaSw.style.height = ''; return; }
          caixaSw.setAttribute('data-animando', '1');
          caixaSw.style.height = antes + 'px';
          caixaSw.offsetHeight;                 /* força o reflow */
          caixaSw.style.transition = 'height ' + dur + 'ms cubic-bezier(.22,.61,.36,1)';
          caixaSw.style.height = depois + 'px';
          if (tempoAltura) clearTimeout(tempoAltura);
          tempoAltura = setTimeout(function () {
            caixaSw.style.transition = '';
            caixaSw.style.height = '';
            caixaSw.removeAttribute('data-animando');
          }, dur + 30);
        }

        btnMais.addEventListener('click', function () {
          if (tempoFecha) { clearTimeout(tempoFecha); tempoFecha = null; }
          var aberto = caixaSw.hasAttribute('data-aberto') && !caixaSw.hasAttribute('data-fechando');

          if (aberto) {
            /* mede recolhida, mas mantém aberta+fechando para o fade rodar junto */
            animarAltura(
              function () { caixaSw.removeAttribute('data-aberto'); },
              function () { caixaSw.setAttribute('data-aberto', '1'); caixaSw.setAttribute('data-fechando', '1'); },
              280);
            tempoFecha = setTimeout(function () {
              /* só encerra se o fechamento ainda estiver valendo */
              if (caixaSw.hasAttribute('data-fechando')) {
                caixaSw.removeAttribute('data-fechando');
                caixaSw.removeAttribute('data-aberto');
              }
              tempoFecha = null;
            }, 285);
              btnMais.setAttribute('aria-expanded', 'false');
          } else {
            animarAltura(
              function () { caixaSw.removeAttribute('data-fechando'); caixaSw.setAttribute('data-aberto', '1'); },
              function () {},
              340);
            btnMais.setAttribute('aria-expanded', 'true');
          }
        });
      }

      /* quantidade — e o total acompanha */
      var campoQtd = raiz.querySelector('.sola-mp__qtd-num');
      var botoesQtd = raiz.querySelectorAll('[data-mp-qtd]');
      var kitQtd = parseInt(raiz.getAttribute('data-mp-kit'), 10) || 1;
      var pixMult = parseFloat(raiz.getAttribute('data-mp-pixmult')) || 1;
      var resumo1 = raiz.getAttribute('data-mp-resumo') || '';
      var resumoN = raiz.getAttribute('data-mp-resumo-multi') || '';
      var elResumo = raiz.querySelector('[data-mp-resumo-alvo]');

      function dinheiro(centavos) {
        var v = Math.round(centavos) / 100;
        var inteiro = Math.floor(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        var frac = Math.round((v - Math.floor(v)) * 100);
        return 'R$ ' + inteiro + ',' + (10 > frac ? '0' + frac : frac);
      }

      /* A foto da barra acompanha a combinação. A fonte é a própria imagem do swatch
         que já está no DOM — nada de mapa paralelo em JSON, que sairia do ar sozinho
         no dia em que o cliente trocasse uma foto no personalizador. */
      var barraFoto = document.querySelector('[data-mp-barra-foto] img');
      var fotoInicial = barraFoto ? (barraFoto.getAttribute('src') || '') : '';
      function atualizarFotoBarra() {
        if (!barraFoto) return;
        var escolhida = null;
        for (var i = 0; inputs.length > i; i++) {
          if (!inputs[i].checked) continue;
          var lab = raiz.querySelector('label[for="' + inputs[i].id + '"]');
          var im = lab ? lab.querySelector('.sola-mp__sw-img img') : null;
          if (im) escolhida = im;
        }
        var src = escolhida ? (escolhida.currentSrc || escolhida.getAttribute('src')) : fotoInicial;
        if (!src || barraFoto.getAttribute('src') === src) return;
        barraFoto.setAttribute('src', src);
        barraFoto.removeAttribute('srcset');    /* senão o srcset antigo vence o src novo */
      }

      function atualizarTotal() {
        var qtd = parseInt(campoQtd ? campoQtd.value : 1, 10) || 1;
        var sel = escolhidos();
        var v = acha(sel);
        /* Quando existe combo, o preço é o da COMPOSIÇÃO que vai para o carrinho —
           não o da variante do produto do módulo. Sem isto o topo mostrava o preço do
           combo e o total logo acima do botão mostrava o preço do produto antigo, dois
           números diferentes na mesma tela para a mesma coisa. */
        var tcT = (typeof totalCombo === 'function') ? totalCombo() : null;
        var baseUm = (tcT && tcT.total > 0) ? Math.round(tcT.total * pixMult)
                                            : (v ? v.p * pixMult : 0);
        var pecasUm = (tcT && tcT.pecas) ? tcT.pecas : kitQtd;
        if (elTotal && (v || tcT)) {
          elTotal.innerHTML = dinheiro(baseUm * qtd) +
            ' <span class="sola-mp__pix-mini">no pix</span>';
        }
        var bTot = document.querySelector('[data-mp-barra-total]');
        var bUn = document.querySelector('[data-mp-barra-un]');
        if (bTot && (v || tcT)) bTot.textContent = dinheiro(baseUm * qtd);
        if (bUn && (v || tcT)) bUn.textContent = dinheiro(Math.round(baseUm / pecasUm)) + '/un';
        if (elResumo) {
          elResumo.textContent = (qtd > 1 && resumoN)
            ? resumoN.replace('{pecas}', kitQtd * qtd).replace('{kits}', qtd)
            : resumo1;
        }
      }

      for (var q = 0; botoesQtd.length > q; q++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            var n = parseInt(campoQtd.value, 10) || 1;
            n = n + parseInt(btn.getAttribute('data-mp-qtd'), 10);
            if (1 > n) n = 1;
            campoQtd.value = n;
            atualizarTotal();
          });
        })(botoesQtd[q]);
      }
      if (campoQtd) {
        campoQtd.addEventListener('change', atualizarTotal);
        campoQtd.addEventListener('input', atualizarTotal);
      }
      atualizarTotal();

      /* Adicionar ao carrinho abre a GAVETA do tema em vez de ir para /cart.
         Usa a API do próprio cart-drawer (Dawn): renderContents já abre a gaveta. */
      var form = raiz.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', function (ev) {
          var gaveta = document.querySelector('cart-drawer');
          if (!gaveta) return;                       /* sem gaveta: deixa o POST normal */
          ev.preventDefault();
          if (cta) { cta.disabled = true; cta.setAttribute('aria-busy', 'true'); }
          if (ctaTxt) ctaTxt.textContent = raiz.getAttribute('data-mp-cta-carregando') || 'Adicionando';

          var dados = new FormData(form);
          if (typeof gaveta.getSectionsToRender === 'function') {
            var ids = [];
            var secoes = gaveta.getSectionsToRender();
            for (var z = 0; secoes.length > z; z++) ids.push(secoes[z].id);
            dados.append('sections', ids.join(','));
            dados.append('sections_url', window.location.pathname);
          }
          var raiz_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          /* Redesenha a gaveta INTEIRA pela API de seções e alinha a classe `is-empty`
             do <cart-drawer> ao carrinho real. Nunca navega.

             Por que não confiar só no renderContents(json) do tema: sem `sections` na
             resposta do add ele não tem o que desenhar — e quem limpa o `is-empty` do
             host no add do Dawn é o product-form.js (~linha 112), que esta LP não usa.
             Resultado no PRIMEIRO add com carrinho vazio: o host seguia `is-empty`, o
             CSS do drawer escondia header, barra, itens e rodapé, e a gaveta abria em
             branco só com o upsell. Medido ao vivo em 11/09.

             O alvo da troca é o #CartDrawer — o mesmo que o renderContents do tema usa —
             e a URL é a da página, não a raiz, pelo mesmo motivo do cart.js: o escopo do
             Order Bump V2 lê page.handle. */
          function recarregarGaveta() {
            var url = (window.location && window.location.pathname ? window.location.pathname : raiz_url) + '?sections=cart-drawer';
            return fetch(url)
              .then(function (r) { return r.json(); })
              .then(function (sec) {
                var html = sec && sec['cart-drawer'];
                if (!html) return;
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var novo = doc.querySelector('#CartDrawer');
                var atual = gaveta.querySelector('#CartDrawer');
                if (novo && atual) {
                  atual.innerHTML = novo.innerHTML;
                  /* o overlay foi recriado: religa o fechar-ao-clicar-fora (igual o tema) */
                  var overlay = gaveta.querySelector('#CartDrawer-Overlay');
                  if (overlay && typeof gaveta.close === 'function') overlay.addEventListener('click', gaveta.close.bind(gaveta));
                } else {
                  var novoInner = doc.querySelector('.drawer__inner');
                  var atualInner = gaveta.querySelector('.drawer__inner');
                  if (novoInner && atualInner) atualInner.innerHTML = novoInner.innerHTML;
                }
                /* is-empty vem do que a seção devolveu, não de suposição */
                var vazio = !doc.querySelector('.cart-item');
                gaveta.classList.toggle('is-empty', vazio);
                var lista = gaveta.querySelector('cart-drawer-items');
                if (lista) lista.classList.toggle('is-empty', vazio);
              })
              .catch(function () {});
          }

          /* Rede de segurança: se depois de aberta a gaveta tiver linha de item e ainda
             estiver `is-empty` (medido ao vivo em 11/09: host "drawer is-empty animate
             active", 2 .cart-item, cart-drawer-items display:none), corrige — não importa
             quem recolocou a classe. */
          function garantirNaoVazia() {
            try {
              if (gaveta.querySelector('.cart-item')) {
                gaveta.classList.remove('is-empty');
                var lista = gaveta.querySelector('cart-drawer-items');
                if (lista) lista.classList.remove('is-empty');
              }
            } catch (e) {}
          }

          function abrirGaveta(json) {
            var abrir = function () {
              if (typeof gaveta.open === 'function') gaveta.open();
              else gaveta.classList.add('active');
              document.body.classList.add('overflow-hidden');
              garantirNaoVazia();
              setTimeout(garantirNaoVazia, 400);
              setTimeout(garantirNaoVazia, 1500);
            };
            /* Só delega ao tema quando a resposta traz a seção — aí o renderContents tem
               o que desenhar. E limpa o is-empty do host antes, como o product-form.js. */
            var temSecao = json && json.sections && json.sections['cart-drawer'];
            if (temSecao && typeof gaveta.renderContents === 'function') {
              try {
                gaveta.classList.remove('is-empty');
                gaveta.renderContents(json); /* abre sozinho */
                setTimeout(garantirNaoVazia, 400);
                setTimeout(garantirNaoVazia, 1500);
                return;
              } catch (e) { /* o tema falhou: caminho manual abaixo */ }
            }
            recarregarGaveta().then(abrir);
          }

          /* ---------------------------------------------------------------
             Combo. A oferta da loja deixou de ser um produto "kit": o add posta
             as camisetas AVULSAS e uma Shopify Function desconta o slot e zera o
             brinde. Quem converte é `combo-cart-sync`, que já roda em toda a loja
             e reescreve `/cart/add` quando vê `_kit_variant_id` nas linhas — ele
             troca por `_combo_id` e anexa a carteira sozinho.

             Por isso NÃO montamos aqui o brinde nem o id do combo: só traduzimos
             a combinação escolhida nas variantes avulsas certas. Se eles mudarem
             o desconto ou o brinde, a página acompanha sem tocar em nada.

             Se a tradução falhar por qualquer motivo, `body` continua sendo o
             FormData de antes: a compra nunca fica bloqueada por causa disto. */
          var corpo = dados, cabecalhos = { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };
          var itensCombo = montarCombo(dados.get('quantity'));
          if (itensCombo) {
            window.__kitExplodeLastQty = itensCombo.kits;   /* o script lê daqui quantos brindes anexar */
            corpo = JSON.stringify({
              items: itensCombo.itens.map(function (it) {
                return { id: it.id, quantity: it.quantity, properties: it.properties };
              }),
              sections: dados.get('sections') ? String(dados.get('sections')).split(',') : undefined,
              sections_url: window.location.pathname
            });
            cabecalhos = { 'Content-Type': 'application/json', 'Accept': 'application/javascript' };
          }

          fetch(raiz_url + 'cart/add.js', {
            method: 'POST',
            headers: cabecalhos,
            body: corpo
          })
            .then(function (r) { return r.json(); })
            .then(function (json) {
              if (json.status) {                     /* erro da Shopify */
                if (ctaTxt) ctaTxt.textContent = json.description || 'Não foi possível adicionar';
                return;
              }
              abrirGaveta(json);
            })
            .catch(function () {
              /* rede caiu. NÃO navegar: o item pode já ter entrado e o cliente
                 perderia a página. Só devolve o botão e avisa. */
              if (ctaTxt) ctaTxt.textContent = 'Tente de novo';
            })
            .then(function () {
              if (cta) { cta.disabled = false; cta.removeAttribute('aria-busy'); }
              if (ctaTxt) ctaTxt.textContent = textoCta;
            });
        });
      }

      /* O link ao lado do rótulo. Ele deixou de ser a porta do provador: essa porta
         é a faixa abaixo do seletor, que é onde o olho para. Aqui fica a tabela —
         consulta, não decisão. O destino é setting, para trocar sem mexer no código. */
      var linkTam = raiz.querySelector('[data-mp-sizebay]');
      if (linkTam) {
        var acaoLink = linkTam.getAttribute('data-mp-sizebay') || 'tabela';
        linkTam.addEventListener('click', function () {
          if (acaoLink === 'provador') abrirProvador();
          else abrirTabela();
        });
      }

      /* Prazo de entrega: duas datas a partir de HOJE, no fuso de quem está lendo.
         `{de}` e `{ate}` são trocados no texto vindo do personalizador. */
      var elEntrega = raiz.querySelector('[data-mp-entrega]');
      if (elEntrega) {
        (function () {
          /* Dia ÚTIL, não dia corrido — é assim que a página atual deles conta, e as duas
             precisam prometer a mesma data para o A/B comparar página, não oferta.
             `setHours(12)` antes de somar: no horário de verão a meia-noite escorrega
             para o dia anterior e a data sai um dia menor. */
          var uteis = elEntrega.getAttribute('data-uteis') === '1';
          var dias = function (n) {
            var d = new Date(); d.setHours(12, 0, 0, 0);
            if (uteis) {
              var somados = 0;
              while (n > somados) {
                d.setDate(d.getDate() + 1);
                var s = d.getDay();
                if (s !== 0 && s !== 6) somados++;
              }
            } else {
              d.setDate(d.getDate() + n);
            }
            return d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' });
          };
          var de = dias(parseInt(elEntrega.getAttribute('data-de'), 10) || 2);
          var ate = dias(parseInt(elEntrega.getAttribute('data-ate'), 10) || 6);
          var alvo = elEntrega.querySelector('.sola-mp__entrega-1');
          if (alvo) {
            alvo.innerHTML = alvo.textContent
              .replace('{de}', '<b>' + de + '</b>')
              .replace('{ate}', '<b>' + ate + '</b>');
          }
          elEntrega.hidden = false;
        })();
      }

      /* galeria: miniatura troca a foto grande */
      var minis = raiz.querySelectorAll('[data-mp-mini]');
      var principal = raiz.querySelector('.sola-mp__principal img');
      var itens = raiz.querySelectorAll('.sola-mp__item img');
      for (var m = 0; minis.length > m; m++) {
        (function (btn, idx) {
          btn.addEventListener('click', function () {
            for (var k = 0; minis.length > k; k++) minis[k].removeAttribute('aria-current');
            btn.setAttribute('aria-current', 'true');
            var fonte = itens[idx] || btn.querySelector('img');
            if (principal && fonte) {
              principal.src = fonte.currentSrc || fonte.src;
              if (fonte.srcset) principal.srcset = fonte.srcset;
            }
          });
        })(minis[m], m);
      }

      /* pontinhos acompanham o arrasto da tira */
      var tira = raiz.querySelector('[data-mp-tira]');
      var pontos = raiz.querySelector('[data-mp-pontos]');
      if (tira && pontos && pontos.children.length) {
        tira.addEventListener('scroll', function () {
          var largura = tira.scrollWidth / pontos.children.length;
          var i = Math.round(tira.scrollLeft / largura);
          if (i > pontos.children.length - 1) i = pontos.children.length - 1;
          for (var k = 0; pontos.children.length > k; k++) {
            pontos.children[k].className = (k === i) ? 'on' : '';
          }
        }, { passive: true });
      }
    }

    /* O cabeçalho da loja é sticky. Sem isto a galeria grudada entra por baixo dele. */
    function ajustarTopo() {
      /* O cabeçalho da loja são DOIS elementos grudados (barra de aviso + header).
         Medir a altura de um só erra por ~35px — o que vale é a BASE do conjunto. */
      var altura = 0;
      var cands = document.querySelectorAll('header, .header-wrapper, .shopify-section-header, .announcement-bar, [class*="header"], [class*="announcement"]');
      for (var i = 0; cands.length > i; i++) {
        var c = getComputedStyle(cands[i]);
        if (c.position !== 'sticky' && c.position !== 'fixed') continue;
        var r = cands[i].getBoundingClientRect();
        if (r.height < 4 || r.height > 220) continue;
        if (r.top > 90) continue;
        if (r.bottom > altura) altura = r.bottom;
      }
      var lista = document.querySelectorAll('.sola-mp');
      for (var k = 0; lista.length > k; k++) {
        var folga = parseInt(lista[k].getAttribute('data-mp-folga'), 10) || 34;
        lista[k].style.setProperty('--mp-topo', (altura ? Math.round(altura + folga) : 96 + folga) + 'px');
      }
    }


    /* ---------------------------------------------------------------------
       Prazo. UM relógio só, compartilhado pelo popup e pela barra de aviso.

       O prazo mora no localStorage, não na memória da página: refresh não
       devolve 15:00. O popup que a loja usa hoje reseta a cada carga — é
       exatamente isso que entrega que o número é enfeite. Aqui, se a pessoa
       voltar em 3 minutos, o relógio marca 12.

       A barra de aviso é do header group, compartilhada com a loja inteira.
       Não se edita aquele arquivo: a gente toma a barra por JS, e este JS só
       existe onde esta seção está. Fora desta página nada muda. Ao zerar, o
       conteúdo original volta — inclusive o frete grátis.
       --------------------------------------------------------------------- */
    function criarPrazo() {
      var raiz = document.querySelector('.sola-mp[data-prazo-min]');
      if (!raiz) return null;
      var min = parseInt(raiz.getAttribute('data-prazo-min'), 10) || 0;
      if (0 >= min) return null;

      var chave = raiz.getAttribute('data-prazo-chave') || 'sola-prazo';
      var teste = !!document.querySelector('[data-cap-teste]');
      var fim = 0;
      try { fim = parseInt(localStorage.getItem(chave), 10) || 0; } catch (e) {}
      /* O modo de teste faz o POPUP reaparecer a cada refresh — mas não mexe no relógio.
         Antes zerava junto, e o efeito era o refresh devolver 15:00: exatamente o defeito
         do popup da loja que a gente estava corrigindo. Só reinicia se já venceu. */
      if (!fim || (teste && 0 >= fim - Date.now()) || fim - Date.now() > min * 60000) {
        fim = Date.now() + min * 60000;
        try { localStorage.setItem(chave, String(fim)); } catch (e) {}
      }

      var reinicia = raiz.getAttribute('data-prazo-reinicia') === '1';
      var ouvintes = [], zerou = false;
      function resta() { return Math.max(0, fim - Date.now()); }
      function dois(n) { return (10 > n ? '0' : '') + n; }
      function pintar() {
        var s = Math.floor(resta() / 1000);
        var mm = dois(Math.floor(s / 60)), ss = dois(s % 60);
        var a = document.querySelectorAll('[data-prazo-mm]'), b = document.querySelectorAll('[data-prazo-ss]');
        for (var i = 0; a.length > i; i++) a[i].textContent = mm;
        for (var j = 0; b.length > j; j++) b[j].textContent = ss;
        if (!zerou && 0 >= resta()) {
          zerou = true;
          for (var k = 0; ouvintes.length > k; k++) { try { ouvintes[k](); } catch (e) {} }
          /* Reinicia sozinho. Sem isto o relógio morre em 00:00 e fica assim até alguém
             recarregar — e um contador parado em zero desmente a própria oferta, que é o
             defeito que a gente estava corrigindo no popup da loja.
             A ordem importa: os ouvintes rodam ANTES (o 'retravar' apaga a chave do
             navegador), e só então o novo prazo é gravado por cima. */
          if (reinicia) {
            fim = Date.now() + min * 60000;
            try { localStorage.setItem(chave, String(fim)); } catch (e) {}
            zerou = false;
          }
        }
      }
      pintar();
      setInterval(pintar, 500);
      return {
        resta: resta,
        pintar: pintar,
        aoZerar: function (fn) { if (zerou) fn(); else ouvintes.push(fn); }
      };
    }
    /* Criado na carga, como sempre foi. Se o script rodar ANTES do HTML da secao
       existir, `criarPrazo` devolve null aqui — e o `iniciar()`, que so roda com o
       DOM pronto, tenta de novo. Sem isso, um unico null no momento errado matava o
       relogio da pagina inteira em silencio: o cartao ficava em "--:--", a barra do
       topo saia na primeira linha de `assumirBarra` e o popup de saida escondia o
       contador. O `prazo_min` sempre esteve certo (15) — quebrava era a ordem. */
    var Prazo = criarPrazo();

    /* Barra de aviso. O relógio não SUBSTITUI o conteúdo: ele entra por cima, varrendo
       da esquerda para a direita, e o "FRETE GRÁTIS ACIMA DE R$ 500" fica visível à
       frente da varredura até ser coberto.

       Feito com `clip-path: inset(0 100% 0 0)` animado até `inset(0)`. É a única forma
       que revela sem mover nada: largura animada empurraria o texto, e `transform`
       arrastaria a capa inteira em vez de descobri-la.

       Capa sobreposta em vez de troca de innerHTML também resolve a volta: ao zerar,
       basta varrer de volta e remover — o conteúdo original nunca foi tocado.

       Tudo com !important: o esquema de cores do tema declara fundo e cor com
       !important, e inline puro perde — o sintoma é a barra continuar cinza. */
    function assumirBarra(animar) {
      if (!Prazo || 0 >= Prazo.resta()) return;
      var raiz = document.querySelector('.sola-mp[data-prazo-barra]');
      if (!raiz) return;
      var barra = document.querySelector('.announcement-bar');
      if (!barra) return;
      var util = barra.closest ? barra.closest('.utility-bar') : null;
      if (!util || util.getAttribute('data-sola-tomada')) return;
      util.setAttribute('data-sola-tomada', '1');
      try { localStorage.setItem(raiz.getAttribute('data-prazo-chave') + '-barra', '1'); } catch (e) {}

      var rotulo = raiz.getAttribute('data-prazo-rotulo') || 'OFERTA EXCLUSIVA';
      var marca = getComputedStyle(raiz).getPropertyValue('--mp-marca') || '#F4762F';
      var dur = raiz.getAttribute('data-prazo-varrida') || '850';

      if (getComputedStyle(util).position === 'static') util.style.setProperty('position', 'relative');

      var capa = document.createElement('div');
      capa.setAttribute('data-sola-capa', '1');
      capa.style.cssText = 'position:absolute;inset:0;z-index:3;display:flex;align-items:center;'
        + 'justify-content:center;background:#141413;overflow:hidden;'
        + '-webkit-clip-path:inset(0 100% 0 0);clip-path:inset(0 100% 0 0);'
        /* De volta à curva original: acelera no começo e assenta no fim. Testamos
           `linear` e uma curva de entrada; esta foi a que ficou. */
        + 'transition:clip-path ' + dur + 'ms cubic-bezier(.62,.02,.34,1),'
        + '-webkit-clip-path ' + dur + 'ms cubic-bezier(.62,.02,.34,1)';
      capa.innerHTML =
        '<p style="margin:0;display:flex;align-items:center;justify-content:center;gap:9px;'
        + 'font-size:12px;letter-spacing:.1em;text-transform:uppercase;font-weight:700;'
        + 'color:#fff !important;line-height:1;white-space:nowrap">'
        + '<span style="color:#fff !important">' + rotulo + '</span>'
        + '<span style="color:#fff !important;opacity:.35">&middot;</span>'
        + '<span style="color:' + marca + ' !important;font-variant-numeric:tabular-nums;'
        + 'font-feature-settings:&quot;tnum&quot; 1;letter-spacing:.04em">'
        + '<b data-prazo-mm>--</b>:<b data-prazo-ss>--</b></span>'
        + '</p>';
      util.appendChild(capa);
      Prazo.pintar();

      if (animar === false) {
        capa.style.transition = 'none';
        capa.style.webkitClipPath = capa.style.clipPath = 'inset(0)';
      } else {
        /* dois quadros: o navegador precisa pintar o estado fechado antes de animar */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            capa.style.webkitClipPath = capa.style.clipPath = 'inset(0)';
          });
        });
      }

      Prazo.aoZerar(function () {
        capa.style.webkitClipPath = capa.style.clipPath = 'inset(0 0 0 100%)';   /* sai pela direita */
        util.removeAttribute('data-sola-tomada');
        try { localStorage.removeItem(raiz.getAttribute('data-prazo-chave') + '-barra'); } catch (e) {}
        setTimeout(function () { if (capa.parentElement) capa.parentElement.removeChild(capa); }, parseInt(dur, 10) + 60);
      });
    }

    /* Captura de e-mail. Regras, em ordem de importância:
       1) nunca aparece antes de a pessoa ver a oferta;
       2) nunca trava a rolagem;
       3) some para sempre depois de fechada ou enviada;
       4) não aparece para quem já colocou no carrinho — a essa altura já ganhamos. */
    function iniciarCaptura() {
      var cap = document.querySelector('[data-cap]');
      if (!cap || cap.getAttribute('data-cap-pronto')) { assumirBarra(); return; }
      cap.setAttribute('data-cap-pronto', '1');

      /* ══ MODO "POPUP DO CLIENTE" ══
         Enquanto o fluxo do WhatsApp não estiver resolvido do nosso lado, quem capta é o
         formulário do Klaviyo deles — que já funciona inteiro. O nosso fica no DOM,
         escondido, e nada dele roda. A única coisa nossa que continua: quando o popup
         deles FECHA, a barra do topo assume com o relógio, que é o gesto que a gente
         desenhou para esse momento. */
      if (cap.getAttribute('data-cap-deles') === '1') {
        var idDeles = cap.getAttribute('data-cap-kl-form');
        if (!idDeles) { assumirBarra(); return; }
        try { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', idDeles]); } catch (e) {}
        var viuDeles = false, encerrado = false;
        function fechouDeles() {
          if (encerrado) return;
          encerrado = true;
          try { obsDeles.disconnect(); } catch (e) {}
          document.documentElement.style.overflow = '';   /* o popup deles trava a rolagem */
          assumirBarra(true);
        }
        /* "sumiu do DOM" é o sinal de fechamento: o Klaviyo remove a camada inteira.
           Também vale se ela continuar no DOM mas invisível. */
        var obsDeles = new MutationObserver(function () {
          var fk = document.querySelector('form.klaviyo-form');
          if (fk) { viuDeles = true; return; }
          if (viuDeles) fechouDeles();
        });
        obsDeles.observe(document.body, { childList: true, subtree: true });
        var vigia = setInterval(function () {
          var fk = document.querySelector('form.klaviyo-form');
          if (fk) { viuDeles = true; if (fk.offsetParent === null) fechouDeles(); }
          else if (viuDeles) fechouDeles();
          if (encerrado) clearInterval(vigia);
        }, 600);
        /* se o formulário deles nunca aparecer, a barra assume sozinha e a página não
           fica devendo o relógio */
        setTimeout(function () { if (!viuDeles) { clearInterval(vigia); fechouDeles(); } }, 25000);
        return;
      }

      var chave = cap.getAttribute('data-cap-chave') || 'sola-cap';
      var teste = cap.getAttribute('data-cap-teste') === '1';   /* ignora tudo e mostra sempre */
      var raizPrazo = document.querySelector('.sola-mp[data-prazo-min]');
      var liberado = false;                                     /* já mandou o e-mail */
      function jaFoi() { if (teste) return false; try { return localStorage.getItem(chave) === '1'; } catch (e) { return false; } }
      function marcar() { if (teste) return; try { localStorage.setItem(chave, '1'); } catch (e) {} }

      /* volta do envio do formulário nativo da Shopify */
      if (/customer_posted=true/.test(window.location.search)) {
        var ok = cap.querySelector('[data-cap-ok]'), fm = cap.querySelector('[data-cap-form]');
        if (ok && fm) { fm.hidden = true; ok.hidden = false; }
        cap.removeAttribute('hidden');
        cap.setAttribute('data-visivel', '1');
        marcar();
        setTimeout(function () { cap.removeAttribute('data-visivel'); assumirBarra(); }, 6000);
        return;
      }
      if (jaFoi()) { assumirBarra(); return; }

      /* `|| 35` engolia o ZERO: quem configurava "aparecer na entrada" recebia
         silenciosamente 35% de rolagem e 20 segundos de espera, e o popup nunca vinha.
         Zero é uma configuração legítima, não ausência de configuração. */
      var precisaScroll = parseInt(cap.getAttribute('data-cap-scroll'), 10);
      if (isNaN(precisaScroll)) precisaScroll = 35;
      var espera = parseInt(cap.getAttribute('data-cap-espera'), 10);
      if (isNaN(espera)) espera = 20;
      espera = espera * 1000;
      if (teste) { precisaScroll = 0; espera = 0; }
      var desde = Date.now();
      var mostrada = false;

      function temNoCarrinho() {
        var b = document.querySelector('.cart-count-bubble, [class*="cart-count"]');
        return b && /[1-9]/.test(b.textContent || '');
      }
      function avaliar() {
        if (mostrada || jaFoi()) return;
        if (!teste && temNoCarrinho()) return;
        var alt = document.documentElement.scrollHeight - window.innerHeight;
        var pct = alt > 0 ? (window.pageYOffset / alt) * 100 : 0;
        if (pct >= precisaScroll && Date.now() - desde >= espera) {
          /* Não abrir com buraco. O Klaviyo pode levar segundos para desenhar o campo
             — na máquina do cliente chegou a OITO. Aqui a gente espera ele ficar pronto
             antes de mostrar o cartão, com teto de 6s para nunca travar a captação por
             causa de um formulário que não veio. */
          if (embedId) {
            var jaTem = cap.querySelector('.klaviyo-form-' + embedId + ' form');
            if (!jaTem) {
              if (!avaliar._esperaEmbed) avaliar._esperaEmbed = Date.now();
              /* 10s: o cliente relatou 8 segundos numa máquina com cache frio, e um teto
                 menor faria o popup abrir justamente sem o campo — encurtando o buraco em
                 vez de eliminá-lo. */
              if (10000 > Date.now() - avaliar._esperaEmbed) return;
              /* Esgotado o prazo, o formulário dele não vem. Em vez de abrir um cartão
                 com um vazio no meio, a gente usa o NOSSO formulário, que está aqui no
                 DOM desde sempre. A captação acontece de todo jeito. */
              var meu = cap.querySelector('[data-cap-form]');
              var caixaKl = cap.querySelector('.sola-cap__embed');
              if (meu && meu.hasAttribute('hidden')) {
                meu.removeAttribute('hidden');
                if (caixaKl) caixaKl.style.display = 'none';
                cap.setAttribute('data-cap-reserva', '1');
              }
            }
          }
          mostrada = true;
          cap.removeAttribute('hidden');
          /* dois quadros: o navegador precisa pintar o estado inicial antes da transição */
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { cap.setAttribute('data-visivel', '1'); travar(true); montarEmbed(); });
          });
        }
      }
      window.addEventListener('scroll', avaliar, { passive: true });
      setInterval(avaliar, 250);   /* barato, e é o que decide quando o cartão abre */

      var ehCentro = cap.className.indexOf('--centro') >= 0;
      function travar(v) {
        if (!ehCentro) return;
        document.documentElement.style.overflow = v ? 'hidden' : '';
      }
      function fechar() {
        if (!cap.hasAttribute('data-visivel')) return;
        /* Marca a hora do fechamento. O popup de SAÍDA lê isto e se cala por um tempo:
           quem acabou de deixar o e-mail e fechou a tela de obrigado estava sendo
           recebido, no mesmo segundo, por outro popup dizendo "não vá embora". */
        try { window.__solaCapFechouEm = Date.now(); } catch (e) {}
        cap.removeAttribute('data-visivel'); travar(false); marcar();
        setTimeout(function () { cap.hidden = true; }, 500);
        assumirBarra();                          /* o relógio continua na barra */
      }
      cap.addEventListener('click', function (e) { if (e.target === cap) fechar(); });  /* só o fundo */
      document.addEventListener('sola:fechar-sobreposicoes', fechar);
      var x = cap.querySelector('[data-cap-fechar]');
      if (x) x.addEventListener('click', fechar);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });
      /* Envio por fetch, não POST nativo. O formulário de cliente da Shopify recarrega
         a página e volta na âncora do próprio formulário — que fica no rodapé. Era isso
         que jogava a pessoa lá para baixo depois de deixar o e-mail: não era rolagem
         nossa, era navegação. Sem recarga, ela continua exatamente onde estava. */
      /* ══════════════════════════════════════════════════════════════════════════
         MODO "FORMULÁRIO": em vez de imitar o que o formulário do cliente manda, a
         gente USA o formulário dele — carregado escondido — e só digita nele.

         Por que isto é melhor que imitar: o formulário do Klaviyo faz dezenas de
         coisas que só aparecem quando faltam (evento de gatilho, opt-in do formulário,
         analytics, versão do formulário, consentimento com origem). Passei a noite
         descobrindo essas coisas uma a uma. Aqui não há o que descobrir: quem executa
         é o código deles, então o resultado é igual por construção.

         A pessoa continua vendo só o nosso popup.
         ══════════════════════════════════════════════════════════════════════════ */
      var modoForm = cap.getAttribute('data-cap-kl-modo') === 'formulario';
      var klForm = null;

      /* Esconder por seletor não funcionou: a camada do Klaviyo é uma pilha de divs com
         classes geradas, e a de cima interceptava os cliques do NOSSO popup. Então subo
         a partir do formulário até o elemento que é filho do <body> e escondo AQUELE,
         com estilo inline — sem depender de adivinhar seletor.
         Fora da tela, e não `display:none`: escondido de verdade, o Klaviyo entende que
         o formulário não está visível e recusa o envio. */
      function esconderKl() {
        var f = document.querySelector('form.klaviyo-form');
        if (!f) return;
        var raiz = f;
        while (raiz.parentElement && raiz.parentElement !== document.body) raiz = raiz.parentElement;
        if (raiz.getAttribute('data-sola-oculto')) return;
        raiz.setAttribute('data-sola-oculto', '1');
        raiz.style.cssText += ';position:fixed !important;left:-99999px !important;top:0 !important;' +
          'width:390px !important;height:700px !important;opacity:0.01 !important;' +
          'pointer-events:none !important;z-index:-1 !important;visibility:visible !important';
        /* o formulário deles trava a rolagem da página ao abrir; como ele está oculto,
           quem manda na rolagem continua sendo o nosso popup */
        document.documentElement.style.overflow = 'hidden';
      }

      function abrirKlOculto() {
        if (!modoForm) return;
        var id = cap.getAttribute('data-cap-kl-form');
        if (!id) return;
        esconderKl();
        try { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', id]); } catch (e) {}
        var obs = new MutationObserver(function () {
          var f = document.querySelector('form.klaviyo-form');
          if (f) { klForm = f; esconderKl(); }
        });
        obs.observe(document.body, { childList: true, subtree: true });
        /* o observador fica: a cada troca de etapa o Klaviyo remonta a camada, e ela
           voltaria a cobrir a tela */
        var reforco = setInterval(esconderKl, 400);
        setTimeout(function () { clearInterval(reforco); obs.disconnect(); }, 120000);
      }

      /* Campos do Klaviyo são React: mexer no `.value` direto não registra. Tem de ser
         pelo setter nativo do protótipo, seguido do evento de input. */
      function digitar(el, valor) {
        if (!el) return false;
        var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
        if (setter && setter.set) setter.set.call(el, valor); else el.value = valor;
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      function klCampo(tipos) {
        var f = klForm || document.querySelector('form.klaviyo-form');
        if (!f) return null;
        var ins = f.querySelectorAll('input');
        for (var i = 0; ins.length > i; i++) {
          if (tipos.indexOf(ins[i].type) > -1 && ins[i].offsetParent !== null) return ins[i];
        }
        for (var j = 0; ins.length > j; j++) if (tipos.indexOf(ins[j].type) > -1) return ins[j];
        return null;
      }

      function klEnviar(valor, tipos) {
        var f = klForm || document.querySelector('form.klaviyo-form');
        if (!f) return false;
        var campo = klCampo(tipos);
        if (!campo || !digitar(campo, valor)) return false;
        var bt = f.querySelector('button[type="submit"]') || f.querySelector('button');
        if (!bt) return false;
        /* `.click()` sozinho não bastou: o React do Klaviyo escuta a sequência de
           ponteiro. Mandamos a sequência inteira, e o `click` por último. */
        setTimeout(function () {
          try {
            ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (t) {
              var ev = t.indexOf('pointer') === 0
                ? new PointerEvent(t, { bubbles: true, cancelable: true, pointerId: 1, isPrimary: true })
                : new MouseEvent(t, { bubbles: true, cancelable: true, view: window });
              bt.dispatchEvent(ev);
            });
          } catch (e) { try { bt.click(); } catch (e2) {} }
        }, 200);
        return true;
      }

      /* ─── uma porta só para o Klaviyo ───
         A etapa 1 assina o e-mail; a etapa 2 volta aqui com o MESMO e-mail mais o
         telefone. Mandar o e-mail de novo é o que faz o Klaviyo reconhecer o perfil e
         só acrescentar o SMS, em vez de criar um segundo. */
      function klaviyo(email, fone) {
        var emp = cap.getAttribute('data-cap-kl-empresa');
        var lst = cap.getAttribute('data-cap-kl-lista');
        if (!emp || !lst || !email) return;
        var perfil = { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
        if (fone) {
          perfil.phone_number = fone;
          perfil.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
          /* Canal separado no Klaviyo. O formulário do cliente coleta só SMS, então por
             padrão a gente faz igual. Se o fluxo do WhatsApp exigir o consentimento
             próprio, é este interruptor — e aí o aviso legal precisa citar WhatsApp. */
          if (cap.getAttribute('data-cap-kl-whats') === '1') {
            perfil.subscriptions.whatsapp = { marketing: { consent: 'SUBSCRIBED' } };
          }
        }
        /* `custom_source` é o mesmo texto do formulário DELES de propósito. Se algum
           fluxo lá dentro filtrar por origem, um valor novo faria o fluxo simplesmente
           não disparar — e a gente descobriria pela ausência de e-mail, que é o pior
           jeito de descobrir. A atribuição da nossa página vai numa propriedade à
           parte, que não interfere em gatilho nenhum. */
        var fonte = cap.getAttribute('data-cap-kl-fonte');
        var origem = cap.getAttribute('data-cap-kl-origem');
        var formId = cap.getAttribute('data-cap-kl-form');
        var formVer = parseInt(cap.getAttribute('data-cap-kl-formver'), 10);

        /* ─── por que tem tanta coisa aqui ───
           Espelhei o que o formulário do cliente manda, capturado da rede. Assinar a
           lista NÃO dispara fluxo: o gatilho é o evento **"Form submitted by profile"**
           com o `form_id`, que vai junto no mesmo pedido. Sem ele, o contato entra na
           lista, recebe a confirmação de assinatura e mais nada — foi exatamente o que
           acontecia: e-mail chegava, WhatsApp não. */
        perfil.properties = {
          $consent_method: 'Klaviyo Form',
          $timezone_offset: -3
        };
        if (formId) {
          perfil.properties.$consent_form_id = formId;
          if (!isNaN(formVer)) perfil.properties.$consent_form_version = formVer;
        }
        if (origem) perfil.properties.origem_lp = origem;

        var pacote = {
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: perfil } },
              custom_source: fonte || undefined
            },
            relationships: { list: { data: { type: 'list', id: lst } } }
          }
        };
        if (formId) {
          var evProps = { form_id: formId, page: window.location.href,
                          device_type: (720 > window.innerWidth ? 'mobile' : 'desktop'),
                          $use_ip: true, $is_session_activity: true, $is_client_event: false };
          if (!isNaN(formVer)) evProps.form_version_id = formVer;
          var ev = {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Form submitted by profile', service: 'api' } } },
              profile: { data: { type: 'profile', attributes: { email: email, properties: { $email: email } } } },
              properties: evProps
            },
            relationships: { form: { data: { id: formId, type: 'form' } } }
          };
          if (!isNaN(formVer)) ev.relationships['form-version'] = { data: { id: formVer, type: 'form-version' } };
          pacote.data.attributes.events = { data: [ev] };
          pacote.data.relationships.form = { data: { type: 'form', id: formId } };
          if (!isNaN(formVer)) pacote.data.relationships['form-version'] = { data: { type: 'form-version', id: formVer } };
        }
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(emp), {
          method: 'POST',
          /* A VERSÃO IMPORTA. Em `2024-10-15` o Klaviyo recusa o corpo inteiro com
             "'subscriptions' is not a valid field for the resource 'profile'" — 400, e o
             lead se perde. Em `2025-01-15` o mesmo corpo passa. Conferido contra a conta
             deles usando uma lista inexistente, que valida o formato sem inscrever
             ninguém: a única reclamação que sobra é "List not found". */
          headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
          body: JSON.stringify(pacote)
        }).then(function (r) {
          cap.setAttribute(fone ? 'data-cap-kl-fone' : 'data-cap-kl-email', String(r.status));
          pintarDiag();
        }).catch(function () {
          cap.setAttribute(fone ? 'data-cap-kl-fone' : 'data-cap-kl-email', 'erro');
          pintarDiag();
        });
      }

      /* "(11) 98765-4321" → "+5511987654321". O Klaviyo só aceita E.164, e número
         malformado faz a chamada INTEIRA ser recusada — por isso, na dúvida, devolve
         vazio e o perfil segue só com o e-mail. */
      function paraE164(v, ddi) {
        var d = String(v || '').replace(/\D/g, '');
        var c = String(ddi || '55').replace(/\D/g, '') || '55';
        if (!d) return '';
        d = d.replace(/^0+/, '');                       /* "0 11 9..." é hábito de telefone fixo */
        if (d.indexOf(c) === 0 && d.length > c.length + 7) d = d.slice(c.length);   /* já veio com DDI */
        if (7 > d.length || d.length > 13) return '';   /* fora disso não é número: manda só o e-mail */
        return '+' + c + d;
      }

      /* Em tema NÃO PUBLICADO a Shopify não cria cliente por formulário — medido: o
         formulário de newsletter do próprio tema falha no preview e funciona no ar, com
         o mesmo código. Então aqui o "falhou" não quer dizer nada, e a tarja precisa
         avisar isso, senão vira alarme falso a cada teste. */
      var temaPreview = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');

      /* Escreve os três status na tela quando o modo de teste está ligado. */
      function pintarDiag() {
        var d = cap.querySelector('[data-cap-diag]');
        if (!d) return;
        function v(x) { return cap.getAttribute(x) || '…'; }
        var linha = 'Shopify ' + v('data-cap-shopify') +
                    ' · Klaviyo e-mail ' + v('data-cap-kl-email') +
                    ' · Klaviyo fone ' + v('data-cap-kl-fone');
        if (temaPreview) linha += '  ⚠ tema de preview: a Shopify não cria cliente aqui — só depois de publicado';
        d.textContent = linha;
      }

      /* No modo embed não há nada nosso para enviar: o formulário do Klaviyo cuida de
         tudo. A gente só garante que ele seja montado quando o popup abre — se a div
         nasceu escondida, o Klaviyo pode ter passado por ela sem renderizar. */
      /* ⚠️ O formulário só é montado QUANDO O POPUP ABRE.
         Montando na carga da página, ele nascia dentro de um popup ainda fechado: o
         container é `position:fixed; inset:0` com opacidade 0, então o formulário ficava
         INVISÍVEL (opacidade não se sobrescreve de dentro) e mesmo assim CLICÁVEL, porque
         o Klaviyo põe `pointer-events` nos próprios elementos. Uma camada de captura
         transparente por cima da página inteira. */
      var embedId = cap.getAttribute('data-cap-embed');
      /* ── acompanhar as etapas do formulário do Klaviyo ──
         Ele troca de tela por conta própria; a nossa moldura precisa acompanhar, senão
         a pessoa vê a copy do e-mail enquanto digita o telefone, e no fim recebe um
         "Thanks for subscribing" em inglês no meio do nosso popup. */
      function seguirEtapasEmbed() {
        var caixa = cap.querySelector('.sola-cap__embed');
        if (!caixa) return;
        var txt = cap.querySelector('[data-cap-cabeca] .sola-cap__texto');
        var textoEmail = txt ? txt.textContent : '';
        var textoTel = cap.getAttribute('data-cap-tel-texto') || '';
        function olhar() {
          /* Com o popup fechado o embed é `display:none`, então todo campo fica
             invisível e a checagem concluía "acabou" sozinha — marcando o fluxo como
             concluído sem ninguém ter preenchido nada. */
          if (!cap.hasAttribute('data-visivel')) { olhar._vazioDesde = 0; return; }
          /* Não depende do <form> existir: ao terminar, o Klaviyo às vezes REMOVE o
             formulário inteiro em vez de trocar o conteúdo dele. Exigir o form aqui
             fazia a checagem desistir justamente no momento que interessa. */
          var temTel = !!caixa.querySelector('input[type="tel"]');
          var temEmail = !!caixa.querySelector('input[type="email"]');
          /* Existe um `input[type=submit]` com display:none que NUNCA sai do DOM.
             Contá-lo como campo fazia a checagem achar que o formulário ainda estava
             lá, e a tela final nunca chegava. Só conta campo que a pessoa vê. */
          var temCampo = false;
          var listaC = caixa.querySelectorAll('input');
          for (var ci = 0; listaC.length > ci; ci++) {
            var tp = (listaC[ci].type || '').toLowerCase();
            if (tp === 'hidden' || tp === 'submit') continue;
            if (listaC[ci].offsetParent === null) continue;
            temCampo = true; break;
          }
          var dito = (caixa.textContent || '').trim();
          if (caixa.querySelector('form')) olhar._teveForm = true;
          /* O fim pode ser de dois jeitos: ele troca o formulário por uma mensagem, ou
             simplesmente ESVAZIA o contêiner. O segundo caso deixava o popup mostrando
             só o cabeçalho, sem nada embaixo. Guardar que já houve formulário é o que
             permite reconhecer os dois. */
          var temAlgo = olhar._teveForm || dito.length > 8;
          /* O Klaviyo também some com o formulário quando o envio FALHA, e a mensagem
             de erro fica no lugar. Sem esta guarda a gente mostrava "Pronto, obrigado!"
             para quem não conseguiu se inscrever — mentira na cara da pessoa. */
          var deuErro = /error|erro|try again|tente|inv[aá]lid|failed/i.test(dito);
          if (temTel && !temEmail && txt && textoTel) txt.textContent = textoTel;
          else if (temEmail && txt && textoEmail) txt.textContent = textoEmail;
          /* sem campo nenhum = ele chegou na tela de agradecimento dele.
             A nossa entra no lugar, com o logo e o botão que leva de volta à oferta. */
          /* ⚠️ Entre uma etapa e outra existe um instante SEM campo nenhum: o Klaviyo já
             tirou o e-mail e ainda não desenhou o telefone. Concluir ali pulava a etapa do
             WhatsApp direto para o agradecimento. Agora o vazio precisa DURAR: só depois
             de 2 segundos seguidos sem campo é que a gente aceita que acabou. */
          if (temTel) olhar._teveTel = true;
          if (temCampo) olhar._vazioDesde = 0;
          else if (!olhar._vazioDesde) olhar._vazioDesde = Date.now();
          /* A espera existe só para o vão ENTRE etapas. Depois que a etapa do telefone
             apareceu, ela é a última — some campo, acabou, e a tela de obrigado entra na
             hora. Esperar ali deixava o cartão dois segundos com só o relógio, que é
             exatamente o quadro que a gente não quer congelar. */
          var esperaMin = olhar._teveTel ? 0 : 2000;
          var vazioFirme = olhar._vazioDesde && (Date.now() - olhar._vazioDesde) >= esperaMin;

          if (!temCampo && vazioFirme && temAlgo && !deuErro && !cap.hasAttribute('data-cap-fim')) {
            cap.setAttribute('data-cap-fim', '1');
            var okF = cap.querySelector('[data-cap-ok]');
            var cabeca = cap.querySelector('[data-cap-cabeca]');
            if (okF) okF.hidden = false;
            if (cabeca) cabeca.hidden = true;
          }
        }
        new MutationObserver(olhar).observe(caixa, { childList: true, subtree: true });
        setInterval(olhar, 700);

        /* O jeito certo de saber que terminou: o próprio Klaviyo avisa. Adivinhar pelo
           DOM é frágil — ele remove o formulário tanto no sucesso quanto no erro. */
        document.addEventListener('klaviyoForms', function (ev) {
          var det = (ev && ev.detail) || {};
          if (det.formId && embedId && det.formId !== embedId) return;
          if (det.type !== 'submit') return;
          if (cap.hasAttribute('data-cap-fim')) return;
          cap.setAttribute('data-cap-fim', '1');
          var okF = cap.querySelector('[data-cap-ok]');
          var cabeca = cap.querySelector('[data-cap-cabeca]');
          if (okF) okF.hidden = false;
          if (cabeca) cabeca.hidden = true;
          marcar();
        });
      }

      function montarEmbed() {
        if (!embedId || montarEmbed._feito) return;
        montarEmbed._feito = true;
        seguirEtapasEmbed();
        /* Observador em vez de ronda: o formulário aparece de uma vez, e esperar até
           400ms para perceber era o que sobrava entre ele ficar pronto e o cartão abrir. */
        try {
          var caixaEsp = cap.querySelector('.klaviyo-form-' + embedId) || cap;
          var obsPronto = new MutationObserver(function () {
            var f = cap.querySelector('.klaviyo-form-' + embedId + ' form');
            if (!f) return;
            obsPronto.disconnect();
            try { avaliar(); } catch (e) {}
          });
          obsPronto.observe(caixaEsp, { childList: true, subtree: true });
        } catch (e) {}

        var tentou = 0;
        var acorda = setInterval(function () {
          tentou++;
          var alvo = cap.querySelector('.klaviyo-form-' + embedId);
          if (alvo && alvo.querySelector('form')) {
            clearInterval(acorda);
            /* Avisa na hora. Sem isto o popup esperava a próxima volta da verificação
               — o formulário ficava pronto em 1,2s e o cartão só abria em 2,5s. */
            try { avaliar(); } catch (e) {}
            return;
          }
          try { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', embedId]); } catch (e) {}
          if (tentou > 12) clearInterval(acorda);
        }, 400);   /* era 900ms: a ronda é barata e cada volta atrasa a abertura */
      }

      /* O formulário é montado JÁ NO CARREGAMENTO, não na abertura: o Klaviyo leva um
         instante para desenhar, e quem tem conexão mais lenta via o cartão abrir com um
         buraco onde deveria estar o campo. É seguro montar cedo porque o popup fechado
         é `display:none` e nada lá dentro recebe clique — as duas travas que a gente
         colocou depois do episódio do formulário invisível. */
      if (embedId) montarEmbed();

      abrirKlOculto();

      /* NOSSO formulário, não o do Klaviyo. Com o incorporado no cartão, um
         `querySelector('form')` solto pegava o DELE — e a gente saía pendurando os
         nossos ouvintes no formulário do cliente. */
      var f = cap.querySelector('[data-cap-form] form');
      if (f) {
        /* ─── por que NÃO é fetch ───
           A Shopify protege os formulários de `{% form %}` contra robô, e o token dessa
           proteção é injetado no submit DE VERDADE. Mandando por fetch o pedido chega
           sem token e a loja recusa — foi o que devolvia 400/403 e fazia o cliente nunca
           aparecer em Clientes. Aqui o envio é o nativo, só que mirando um iframe
           escondido: o navegador posta de verdade, a proteção roda, e a página não sai
           do lugar, então o popup continua nas três etapas. */
        var quadro = document.getElementById('sola-cap-envio');
        if (!quadro) {
          quadro = document.createElement('iframe');
          quadro.id = 'sola-cap-envio';
          quadro.name = 'sola-cap-envio';
          quadro.setAttribute('aria-hidden', 'true');
          quadro.setAttribute('tabindex', '-1');
          quadro.style.cssText = 'position:absolute;width:0;height:0;border:0;left:-9999px;top:-9999px';
          document.body.appendChild(quadro);
        }
        /* no elemento, não no submit: assim qualquer caminho de envio — inclusive um
           `form.submit()` disparado por script do tema — cai no iframe */
        f.target = 'sola-cap-envio';

        var enviando = false;
        function avancar() {
          var ok = cap.querySelector('[data-cap-ok]'), fm = cap.querySelector('[data-cap-form]');
          var passoTel = cap.querySelector('[data-cap-tel-passo]');
          if (fm && passoTel) { fm.hidden = true; passoTel.hidden = false; }
          else if (ok && fm) {
            fm.hidden = true; ok.hidden = false;
            var cb = cap.querySelector('[data-cap-cabeca]');
            if (cb) cb.hidden = true;
          }
          var envio = f.querySelector('button[type="submit"]');
          if (envio) envio.disabled = false;
          enviando = false;
        }

        /* O iframe é do mesmo domínio, então dá para ler o resultado: a Shopify volta
           com `customer_posted=true` quando criou o cliente. */
        function lerQuadro() {
          try {
            var u = (quadro.contentWindow && quadro.contentWindow.location.href) || '';
            if (!u || u === 'about:blank') return null;
            if (/customer_posted=true/.test(u)) return 'CRIADO';
            var corpo = (quadro.contentDocument && quadro.contentDocument.body && quadro.contentDocument.body.innerText) || '';
            if (/verified|captcha|robot|verifica/i.test(corpo)) return 'BLOQUEADO pela loja';
            if (/invalid parameters/i.test(corpo)) return 'RECUSADO (parâmetros)';
            return 'respondeu, sem confirmação';
          } catch (e) {
            /* Cross-origin: não dá para ler. Já vi este caso terminar com o cliente
               criado normalmente, então nem "enviado" nem "bloqueado" — a única
               afirmação honesta é que daqui não dá para saber. Quem responde é a tela
               de Clientes. */
            return 'resposta ilegível — confira em Clientes';
          }
        }
        quadro.addEventListener('load', function () {
          var r = lerQuadro();
          if (r) { cap.setAttribute('data-cap-shopify', r); pintarDiag(); }
          /* a resposta pode chegar em dois passos (POST → redirect) */
          /* POST → redirect chega em dois tempos; e em rede lenta pode demorar mais */
          [1500, 4000].forEach(function (t) {
            setTimeout(function () {
              var r2 = lerQuadro();
              if (r2) { cap.setAttribute('data-cap-shopify', r2); pintarDiag(); }
            }, t);
          });
        });

        function enviar(ev) {
          var campo = f.querySelector('input[type="email"]');
          if (campo && !campo.checkValidity()) {
            if (campo.reportValidity) campo.reportValidity();
            if (ev) ev.preventDefault();
            return;
          }
          if (enviando) { if (ev) ev.preventDefault(); return; }
          enviando = true;
          marcar(); liberado = true;

          var envio = f.querySelector('button[type="submit"]');
          if (envio) envio.disabled = true;

          /* o e-mail entra no Klaviyo já nesta etapa: se a pessoa abandonar a etapa do
             WhatsApp, o lead continua sendo nosso */
          if (campo) {
            var emailValor = campo.value;
            var pelaForma = modoForm && klEnviar(emailValor, ['email', 'text']);
            cap.setAttribute('data-cap-kl-email', pelaForma ? 'form' : '…');
            if (!pelaForma) klaviyo(emailValor, '');
            else {
              /* Rede de segurança: se o formulário deles não concluir em 7s — botão
                 continua desabilitado, que é o sinal de travado — a gente manda pela
                 API assim mesmo. Pior caso, o contato entra duas vezes e o Klaviyo
                 junta pelo e-mail. Melhor um perfil duplicado que um lead perdido. */
              setTimeout(function () {
                var ff = klForm || document.querySelector('form.klaviyo-form');
                var bt = ff && (ff.querySelector('button[type="submit"]') || ff.querySelector('button'));
                if (bt && bt.disabled) {
                  cap.setAttribute('data-cap-kl-email', 'form travou → API');
                  klaviyo(emailValor, '');
                }
              }, 7000);
            }
            pintarDiag();
          }

          /* IMPORTANTE: nada de preventDefault aqui. O submit precisa acontecer de
             verdade para a proteção da Shopify entrar. A tela troca em seguida. */
          setTimeout(avancar, 250);
        }

        f.addEventListener('submit', enviar);
      }

      /* ─── etapa 2: o WhatsApp ───
         Enviar e pular levam ao mesmo lugar. O botão nunca trava a pessoa nesta tela:
         ela já cumpriu a parte dela na etapa 1. */
      (function () {
        var passoTel = cap.querySelector('[data-cap-tel-passo]');
        if (!passoTel) return;
        var campoTel = cap.querySelector('[data-cap-tel]');
        var okTel = cap.querySelector('[data-cap-ok]');
        var indo = false;
        function seguir(mandar) {
          if (indo) return;
          indo = true;
          if (mandar && campoTel) {
            var email = f && f.querySelector('input[type="email"]');
            var ddi = cap.querySelector('[data-cap-ddi]');
            var fone = paraE164(campoTel.value, ddi ? ddi.value : '55');
            if (fone) {
              var pelaForma = modoForm && klEnviar(fone, ['tel', 'text']);
              cap.setAttribute('data-cap-kl-fone', pelaForma ? 'form' : '…');
              if (!pelaForma && email && email.value) klaviyo(email.value, fone);
              else if (pelaForma && email && email.value) {
                setTimeout(function () {
                  var ff = klForm || document.querySelector('form.klaviyo-form');
                  var bt = ff && (ff.querySelector('button[type="submit"]') || ff.querySelector('button'));
                  if (bt && bt.disabled) {
                    cap.setAttribute('data-cap-kl-fone', 'form travou → API');
                    klaviyo(email.value, fone);
                  }
                }, 7000);
              }
              pintarDiag();
            }
          }
          passoTel.hidden = true;
          var cabeca = cap.querySelector('[data-cap-cabeca]');
          if (cabeca) cabeca.hidden = true;        /* a tela final tem o logo e a mensagem dela */
          if (okTel) okTel.hidden = false;
        }
        var bt = cap.querySelector('[data-cap-tel-enviar]');
        if (bt) bt.addEventListener('click', function () { seguir(true); });
        if (campoTel) campoTel.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); seguir(true); }
        });
      })();

      /* "Aproveitar a oferta" só fecha: a pessoa já está na página da oferta. */
      var aproveitar = cap.querySelector('[data-cap-aproveitar]');
      if (aproveitar) aproveitar.addEventListener('click', fechar);

      /* Ao zerar: ou a página volta a pedir o e-mail (o relógio passa a ser verdade,
         porque a gente cumpre), ou não acontece nada além da barra voltar ao normal.
         Quem já deu o e-mail, ou já tem algo no carrinho, nunca é retravado. */
      if (Prazo && raizPrazo && raizPrazo.getAttribute('data-prazo-acao') === 'retravar') {
        Prazo.aoZerar(function () {
          if (liberado || temNoCarrinho()) return;
          try { localStorage.removeItem(chave); localStorage.removeItem(chave + '-barra'); } catch (e) {}
          cap.removeAttribute('hidden');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { cap.setAttribute('data-visivel', '1'); travar(true); montarEmbed(); });
          });
        });
      }
    }


    /* ---------------------------------------------------------------------
       Popup de recuperação. Dispara por PROXIMIDADE de um alvo — a seção de
       garantia, no fim da página — e não por tempo nem por saída de mouse.

       Por que assim: quem chega ao fim e não comprou já leu tudo. Não falta
       informação, falta motivo para decidir agora. E `mouseleave` não existe
       em toque, que é de onde vem a maior parte deste tráfego.

       IntersectionObserver com rootMargin positivo no topo faz o disparo
       acontecer ANTES de o alvo entrar na tela — "um pouquinho antes da
       garantia" é literalmente isso.

       Guarda de sessão, não de sempre: quem voltar amanhã vê de novo.
       --------------------------------------------------------------------- */
    function iniciarRecuperacao() {
      var rec = document.querySelector('[data-rec]');
      if (!rec || rec.getAttribute('data-rec-pronto')) return;
      rec.setAttribute('data-rec-pronto', '1');

      var teste = rec.getAttribute('data-rec-teste') === '1';
      var chave = rec.getAttribute('data-rec-chave') || 'sola-rec';
      /* localStorage, não sessionStorage: "só uma vez" é uma vez por pessoa, não uma
         vez por aba. Com sessão, voltar no dia seguinte mostrava de novo. */
      function jaViu() { if (teste) return false; try { return localStorage.getItem(chave) === '1'; } catch (e) { return false; } }
      function marcar() { if (teste) return; try { localStorage.setItem(chave, '1'); } catch (e) {} }
      if (jaViu()) return;

      var cap = document.querySelector('[data-cap]');
      function temNoCarrinho() {
        var b = document.querySelector('.cart-count-bubble, [class*="cart-count"]');
        return b && /[1-9]/.test(b.textContent || '');
      }

      var aberta = false, agendada = false;
      var espera = parseInt(rec.getAttribute('data-rec-espera'), 10);
      if (isNaN(espera)) espera = 1800;

      function abrir() {
        if (aberta || jaViu()) return;
        /* nunca por cima da captura de e-mail, e nunca para quem já resolveu */
        if (cap && cap.hasAttribute('data-visivel')) return;
        /* Nem logo depois dela: 5 segundos de trégua. O problema nunca foi o popup de
           saída existir para quem deixou o e-mail — era ele chegar NO MESMO SEGUNDO em
           que a pessoa fechou a tela de obrigado. Passados 5 segundos, o gesto de sair
           é um gesto novo, e ele volta a fazer sentido. */
        try {
          if (window.__solaCapFechouEm && 5000 > (Date.now() - window.__solaCapFechouEm)) return;
        } catch (e) {}
        if (!teste && rec.getAttribute('data-rec-pula-carrinho') === '1' && temNoCarrinho()) { marcar(); return; }
        aberta = true; marcar();

        /* o relógio só entra se ainda houver prazo: 00:00 desmente a mensagem */
        var caixa = rec.querySelector('[data-rec-prazo]');
        if (caixa) {
          if (Prazo && Prazo.resta() > 0) { caixa.hidden = false; Prazo.pintar(); }
          else caixa.hidden = true;
        }

        rec.removeAttribute('hidden');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            rec.setAttribute('data-visivel', '1');
            document.documentElement.style.overflow = 'hidden';
          });
        });
      }

      /* Aparecer no mesmo quadro em que a seção entra na tela dá susto: a pessoa ainda
         está lendo o que acabou de chegar. A espera é o tempo de ela pousar o olho. */
      function agendar() {
        if (agendada || aberta || jaViu()) return;
        agendada = true;
        setTimeout(abrir, espera);
      }
      function fechar() {
        if (!rec.hasAttribute('data-visivel')) return;
        rec.removeAttribute('data-visivel');
        document.documentElement.style.overflow = '';
        setTimeout(function () { rec.hidden = true; }, 500);
      }

      rec.addEventListener('click', function (e) { if (e.target === rec) fechar(); });
      document.addEventListener('sola:fechar-sobreposicoes', fechar);
      var x = rec.querySelector('[data-rec-fechar]');
      if (x) x.addEventListener('click', fechar);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });

      var botao = rec.querySelector('[data-rec-ir-btn]');
      if (botao) botao.addEventListener('click', function () {
        var alvo = document.querySelector(rec.getAttribute('data-rec-ir') || '#modulo');
        fechar();
        if (!alvo) return;
        /* espera o overflow do <html> voltar: rolar com a página travada não anda */
        setTimeout(function () {
          var topo = alvo.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mp-topo'), 10) || 96);
          window.scrollTo({ top: topo, behavior: 'smooth' });
        }, 60);
      });

      var modo = rec.getAttribute('data-rec-modo') || 'saida';
      var alvo = modo === 'saida' ? null : document.querySelector(rec.getAttribute('data-rec-alvo') || '');
      if (modo !== 'saida' && alvo && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (ent, obs) {
          if (!ent[0].isIntersecting) return;
          obs.disconnect(); agendar();
        }, { rootMargin: '0px 0px -20% 0px' }).observe(alvo);
      } else if (modo !== 'saida') {
        /* sem alvo na página, cai para profundidade de rolagem */
        var fundo = parseInt(rec.getAttribute('data-rec-fundo'), 10) || 85;
        var olhar = function () {
          var alt = document.documentElement.scrollHeight - window.innerHeight;
          if (alt > 0 && (window.pageYOffset / alt) * 100 >= fundo) { window.removeEventListener('scroll', olhar); agendar(); }
        };
        window.addEventListener('scroll', olhar, { passive: true });
      }

      /* Intenção de saída. O cursor sair pelo TOPO é o único sinal honesto: sair pelos
         lados é trocar de aba na barra lateral, pelo rodapé nem é sair. `relatedTarget`
         nulo confirma que o ponteiro deixou o documento, e não entrou num iframe.
         Sem equivalente em toque — o gatilho de rolagem cobre o mobile. */
      if (rec.getAttribute('data-rec-saida') === '1') {
        document.addEventListener('mouseout', function (e) {
          if (e.relatedTarget || e.clientY > 8) return;
          abrir();                        /* aqui não espera: a pessoa já está de saída */
        });
      }
    }

    /* ---------------------------------------------------------------------
       Provador virtual. Quem manda na loja inteira é o prescript.js da própria
       Sizebay, e ele foi escrito para PDP:

         getPermalink(): `https://minimalclub.com.br/${document.querySelector('product-info')?.getAttribute('data-product-id')}`
         getAnchor():    'fieldset:has(input[name*="Tamanho"])'

       Nesta página não existe <product-info> — quem fornecia era a seção
       featured-product, que desligamos. O permalink virava ".../undefined" e a
       implantação morria calada: os scripts carregam, o CSS carrega, e nenhum
       botão aparece. Também não existe <fieldset> em volta dos tamanhos.

       Em vez de fabricar um <product-info> falso (é custom element do Dawn, tem
       connectedCallback e efeito colateral), chamamos a API pública deles com o
       payload correto. Roda depois, então sobrescreve o que o prescript fez.

       O permalink é `dominio/<id numérico>`, NÃO a URL do produto: mandar
       `/products/<handle>` faz a Sizebay responder "Product not found." — o
       catálogo deles é indexado pelo id que o <product-info> expõe na PDP.
       --------------------------------------------------------------------- */
    /* Os dois gatilhos do provador (a faixa e o link do rótulo) precisam da mesma
       busca, e ela não é trivial: a Sizebay injeta `vfr__button` e `chart__button`
       com texto variável. Preferimos os que caíram DENTRO da nossa seção; sem eles,
       vale qualquer um da página (o featured-product abaixo também os recebe). */
    function acharBotao(tipo) {
      var raiz = document.querySelector('.sola-mp');
      var seletor = tipo === 'tabela'
        ? '[class*="chart__button"],[class*="vfr__button"]'
        : '[class*="vfr__button"],[class*="chart__button"]';
      var re = tipo === 'tabela' ? /tabela|chart|medida/i : /provador|vfr|fitting|prova/i;
      var listas = [];
      if (raiz) listas.push(raiz.querySelectorAll(seletor));
      listas.push(document.querySelectorAll(seletor));
      for (var l = 0; listas.length > l; l++) {
        var alvos = listas[l];
        for (var z = 0; alvos.length > z; z++) {
          if (re.test((alvos[z].textContent || '') + ' ' + alvos[z].className)) return alvos[z];
        }
        if (alvos.length && tipo !== 'tabela') return alvos[0];
      }
      return null;
    }
    function acharBotaoProvador() { return acharBotao('provador'); }
    function abrirProvador() { var b = acharBotao('provador'); if (b) b.click(); return !!b; }

    /* A tabela: primeiro a nossa, que é HTML puro e sobrevive ao webview do Instagram;
       o modal do app só entra se o acordeão não existir nesta página. */
    function abrirTabela() {
      var acc = document.querySelector('.sola-mp__acc--grade');
      if (acc) {
        acc.open = true;
        var topo = 0, mp = document.querySelector('.sola-mp');
        if (mp) topo = parseInt(getComputedStyle(mp).getPropertyValue('--mp-topo'), 10) || 0;
        window.scrollTo({ top: acc.getBoundingClientRect().top + window.pageYOffset - topo - 12, behavior: 'smooth' });
        return true;
      }
      var b = acharBotao('tabela');
      if (b) { b.click(); return true; }
      return false;
    }

    function iniciarProvador() {
      var raiz = document.querySelector('.sola-mp[data-sb-permalink]');
      if (!raiz || raiz.getAttribute('data-sb-pronto')) return;
      var permalink = raiz.getAttribute('data-sb-permalink');
      if (!permalink) return;
      raiz.setAttribute('data-sb-pronto', '1');

      var tentativas = 0, feito = false;
      function implantar() {
        if (feito) return;                          /* o evento e a chamada direta se cruzam */
        if (!window.Sizebay || typeof window.Sizebay.Implantation !== 'function') {
          if (++tentativas > 40) return;            /* 40 × 250ms = 10s e desiste */
          return setTimeout(implantar, 250);
        }
        feito = true;
        window.Sizebay.Implantation({
          permalink: permalink,
          tenantId: parseInt(raiz.getAttribute('data-sb-tenant'), 10) || 1269,
          buttons: { order: [{ name: 'vfr', text: null }, { name: 'chart', text: null }],
                     position: 'before', class: 'vfr__button--clean' },
          anchor: { web: '.sola-mp__sizebay-anchor', mobile: '.sola-mp__sizebay-anchor' },
          lang: 'br',
          recommendation: { default: 'Recomendamos o tamanho {size}',
                            simplified: 'Recomendamos o tamanho {size}' }
        });
      }
      window.addEventListener('sizebay:loaded', implantar);
      implantar();

      /* A recomendação. A Sizebay escreve "Recomendamos o tamanho XGG" solto no DOM,
         sem classe que dê para mirar com confiança — e o texto aparece só depois de a
         pessoa terminar o provador, que é dentro de um iframe. Então a gente observa a
         subárvore e reage ao TEXTO, não à marcação: se eles trocarem as classes
         amanhã, continua funcionando. */
      var bloco = raiz.querySelector('[data-mp-vfr]');
      if (!bloco) return;
      var elTam = bloco.querySelector('[data-mp-vfr-tam]');
      var btnUsar = bloco.querySelector('[data-mp-vfr-usar]');
      var btnAbrir = bloco.querySelector('[data-mp-vfr-abrir]');
      var RE = /recomendamos\s+o\s+tamanho\s+([\wÀ-ú]{1,5})/i;

      /* O convite só entra quando os botões do app existem de verdade. Eles são
         escondidos por CSS nesta seção (o gatilho visível é nosso), então o que se
         procura é a presença no DOM, não a visibilidade. A Sizebay demora — daí a
         espera curta e repetida, que desiste depois de 20s em vez de ficar rodando. */
      var esperas = 0;
      function procurarConvite() {
        if (bloco.getAttribute('data-estado') === 'resultado') return;
        if (acharBotaoProvador()) { bloco.hidden = false; return; }
        if (++esperas > 50) return;                 /* 50 × 400ms = 20s */
        setTimeout(procurarConvite, 400);
      }
      procurarConvite();

      if (btnAbrir) btnAbrir.addEventListener('click', function () { abrirProvador(); });

      function radiosTamanho() {
        return raiz.querySelectorAll('input[type="radio"][name*="Tamanho"]');
      }
      function conferirIgual(tam) {
        var rs = radiosTamanho();
        for (var i = 0; rs.length > i; i++) {
          if (rs[i].checked && rs[i].value.trim().toUpperCase() === tam) { bloco.setAttribute('data-igual', '1'); return; }
        }
        bloco.removeAttribute('data-igual');
      }
      function mostrar(tam) {
        elTam.textContent = tam;
        bloco.hidden = false;
        bloco.setAttribute('data-estado', 'resultado');
        bloco.setAttribute('data-tam', tam);
        conferirIgual(tam);
      }
      if (btnUsar) btnUsar.addEventListener('click', function () {
        var tam = bloco.getAttribute('data-tam'), rs = radiosTamanho();
        for (var i = 0; rs.length > i; i++) {
          if (rs[i].value.trim().toUpperCase() === tam) {
            rs[i].click();                       /* click, não checked: precisa disparar o change */
            conferirIgual(tam);
            return;
          }
        }
      });
      raiz.addEventListener('change', function () {
        var tam = bloco.getAttribute('data-tam');
        if (tam) conferirIgual(tam);
      });

      /* ATENÇÃO: este observador escreve DENTRO da árvore que ele observa. Sem
         desligar antes de escrever, cada escrita dispara uma nova varredura, que
         escreve de novo — laço infinito, aba travada, "a página não responde".
         Foi exatamente o que aconteceu ao fechar o provador. Duas travas:
         desligar o observador enquanto mexe, e não mexer se nada mudou. */
      var obsRec = null, ultimoTam = null;
      function ligarObs() {
        if (obsRec) obsRec.observe(raiz, { childList: true, subtree: true, characterData: true });
      }
      function varrer() {
        /* Procura o elemento MAIS INTERNO cujo texto casa. Exigir `children.length === 0`
           não funciona: eles escrevem "Recomendamos o tamanho <b>XGG</b>", então o
           elemento que tem a frase inteira sempre tem um filho. */
        var todos = raiz.querySelectorAll('p,div,span,b,strong,em,small'), interno = null;
        for (var i = 0; todos.length > i; i++) {
          var e = todos[i];
          if (e === bloco || bloco.contains(e) || e.contains(bloco)) continue;
          if (!RE.test(e.textContent || '')) continue;
          if (!interno || interno.contains(e)) interno = e;
        }
        if (!interno) return;
        var m = RE.exec(interno.textContent || '');
        if (!m) return;

        /* sobe enquanto o pai não acrescenta nada além da frase, para esconder a caixa
           inteira e não deixar um invólucro vazio ocupando altura */
        var caixa = interno;
        while (caixa.parentElement && caixa.parentElement !== raiz &&
               !caixa.parentElement.contains(bloco) &&
               caixa.parentElement.textContent.trim() === caixa.textContent.trim()) {
          caixa = caixa.parentElement;
        }
        var tam = m[1].toUpperCase();
        if (tam === ultimoTam && caixa.style.display === 'none') return;   /* nada novo */
        ultimoTam = tam;

        if (obsRec) obsRec.disconnect();          /* silencia antes de escrever */
        try {
          caixa.style.setProperty('display', 'none', 'important');
          mostrar(tam);
        } finally {
          ligarObs();                             /* e volta a ouvir, sem os registros da própria escrita */
        }
      }
      obsRec = new MutationObserver(varrer);
      varrer();
      ligarObs();
    }

    /* ---------------------------------------------------------------------
       Brinde coerente com o carrinho.

       O `combo-cart-sync` ANEXA o brinde a cada add, mas nada o remove quando a
       composição desmancha. Dois defeitos medidos no carrinho real:
         · tirar as camisetas deixava a carteira sozinha — e aí ela deixa de ser
           brinde e passa a CObRAR R$ 147,90, porque a Function só zera com a
           composição completa;
         · adicionar de novo somava outra carteira, e ficavam duas.

       A regra aqui é uma só: **uma carteira por composição fechada**. Zero peças,
       zero carteiras. Oito peças, duas. É recalculado a cada mudança do carrinho,
       então vale para qualquer caminho — o nosso botão, a lixeira da gaveta, o
       mais/menos, ou o carrinho vindo de outra aba.
       --------------------------------------------------------------------- */
    function sincronizarBrinde() {
      var raiz = document.querySelector('.sola-mp[data-mp-brinde]');
      if (!raiz) return Promise.resolve();
      if (sincronizarBrinde._rodando) return Promise.resolve();
      var idBrinde = String(raiz.getAttribute('data-mp-brinde') || '');
      var slot = String(raiz.getAttribute('data-mp-slot') || '').split(',').filter(Boolean);
      var porComposicao = parseInt(raiz.getAttribute('data-mp-combo-qtd'), 10) || 4;
      if (!idBrinde || !slot.length) return Promise.resolve();

      sincronizarBrinde._rodando = true;
      var raiz_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(raiz_url + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var pecas = 0, tem = 0, variante = null;
          (c.items || []).forEach(function (it) {
            var pid = String(it.product_id);
            if (pid === idBrinde) { tem += it.quantity; variante = it.variant_id; }
            else if (slot.indexOf(pid) >= 0) pecas += it.quantity;
          });
          var deveria = Math.floor(pecas / porComposicao);
          if (!variante || tem === deveria) return null;
          /* A linha do brinde some AGORA, antes da ida e volta ao servidor. Sem isto
             ela ficava dois ou três segundos na tela exibindo o preço cheio, como se a
             pessoa fosse pagar pela carteira — o pior quadro possível para congelar. */
          if (tem > deveria) {                 /* vai sair brinde: esconde já */
            var gavJa = document.querySelector('cart-drawer');
            if (gavJa) gavJa.setAttribute('data-sola-brinde-saindo', '1');
          }
          /* `update.js` por VARIANTE, não `change.js` por linha.
             O tema remove itens por índice de linha; quando a nossa correção
             mexia no carrinho ao mesmo tempo, os índices dele saíam do lugar e a
             remoção falhava com "O parâmetro line é inválido" — foi o erro que
             apareceu ao tirar a última camiseta. `updates` é por id de variante:
             não existe índice para desencontrar, e repetir a mesma chamada não
             muda o resultado. */
          var updates = {};
          updates[String(variante)] = deveria;
          /* Pedimos as seções junto e mandamos o tema redesenhar com o resultado.
             É o passo que faltava: a gaveta do tema opera por ÍNDICE de linha, e
             quando a carteira sai do carrinho a camiseta muda de índice. Sem o
             redesenho, o próximo clique no menos mandava o índice velho e a
             Shopify respondia 422 — "O parâmetro line é inválido". */
          return fetch(raiz_url + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              updates: updates,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (json) {
              var gav = document.querySelector('cart-drawer');
              try {
                if (gav && typeof gav.renderContents === 'function') gav.renderContents(json);
              } catch (e) { /* o tema falhou ao redesenhar: o carrinho já está certo */ }
              if (gav) gav.removeAttribute('data-sola-brinde-saindo');
              /* Carrinho zerado: o tema mostra o "seu carrinho está vazio" pela classe
                 `is-empty`, e o redesenho por seção não a devolve — era daí que vinha a
                 gaveta em branco. Repomos a classe e, se ainda assim ficar sem conteúdo,
                 buscamos a seção inteira, que é o que o tema faz ao carregar. */
              try {
                if (gav && json && json.item_count === 0) {
                  gav.classList.add('is-empty');
                  var vazio = gav.querySelector('.drawer__inner-empty');
                  if (!vazio) {
                    fetch(raiz_url + '?sections=cart-drawer')
                      .then(function (r) { return r.json(); })
                      .then(function (sec) {
                        var html = sec && sec['cart-drawer'];
                        if (!html) return;
                        var molde = document.createElement('div');
                        molde.innerHTML = html;
                        var nova = molde.querySelector('cart-drawer');
                        if (nova) { gav.innerHTML = nova.innerHTML; gav.classList.add('is-empty'); }
                      }).catch(function () {});
                  }
                } else if (gav) {
                  gav.classList.remove('is-empty');
                }
              } catch (e) {}
              /* Limpa o aviso de erro da gaveta DEPOIS de um ajuste nosso, porque
                 nesse ponto o carrinho acabou de ser conferido e está coerente.
                 ⚠️ Não cobre o caso de esvaziar o carrinho até zero pelo botão de
                 menos: ali o aviso é do próprio tema e aparece igual na loja no ar,
                 sem nada nosso — medido. Corrigir aquilo é mexer no tema. */
              try {
                var avisos = gav ? gav.querySelectorAll('.cart-item__error-text, [id*="CartDrawer-LineItemError"], [id*="Cart-LineItemError"]') : [];
                for (var i = 0; avisos.length > i; i++) avisos[i].textContent = '';
              } catch (e) {}
              return json;
            });
        })
        .catch(function () { return null; })
        .then(function (mudou) {
          sincronizarBrinde._rodando = false;
          return mudou;
        });
    }

    /* Marca a linha do brinde na gaveta para o CSS poder tratá-la como brinde, e
       não como mais um item. A gaveta é recriada pelo tema a cada mudança, então
       a marcação é reaplicada junto com a vigilância — e é idempotente. */
    function marcarBrindeNaGaveta() {
      var raiz = document.querySelector('.sola-mp[data-mp-brinde]');
      var gav = document.querySelector('cart-drawer');
      if (!raiz || !gav) return;
      var handle = raiz.getAttribute('data-mp-brinde-handle');
      if (!handle) return;
      var linhas = gav.querySelectorAll('.cart-item, .drawer__cart-item, tr[class*="cart-item"]');
      for (var i = 0; linhas.length > i; i++) {
        var a = linhas[i].querySelector('a[href*="/products/"]');
        var eh = a && a.getAttribute('href').indexOf('/products/' + handle) >= 0;
        if (eh) {
          linhas[i].setAttribute('data-sola-brinde', '1');
        } else linhas[i].removeAttribute('data-sola-brinde');
      }
    }

    /* Roda a cada mudança da gaveta. O observador é desligado enquanto a própria
       correção acontece, senão a escrita dispara nova varredura e vira laço. */
    function vigiarBrinde() {
      if (!document.querySelector('.sola-mp[data-mp-brinde]')) return;
      /* A gaveta NÃO é o único lugar onde se tira item: existe a página /cart, e lá
         nada disto rodava — a carteira ficava sozinha até um refresh. Era essa a
         lacuna. Agora os dois lugares são vigiados pelo mesmo código. */
      var alvos = [];
      var gv = document.querySelector('cart-drawer');
      if (gv) alvos.push(gv);
      var pag = document.querySelector('cart-items, #main-cart-items, .cart-items, form[action$="/cart"]');
      if (pag) alvos.push(pag);
      for (var v = 0; alvos.length > v; v++) vigiarUm(alvos[v]);
    }

    function vigiarUm(gav) {
      if (!gav || gav.getAttribute('data-sola-brinde-vigia')) return;
      gav.setAttribute('data-sola-brinde-vigia', '1');

      /* ─── esconder pela INTENÇÃO, não pela resposta ───
         Esperar o servidor confirmar deixava a carteira dois segundos sozinha na tela,
         exibindo o preço cheio como se a pessoa fosse pagar por ela. Agora, no instante
         em que alguém clica para remover ou diminuir uma camiseta, a linha do brinde já
         sai — a correção de verdade vem logo atrás e confirma. Se por algum motivo não
         vier, o atributo é removido no fim e a linha volta. */
      gav.addEventListener('click', function (e) {
        var alvo = e.target && e.target.closest &&
          e.target.closest('cart-remove-button, .cart-remove-button, a[href*="quantity=0"], button[name="minus"], .quantity__button');
        if (!alvo) return;
        var linha = alvo.closest('.cart-item');
        if (!linha) return;
        var raizB = document.querySelector('.sola-mp[data-mp-brinde]');
        var handle = raizB && raizB.getAttribute('data-mp-brinde-handle');
        /* a própria linha do brinde não conta: quem some é ele */
        if (handle && linha.querySelector('a[href*="/products/' + handle + '"]')) return;
        gav.setAttribute('data-sola-brinde-saindo', '1');
      }, true);
      var pendente = null;
      var obs = new MutationObserver(function () {
        if (sincronizarBrinde._rodando) return;
        clearTimeout(pendente);
        marcarBrindeNaGaveta();
        /* 700ms sem novas mutações. A gaveta se redesenha em etapas quando o tema
           remove um item, e agir no meio disso é o que criava a corrida. */
        pendente = setTimeout(function () {
          sincronizarBrinde().then(function (mudou) {
            if (mudou) document.dispatchEvent(new CustomEvent('sola:brinde-ajustado'));
          });
        }, 260);   /* era 700ms: com o brinde já escondido, esperar tanto só atrasa */
      });
      obs.observe(gav, { childList: true, subtree: true });
      /* Uma passada na chegada: quem entra em /cart com o carrinho já incoerente — por
         ter mexido em outra aba, por exemplo — não precisa mexer em nada para consertar. */
      setTimeout(function () {
        if (sincronizarBrinde._rodando) return;
        marcarBrindeNaGaveta();
        sincronizarBrinde();
      }, 900);
    }

    /* O PRIMEIRO add.js depois de uma publicação leva ~1,1s porque a Shopify precisa
       renderizar a seção do carrinho do zero; os seguintes levam ~25ms. Medido: com um
       GET `?sections=cart-drawer` disparado antes, o primeiro add cai para 27ms.
       Roda ocioso, não compete com o carregamento da página, e não muda nada na tela. */
    function aquecerGaveta() {
      if (!document.querySelector('cart-drawer')) return;
      var raiz_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var vai = function () { fetch(raiz_url + '?sections=cart-drawer').catch(function () {}); };
      if ('requestIdleCallback' in window) requestIdleCallback(vai, { timeout: 3000 });
      else setTimeout(vai, 1200);
    }

    /* O título do item vem como "Camiseta Minimal - Compre 3 e leve 4 + Carteira",
       uma string só. Separar exige JS; o resto da gaveta é CSS porque o Dawn recria
       tudo a cada mudança de item e CSS sobrevive a isso. Este pedaço é reaplicado
       por observador, e é idempotente: se já separou, sai fora. */
    /* Upsell: imagem em resolução decente e carrossel que dá a volta.
       A imagem vem pedida em 200×200 e é desenhada em 56 — em tela retina isso é o
       limite, e de longe aparece serrilhado. A URL da CDN da Shopify aceita a largura
       por parâmetro, então dá para pedir maior sem tocar no snippet do tema. */
    function arrumarUpsell() {
      if (!document.querySelector('.sola-mp[data-mp-gaveta-estilo]')) return;

      var imgs = document.querySelectorAll('cart-drawer .cart-upsell__image img');
      for (var i = 0; imgs.length > i; i++) {
        var im = imgs[i];
        if (im.getAttribute('data-sola-nitida')) continue;
        var src = im.getAttribute('src') || '';
        if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) continue;
        var novo = src.replace(/([?&])width=\d+/, '$1width=440').replace(/([&?])height=\d+/, '$1height=440');
        if (novo === src) novo = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=440';
        im.setAttribute('data-sola-nitida', '1');
        im.removeAttribute('srcset');
        im.setAttribute('src', novo);
      }

      /* A largura dos <select> do upsell saía daqui (medirTexto/larguraDoSelect/
         medirSelect, removidos). Hoje quem mede é o PRÓPRIO componente, em
         assets/global.js (sizeSelects), pra toda a loja e não só nesta página.
         Manter as duas era o problema: as duas escreviam `style.width` no mesmo
         <select>, a de lá escrevia também o `flex` do <label> que embrulha o campo, e
         as medidas discordavam por uns pixels — o campo ficava de um tamanho e a caixa
         que o segura de outro, e o cartão quebrava. */

      /* Largura dos cartões. Em vez de calcular no papel quanto o texto ocupa, a gente
         PERGUNTA À PÁGINA: aplica uma largura, olha se algum título quebrou, e se
         quebrou alarga um degrau. Régua de texto errava — a altura do <h3> é a única
         fonte de verdade sobre quebra (contar `getClientRects` não serve: elemento de
         bloco devolve um retângulo só, mesmo com duas linhas de texto).
         Uma largura para todos, teto de 88% para o próximo continuar espiando. */
      var lista = document.querySelector('cart-drawer slider-component > ul');
      if (lista && lista.children.length) {
        var disp = lista.clientWidth - 28;
        var minL = Math.round(disp * 0.68), maxL = Math.round(disp * 0.88);

        function aplicarLargura(px) {
          for (var k = 0; lista.children.length > k; k++) {
            var li = lista.children[k];
            li.style.setProperty('flex', '0 0 ' + px + 'px', 'important');
            li.style.setProperty('width', px + 'px', 'important');
            li.style.setProperty('min-width', px + 'px', 'important');
            li.style.setProperty('max-width', px + 'px', 'important');
          }
        }
        function algoQuebrou() {
          var ts = lista.querySelectorAll('.cart-upsell__title');
          for (var i = 0; ts.length > i; i++) {
            var lh = parseFloat(getComputedStyle(ts[i]).lineHeight) || 17;
            if (ts[i].getBoundingClientRect().height > lh * 1.4) return true;
          }
          return false;
        }

        var largura = minL;
        aplicarLargura(largura);
        var voltas = 0;
        while (algoQuebrou() && maxL > largura && 8 > voltas) {
          largura = Math.min(maxL, largura + 16);
          aplicarLargura(largura);
          voltas++;
        }
      }

      var ul = document.querySelector('cart-drawer slider-component > ul');
      var prox = document.querySelector('cart-drawer .slider-button--next');
      var ant = document.querySelector('cart-drawer .slider-button--prev');
      if (!ul || !prox || !ant) return;
      function soltar() { prox.removeAttribute('disabled'); ant.removeAttribute('disabled'); }
      soltar();
      if (ul.getAttribute('data-sola-laco')) return;
      ul.setAttribute('data-sola-laco', '1');

      /* ── Navegação do upsell ───────────────────────────────────────────────
         Um índice, um trilho, três destinos possíveis. O laço é feito movendo o
         cartão de uma ponta para a outra no DOM e compensando o índice no mesmo
         quadro, sem transição — o olho não vê o remendo e a próxima puxada
         continua para o mesmo lado. */
      var idxU = 0, giro = 0, arrastandoU = false;
      function nU() { return ul.children.length; }
      function passoLargura() {
        var pri = ul.children[0];
        if (!pri) return 0;
        /* lê o vão do CSS em vez de repetir o número aqui: mudar o gap no estilo
           não pode desalinhar o passo */
        var vao = parseFloat(getComputedStyle(ul).columnGap || getComputedStyle(ul).gap) || 0;
        return pri.getBoundingClientRect().width + vao;
      }
      function posicionar(anim, extra) {
        ul.style.transition = anim ? 'transform .42s cubic-bezier(.22,.61,.36,1)' : 'none';
        ul.style.transform = 'translate3d(' + (-idxU * passoLargura() + (extra || 0)) + 'px,0,0)';
      }
      function numeroAtual() { var n = nU() || 1; return ((giro % n) + n) % n + 1; }
      function pintarContador() {
        var el = document.querySelector('cart-drawer .slider-counter--current');
        if (el && el.textContent != numeroAtual()) el.textContent = numeroAtual();
      }
      var alvoConta = document.querySelector('cart-drawer .slider-counter--current');
      if (alvoConta && !alvoConta.getAttribute('data-sola-conta')) {
        alvoConta.setAttribute('data-sola-conta', '1');
        new MutationObserver(pintarContador).observe(alvoConta, { childList: true, characterData: true, subtree: true });
      }

      /* Rotação por `order`, NUNCA movendo nós no DOM.
         Mover um <custom-cart-upsell> de lugar dispara disconnected/connectedCallback:
         o componente se reinicializa e passa a ter ouvintes de clique duplicados — era
         isso que fazia o botão de adicionar disparar dois adds. `order` muda só a ordem
         VISUAL do flex — o elemento continua conectado e intacto. */
      var desloc = 0;
      function aplicarOrdem() {
        var n = nU();
        for (var i = 0; n > i; i++) {
          ul.children[i].style.order = ((i - desloc) % n + n) % n;
        }
      }
      var animando = false;
      function passoU(dir) {
        if (2 > nU() || animando) return;
        animando = true;
        var dur = 420;
        if (dir > 0) {
          idxU = 1; posicionar(true);
          setTimeout(function () {
            desloc = (desloc + 1) % nU();
            aplicarOrdem();
            idxU = 0; posicionar(false);
            animando = false;
          }, dur);
        } else {
          desloc = (desloc - 1 + nU()) % nU();
          aplicarOrdem();
          idxU = 1; posicionar(false); void ul.offsetWidth;
          idxU = 0; posicionar(true);
          setTimeout(function () { animando = false; }, dur);
        }
        giro += dir;
        pintarContador();
      }
      aplicarOrdem();
      prox.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); passoU(1); }, true);
      ant.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); passoU(-1); }, true);

      /* arrasto com o dedo, mesma regra da galeria: um cartão por gesto */
      var ux0 = 0, uy0 = 0, ut0 = 0, udx = 0, udecidiu = false;
      ul.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        ux0 = e.touches[0].clientX; uy0 = e.touches[0].clientY;
        ut0 = Date.now(); udx = 0; arrastandoU = false; udecidiu = false;
      }, { passive: true });
      ul.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        var ax = e.touches[0].clientX - ux0, ay = e.touches[0].clientY - uy0;
        if (!udecidiu) {
          if (6 > Math.abs(ax) && 6 > Math.abs(ay)) return;
          udecidiu = true; arrastandoU = Math.abs(ax) > Math.abs(ay);
        }
        if (!arrastandoU) return;
        e.preventDefault();
        udx = ax;
        posicionar(false, udx);
      }, { passive: false });
      ul.addEventListener('touchend', function () {
        if (!arrastandoU) return;
        var dir = 0 > udx ? 1 : -1;
        var vel = Math.abs(udx) / Math.max(1, Date.now() - ut0);
        var passou = Math.abs(udx) > passoLargura() * 0.22 || vel > 0.45;
        arrastandoU = false; udx = 0;
        if (passou) passoU(dir); else posicionar(true);
      }, { passive: true });

      posicionar(false);
      pintarContador();
    }

    /* Copy do resumo. Os rótulos vêm do snippet do tema (arquivo compartilhado), então
       a troca é feita aqui, no cliente, e só nesta página. "Total de descontos" é
       linguagem de nota fiscal; "Você economiza" é a mesma informação virada para quem
       está decidindo. O percentual sai da divisão dos dois valores que já estão na tela
       — nada inventado. */
    function arrumarResumo() {
      var raizG = document.querySelector('.sola-mp[data-mp-gaveta-estilo]');
      if (!raizG) return;
      var rod = document.querySelector('cart-drawer .cart-drawer-footer-discounts-content');
      if (!rod) return;

      function trocar(sel, novo) {
        var p = rod.querySelector(sel);
        if (!p || !novo) return null;
        var s = p.querySelector('span');
        if (s && s.textContent.trim() !== novo) s.textContent = novo;
        return p;
      }
      trocar('.cart-drawer__foot_subtotal_without_discounts', raizG.getAttribute('data-res-sub'));
      var pTot = trocar('.cart-drawer__foot_total_pix', raizG.getAttribute('data-res-total'));
      var pEco = trocar('.cart-drawer__foot_total_discounts', raizG.getAttribute('data-res-eco'));

      /* percentual da economia, calculado dos números já exibidos */
      if (pEco && !pEco.querySelector('.sola-pct')) {
        var pSub = rod.querySelector('.cart-drawer__foot_subtotal_without_discounts span:last-child');
        var vEco = pEco.querySelector('span:last-child');
        function num(el) {
          if (!el) return 0;
          return parseFloat((el.textContent || '').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
        }
        var a = Math.abs(num(pSub)), d = Math.abs(num(vEco));
        if (a > 0 && d > 0) {
          var pct = Math.round(d / a * 100);
          if (pct > 0 && 100 > pct) {
            var marca = document.createElement('span');
            marca.className = 'sola-pct';
            marca.textContent = ' · ' + pct + '%';
            vEco.appendChild(marca);
          }
        }
      }

      /* reasseguramento embaixo do botão */
      var ctas = document.querySelector('cart-drawer .cart__ctas');
      var texto = raizG.getAttribute('data-res-garantias');
      if (ctas && texto && !ctas.parentElement.querySelector('.sola-garantias')) {
        var linha = document.createElement('p');
        linha.className = 'sola-garantias';
        var partes = texto.split('|');
        var caminhao = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';
        /* o mesmo escudo da frase "Errou o tamanho? Troca grátis em 30 dias" da seção
           de caimento — dois lugares falando da mesma garantia usam o mesmo símbolo */
        var troca = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.4-3 8.3-7.5 9.5-4.5-1.2-7.5-5.1-7.5-9.5V6z"/><path d="M9 12l2.2 2.2L15.5 10"/></svg>';
        var html = '';
        for (var i = 0; partes.length > i; i++) {
          var txt = partes[i].trim();
          if (!txt) continue;
          /* o ícone segue o TEXTO, não a ordem: com um item só, escolher pelo índice
             mostrava o caminhão numa frase sobre troca */
          html += '<span>' + (/frete|entrega/i.test(txt) ? caminhao : troca) + '<b>' + txt + '</b></span>';
        }
        linha.innerHTML = html;
        ctas.parentElement.insertBefore(linha, ctas.nextSibling);
      }
    }

    /* Stories: troca os controles nativos pelos nossos e deixa o toque no vídeo
       dar play/pause, como a pessoa já espera de vídeo vertical. Só nesta página. */
    function arrumarStories() {
      /* sem Liquid aqui: o bloco {% javascript %} é servido como asset e não passa
         por Liquid — a chave sairia literal e o seletor quebraria. Não precisa de
         escopo: este arquivo só é carregado onde esta seção existe. */
      var pops = document.querySelectorAll('insta-stories-popup');
      for (var i = 0; pops.length > i; i++) {
        var pop = pops[i];
        if (pop.getAttribute('data-sola-pronto')) continue;
        var caixa = pop.querySelector('.blocks-videos__list-item--popup-video');
        var vid = caixa ? caixa.querySelector('video') : null;
        if (!vid) continue;
        pop.setAttribute('data-sola-pronto', '1');
        vid.removeAttribute('controls');
        vid.controls = false;
        vid.setAttribute('playsinline', '');

        var toque = document.createElement('div');
        toque.className = 'sola-st__toque';
        caixa.appendChild(toque);

        var ctrl = document.createElement('div');
        ctrl.className = 'sola-st__ctrl';
        var bPlay = document.createElement('button');
        bPlay.type = 'button'; bPlay.className = 'sola-st__btn';
        bPlay.setAttribute('aria-label', 'Pausar ou reproduzir');
        var bSom = document.createElement('button');
        bSom.type = 'button'; bSom.className = 'sola-st__btn';
        bSom.setAttribute('aria-label', 'Ligar ou desligar o som');
        ctrl.appendChild(bPlay); ctrl.appendChild(bSom);
        caixa.appendChild(ctrl);

        var iPlay = '<svg width="18" height="18" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
        var iPause = '<svg width="18" height="18" viewBox="0 0 24 24"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg>';
        var iSom = '<svg width="18" height="18" viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>';
        var iMudo = '<svg width="18" height="18" viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9.5l5 5M21 9.5l-5 5" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>';

        (function (v, bp, bs, t) {
          function pintar() {
            bp.innerHTML = v.paused ? iPlay : iPause;
            bs.innerHTML = v.muted ? iMudo : iSom;
          }
          function alternar() { if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause(); }
          bp.addEventListener('click', function (e) { e.stopPropagation(); alternar(); });
          t.addEventListener('click', alternar);
          bs.addEventListener('click', function (e) {
            e.stopPropagation();
            v.muted = !v.muted;
            /* som só existe depois de um gesto; garantir que esteja tocando */
            if (!v.muted && v.paused) { var pr2 = v.play(); if (pr2 && pr2.catch) pr2.catch(function () {}); }
            pintar();
          });
          v.addEventListener('play', pintar);
          v.addEventListener('pause', pintar);
          v.addEventListener('volumechange', pintar);
          pintar();
        })(vid, bPlay, bSom, toque);
      }
    }

    /* Direção do deslize. O tema troca o `display` dos popups sem avisar, então a
       gente marca a direção no clique e carimba o popup que ficou visível logo depois. */
    var direcaoStory = 'baixo';
    function ligarDeslizeStories() {
      if (document.documentElement.getAttribute('data-sola-st-nav')) return;
      var alguma = document.querySelector('.blocks-videos__list-item--popup-next');
      if (!alguma) return;
      document.documentElement.setAttribute('data-sola-st-nav', '1');

      function carimbar() {
        setTimeout(function () {
          var pops = document.querySelectorAll('insta-stories-popup');
          for (var i = 0; pops.length > i; i++) {
            var visivel = getComputedStyle(pops[i]).display !== 'none';
            if (!visivel) { pops[i].removeAttribute('data-sola-entra'); continue; }
            pops[i].removeAttribute('data-sola-entra');
            void pops[i].offsetWidth;                 /* reinicia a animação */
            pops[i].setAttribute('data-sola-entra', direcaoStory);
          }
        }, 20);
      }
      document.addEventListener('click', function (e) {
        var alvo = e.target.closest ? e.target.closest('.blocks-videos__list-item--popup-next, .blocks-videos__list-item--popup-prev') : null;
        if (!alvo) return;
        direcaoStory = alvo.className.indexOf('next') >= 0 ? 'baixo' : 'cima';
        carimbar();
      }, true);
    }

    /* ------------------------------------------------------------------------
       Navegação do story: arrastar para cima vai para o próximo, para baixo volta,
       e a loja atrás fica parada.

       O popup não rola nada por dentro, então o toque nele estava sendo entregue à
       página — a pessoa tentava trocar de vídeo e a loja andava atrás. Duas travas,
       porque uma só não basta: `touch-action:none` no CSS impede o navegador de
       começar a rolagem antes de o JS ver o gesto, e `overflow:hidden` no <html>
       segura o resto (roda do mouse, teclado, barra de rolagem).

       A abertura é observada por atributo, não por clique: quem abre e fecha o popup
       é o app, e ele mexe em `class`, `active` e `style` sem avisar ninguém.
       ------------------------------------------------------------------------ */
    function ligarGestosStories() {
      var pops = document.querySelectorAll('insta-stories-popup');
      if (!pops.length || document.documentElement.getAttribute('data-sola-st-gesto')) return;
      document.documentElement.setAttribute('data-sola-st-gesto', '1');

      function abertoAgora() {
        var ps = document.querySelectorAll('insta-stories-popup');
        for (var i = 0; ps.length > i; i++) {
          if (getComputedStyle(ps[i]).display !== 'none') return ps[i];
        }
        return null;
      }

      var travado = false;
      function conferirTrava() {
        var tem = !!abertoAgora();
        if (tem === travado) return;
        travado = tem;
        if (tem) document.documentElement.setAttribute('data-sola-st-aberto', '1');
        else document.documentElement.removeAttribute('data-sola-st-aberto');
      }
      var obs = new MutationObserver(conferirTrava);
      for (var i = 0; pops.length > i; i++) {
        obs.observe(pops[i], { attributes: true, attributeFilter: ['class', 'active', 'style'] });
      }
      conferirTrava();

      function trocar(pop, adiante) {
        var bt = pop.querySelector(adiante
          ? '.blocks-videos__list-item--popup-next'
          : '.blocks-videos__list-item--popup-prev');
        if (bt) bt.click();
      }

      /* toque */
      var y0 = null, pop = null, arrastou = false;
      document.addEventListener('touchstart', function (e) {
        pop = e.target.closest ? e.target.closest('insta-stories-popup') : null;
        if (!pop) return;
        y0 = e.touches[0].clientY;
        arrastou = false;
      }, { passive: true });

      document.addEventListener('touchmove', function (e) {
        if (!pop || y0 === null) return;
        if (Math.abs(e.touches[0].clientY - y0) > 6) {
          arrastou = true;
          if (e.cancelable) e.preventDefault();     /* a loja atrás não anda */
        }
      }, { passive: false });

      document.addEventListener('touchend', function (e) {
        if (!pop || y0 === null) { pop = null; return; }
        var dy = e.changedTouches[0].clientY - y0;
        y0 = null;
        var alvo = pop; pop = null;
        /* toque curto continua sendo play/pause; só o arrasto de verdade troca */
        if (!arrastou || Math.abs(dy) < 45) return;
        trocar(alvo, dy < 0);
      }, { passive: true });

      /* roda do mouse, para o desktop ter o mesmo gesto */
      var ultimaRoda = 0;
      document.addEventListener('wheel', function (e) {
        var p = e.target.closest ? e.target.closest('insta-stories-popup') : null;
        if (!p) return;
        if (e.cancelable) e.preventDefault();
        var agora = (e.timeStamp || 0);
        if (agora - ultimaRoda < 600) return;       /* um vídeo por gesto, não vinte */
        if (Math.abs(e.deltaY) < 12) return;
        ultimaRoda = agora;
        trocar(p, e.deltaY > 0);
      }, { passive: false });

      /* seta do teclado, de graça e boa para acessibilidade */
      document.addEventListener('keydown', function (e) {
        var p = abertoAgora();
        if (!p) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); trocar(p, true); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); trocar(p, false); }
      });
    }

    function arrumarTituloGaveta() {
      if (!document.querySelector('.sola-mp[data-mp-gaveta-estilo]')) return;
      var gav = document.querySelector('cart-drawer');
      var faixa = document.querySelector('#CartDrawer-Progress .progress-container');
      if (faixa && !faixa.getAttribute('data-sola-cheia')) {
        /* Só anima o traço enchendo quando o frete grátis JÁ foi alcançado: com a barra
           pela metade, animar até 100% mostraria uma conquista que não existe. */
        var cheio = faixa.querySelector('.progress-fill');
        var trilha = faixa.querySelector('.progress-bar');
        if (cheio && trilha &&
            cheio.getBoundingClientRect().width >= trilha.getBoundingClientRect().width - 3) {
          faixa.setAttribute('data-sola-cheia', '1');
        }
      }
      if (gav && !gav.getAttribute('data-sola-ja-correu') && faixa) {
        setTimeout(function () { gav.setAttribute('data-sola-ja-correu', '1'); }, 2700);
      }
      var nomes = document.querySelectorAll('cart-drawer .cart-item__name');
      for (var i = 0; nomes.length > i; i++) {
        var el = nomes[i];
        if (el.querySelector('.sola-linha-marca')) continue;
        var txt = (el.textContent || '').trim();
        var corte = txt.indexOf(' - ');
        if (0 >= corte) continue;
        var marca = txt.slice(0, corte).trim(), resto = txt.slice(corte + 3).trim();
        el.textContent = '';
        var m = document.createElement('span');
        m.className = 'sola-linha-marca'; m.textContent = marca;
        el.appendChild(m);
        el.appendChild(document.createTextNode(resto));
      }
    }
    (function () {
      var g = document.querySelector('cart-drawer');
      if (g && 'MutationObserver' in window) {
        new MutationObserver(function () { arrumarTituloGaveta(); arrumarUpsell(); arrumarResumo(); })
          .observe(g, { childList: true, subtree: true });
      }
    })();

    /* ── Rolagem única para todos os CTAs da página ────────────────────────────
       Cada seção tinha o seu `scrollTo`, e o botão do banner era âncora nativa
       (<a href="#modulo">), que salta seco. Aqui um só handler, em fase de captura,
       assume todos: mesma curva, mesma duração, mesmo ponto de parada.
       A parada leva em conta o cabeçalho grudado E um respiro, senão a última faixa
       da seção de cima aparece por baixo do header. */
    function rolarSuave(destinoY, duracao) {
      /* Animação própria, quadro a quadro. `scrollTo({behavior:'smooth'})` funciona no
         Chrome mas cai para salto seco no Safari do iPhone — que é onde este tráfego
         está. É o mesmo motivo pelo qual existem polyfills de smooth scroll; aqui a
         animação é curta o bastante para não valer uma biblioteca.

         Dois cuidados que a primeira versão não tinha e que custaram uma rodada:
         · o relógio começa AGORA (`performance.now()`), não no primeiro quadro. Se o
           primeiro quadro demorar, a curva já entra adiantada em vez de a página ficar
           parada esperando;
         · `scroll-behavior` do documento é desligado durante a animação, senão o
           navegador tenta animar cada passo nosso e o resultado é um arrasto grudento. */
      var inicio = window.pageYOffset;
      var dist = destinoY - inicio;
      if (2 > Math.abs(dist)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, destinoY); return;
      }
      var dur = duracao || 800;
      var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
      var raiz = document.documentElement;
      var antes = raiz.style.scrollBehavior;
      raiz.style.scrollBehavior = 'auto';

      function passo() {
        var agora = (window.performance && performance.now) ? performance.now() : Date.now();
        var p = Math.min(1, (agora - t0) / dur);
        /* easeOutQuart: arranca com corpo e encosta macio, sem freada visível */
        var e = 1 - Math.pow(1 - p, 4);
        window.scrollTo(0, Math.round(inicio + dist * e));
        if (1 > p) requestAnimationFrame(passo);
        else raiz.style.scrollBehavior = antes;
      }
      passo();                                  /* primeiro passo já neste quadro */
      requestAnimationFrame(passo);
    }

    function alvoDosCtas() {
      /* Ancorar na SEÇÃO, não na grade. Com a grade, sobravam 32px acima dela dentro da
         própria seção, e a última faixa do marquee aparecia por baixo do cabeçalho —
         era o traço preto que o cliente via. Parando na borda da seção, nada de cima
         entra na tela e o respiro até o título é o da própria seção. */
      var raizA = document.querySelector('.sola-mp[data-mp-secao]');
      if (raizA && raizA.closest) {
        var sec = raizA.closest('[id^="shopify-section"]');
        if (sec) return sec;
      }
      var id = raizA ? raizA.getAttribute('data-mp-ancora') : null;
      return document.querySelector(id ? '#' + id : '#modulo');
    }

    /* Altura real do que fica grudado no topo. `--mp-topo` chegava vazia e o código caía
       no palpite de 96px, quando o cabeçalho mede 73 no celular: os 23px de diferença
       eram exatamente a faixa que sobrava aparecendo. */
    function alturaGrudada() {
      var maior = 0;
      var cands = document.querySelectorAll('header, [id$="__header"], .utility-bar, .announcement-bar-section, [id*="announcement"]');
      for (var i = 0; cands.length > i; i++) {
        var c = getComputedStyle(cands[i]);
        if (c.position !== 'fixed' && c.position !== 'sticky') continue;
        var r2 = cands[i].getBoundingClientRect();
        if (r2.height > 0 && r2.bottom > maior && 250 > r2.bottom) maior = r2.bottom;
      }
      return Math.round(maior);
    }

    function ligarRolagemCtas() {
      if (document.documentElement.getAttribute('data-sola-rolagem')) return;
      document.documentElement.setAttribute('data-sola-rolagem', '1');
      var SELETORES = '[data-mc-ir],[data-tam-ir],[data-mot-ir],[data-uc-ir],[data-of-ir],'
        + '[data-mp-barra-btn],[data-rec-ir-btn],.sola-hero__cta,a[href="#modulo"]';
      document.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest(SELETORES) : null;
        if (!b) return;
        var alvo = alvoDosCtas();
        if (!alvo) return;
        e.preventDefault();
        e.stopPropagation();            /* impede o scrollTo seco de cada seção */
        /* ...e é justamente por isso que o aviso abaixo precisa existir: este ouvinte
           está na fase de CAPTURA, então `stopPropagation` impede o clique de chegar ao
           handler do próprio botão. Era o que deixava o popup de saída aberto enquanto a
           página rolava por baixo dele: o `fechar()` daquele botão nunca rodava.
           Em vez de abrir exceção para cada popup aqui, avisamos — e quem estiver aberto
           se fecha com a própria lógica. Rolar com uma sobreposição na frente é sempre
           errado, qualquer que seja ela. */
        document.dispatchEvent(new CustomEvent('sola:fechar-sobreposicoes'));
        var raizB = document.querySelector('.sola-mp[data-mp-secao]');
        var folga = parseInt(raizB && raizB.getAttribute('data-mp-parada'), 10);
        if (isNaN(folga)) folga = 14;
        var y = alvo.getBoundingClientRect().top + window.pageYOffset - alturaGrudada() - folga;
        var dur = parseInt(raizB && raizB.getAttribute('data-mp-rolagem'), 10) || 800;
        rolarSuave(Math.max(0, y), dur);
      }, true);
    }

    function todos() {
      var lista = document.querySelectorAll('.sola-mp');
      for (var i = 0; lista.length > i; i++) iniciar(lista[i]);
      ajustarTopo();
      /* a barra não espera o popup se já tinha assumido numa visita anterior */
      var rp = document.querySelector('.sola-mp[data-prazo-chave]');
      if (rp) {
        var lembrou = false;
        try { lembrou = localStorage.getItem(rp.getAttribute('data-prazo-chave') + '-barra') === '1'; } catch (e) {}
        if (lembrou) assumirBarra(false);
      }
      iniciarCaptura();
      iniciarRecuperacao();
      iniciarProvador();
      aquecerGaveta();
      arrumarTituloGaveta();
      arrumarUpsell();
      arrumarResumo();
      arrumarStories();
      ligarDeslizeStories();
      ligarGestosStories();
      ligarRolagemCtas();
      vigiarBrinde();
      marcarBrindeNaGaveta();
      sincronizarBrinde();
    }
    window.addEventListener('resize', ajustarTopo);
    window.addEventListener('load', ajustarTopo);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos);
    else todos();
    /* o personalizador recria a seção sem recarregar a página */
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sola-main-product"] && !Shopify.designMode) return;
  try {
    
  /* Sintaxe conservadora de propósito: 74% do tráfego desta LP está no webview do
     Instagram, e o Clarity já registra erro de JS ali. Sem arrow, sem optional
     chaining, sem template literal. Se este script falhar, o <noscript> com o
     <select name="id"> ainda permite comprar. */
  (function () {
    function iniciar(raiz) {
      if (!Prazo) Prazo = criarPrazo();   /* DOM pronto: o relogio ainda da tempo */
      if (raiz.getAttribute('data-mp-pronto')) return;
      raiz.setAttribute('data-mp-pronto', '1');

      var dados = raiz.querySelector('[data-mp-variantes]');
      var variantes = [];
      try { variantes = JSON.parse(dados.textContent); } catch (e) { return; }

      var inputs = raiz.querySelectorAll('[data-mp-input]');
      var campoId = raiz.querySelector('[data-mp-id]');
      var cta = raiz.querySelector('[data-mp-cta]');
      var ctaTxt = raiz.querySelector('[data-mp-cta-txt]');
      var elPix = raiz.querySelector('[data-mp-pix]');
      var elUn = raiz.querySelector('[data-mp-un]');
      var elTotal = raiz.querySelector('[data-mp-total]');
      var elVeste = raiz.querySelector('[data-mp-veste]');
      var tabelaVeste = {};
      var bruta = raiz.querySelector('[data-mp-veste-tabela]');
      if (bruta) {
        try {
          var linhas = String(JSON.parse(bruta.textContent) || '').split('\n');
          for (var t = 0; linhas.length > t; t++) {
            var partes = linhas[t].split('|');
            if (partes.length >= 2) tabelaVeste[partes[0].trim()] = partes.slice(1).join(' · ').trim();
          }
        } catch (e) {}
      }
      var ligacaoVeste = raiz.getAttribute('data-mp-veste-lig') || 'costuma servir em quem tem';
      var textoCta = ctaTxt ? ctaTxt.textContent : 'Adicionar ao carrinho';

      /* ---- Combo: "2 Pretas | 2 Brancas" -> variantes avulsas ---------------
         O mapa vem do Liquid como `cor|tamanho|gola` -> id, só com disponíveis.
         Devolve null a qualquer sinal de dúvida — e null significa "usa o fluxo
         antigo", nunca "não vende". */
      var mapaCombo = null;
      var brutoCombo = raiz.querySelector('[data-mp-combo-mapa]');
      if (brutoCombo) { try { mapaCombo = JSON.parse(brutoCombo.textContent); } catch (e) { mapaCombo = null; } }

      function corDoCatalogo(nome) {
        if (!mapaCombo) return null;
        var alvo = String(nome).trim().toLowerCase();
        /* "Pretas" e "Preta" são a mesma cor; o kit escreve no plural */
        var semS = alvo.replace(/s$/, '');
        for (var k in mapaCombo) {
          var c = k.split('|')[0].toLowerCase();
          if (c === alvo || c === semS) return k.split('|')[0];
        }
        return null;
      }

      function montarCombo(qtdKits) {
        if (!mapaCombo) return null;
        var kits = parseInt(qtdKits, 10) || 1;
        var sel = escolhidos(), cor = null, tam = null, gola = null;
        for (var i = 0; inputs.length > i; i++) {
          if (!inputs[i].checked) continue;
          var nome = (inputs[i].name || '').toLowerCase();
          if (nome.indexOf('cor') >= 0) cor = inputs[i].value;
          else if (nome.indexOf('tamanho') >= 0) tam = inputs[i].value;
          else if (nome.indexOf('gola') >= 0) gola = inputs[i].value;
        }
        if (!cor || !tam || !gola) return null;

        /* a gola da avulsa é "Gola O"; o kit guarda só "O" */
        var golas = [gola, 'Gola ' + gola];
        var partes = String(cor).split('|'), itens = [], total = 0;
        for (var j = 0; partes.length > j; j++) {
          var m = partes[j].trim().match(/^(\d+)\s+(.+)$/);
          if (!m) return null;
          var qtd = parseInt(m[1], 10);
          var nomeCor = corDoCatalogo(m[2]);
          if (!nomeCor || !qtd) return null;
          var par = null;
          for (var g = 0; golas.length > g && !par; g++) par = mapaCombo[nomeCor + '|' + tam + '|' + golas[g]] || null;
          if (!par) return null;
          total += qtd;
          /* _combo_produto/_combo_variante: o produto de VITRINE desta página e a variante
             escolhida dele — o carrinho lateral agrupa o combo com o nome e a foto dele
             (snippets/cart-combo-grupo). Não entram em desconto nenhum. */
          var vitrineProps = { _kit_variant_id: String(par[0]) };
          if (raiz.getAttribute('data-mp-vitrine')) vitrineProps._combo_produto = raiz.getAttribute('data-mp-vitrine');
          if (campoId && campoId.value) vitrineProps._combo_variante = String(campoId.value);
          /* nome e foto da linha de kit do checkout (Cart Transform kit-agrupado) */
          if (raiz.getAttribute('data-mp-vitrine-titulo')) vitrineProps._combo_titulo = raiz.getAttribute('data-mp-vitrine-titulo');
          if (raiz.getAttribute('data-mp-vitrine-img')) vitrineProps._combo_img = raiz.getAttribute('data-mp-vitrine-img');
          /* kit FECHADO (metacampo custom.agrupar_bundle da vitrine) */
          if (raiz.getAttribute('data-mp-agrupar') === '1') vitrineProps._agrupar = '1';
          itens.push({ id: par[0], quantity: qtd * kits, properties: vitrineProps,
                       preco: par[1], qtd: qtd });
        }
        /* a composição tem que fechar o slot, senão a Function não desconta e a
           página estaria prometendo um preço que o checkout não daria */
        if (total !== (parseInt(raiz.getAttribute('data-mp-combo-qtd'), 10) || 4)) return null;
        return { itens: itens, kits: kits };
      }

      /* Preço do combo, com a MESMA conta do checkout (moonapps, ADR 0005): a % sobre a
         soma das peças da composição, arredondada UMA vez, meio centavo para o cliente.
         4 × 169,90 a 25,2% = 679,60 − 171,26 = R$ 508,34 (pix 493,09). Peça a peça davam
         508,36, que era o que a Function cobrava até 10/2026. A mesma conta mora em
         snippets/combo-desconto-centavos — mudar junto. */
      function dinheiro(centavos) {
        return 'R$ ' + (centavos / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      var comboPct = parseFloat(raiz.getAttribute('data-mp-combo-pct'));
      function totalCombo() {
        if (!mapaCombo || isNaN(comboPct)) return null;
        var c = montarCombo(1);
        if (!c) return null;
        var cheio = 0;
        for (var i = 0; c.itens.length > i; i++) cheio += c.itens[i].preco * c.itens[i].qtd;
        /* em inteiros: a % com até 4 casas, mesmo teto de 50% da Function */
        var n = cheio * Math.round(Math.min(comboPct, 50) * 10000);
        var desconto = Math.floor((2 * n + 1000000) / 2000000);
        return { cheio: cheio, total: cheio - desconto, pecas: c.itens.reduce(function (a, x) { return a + x.qtd; }, 0) };
      }

      function escolhidos() {
        var fora = [];
        for (var i = 0; inputs.length > i; i++) {
          if (inputs[i].checked) fora[Number(inputs[i].getAttribute('data-mp-pos'))] = inputs[i].value;
        }
        return fora;
      }

      function acha(sel) {
        for (var i = 0; variantes.length > i; i++) {
          var v = variantes[i], bate = true;
          for (var k = 0; sel.length > k; k++) { if (v.op[k] !== sel[k]) { bate = false; break; } }
          if (bate) return v;
        }
        return null;
      }

      /* marca as opções que não existem em estoque para a combinação atual */
      function marcarIndisponiveis(sel) {
        for (var i = 0; inputs.length > i; i++) {
          var inp = inputs[i], pos = Number(inp.getAttribute('data-mp-pos'));
          var teste = sel.slice(); teste[pos] = inp.value;
          var v = acha(teste);
          var rot = raiz.querySelector('label[for="' + inp.id + '"]');
          if (rot) rot.setAttribute('data-esgotado', (v && v.d) ? '0' : '1');
        }
      }

      function atualizar() {
        var sel = escolhidos();
        var v = acha(sel);
        marcarIndisponiveis(sel);
        atualizarFotoBarra();

        for (var i = 0; inputs.length > i; i++) {
          if (inputs[i].checked) {
            var alvo = raiz.querySelector('[data-mp-valor="' + inputs[i].getAttribute('data-mp-pos') + '"]');
            if (alvo) alvo.textContent = inputs[i].value;
          }
        }

        /* A linha embaixo do seletor. Ela dizia "PP veste 55 a 65 kg", uma afirmação
           que a grade não sustenta: as faixas de peso se sobrepõem e a mesma pessoa
           cabe em dois tamanhos. O verbo agora é de tendência, não de decreto — quem
           decide é o provador, e o convite para ele está na faixa logo abaixo. */
        if (elVeste) {
          for (var t = 0; inputs.length > t; t++) {
            if (inputs[t].checked && tabelaVeste[inputs[t].value]) {
              elVeste.innerHTML = '<b>' + inputs[t].value + '</b> ' + ligacaoVeste + ' ' + tabelaVeste[inputs[t].value];
            }
          }
        }

        if (!v) {
          if (cta) { cta.disabled = true; }
          if (ctaTxt) { ctaTxt.textContent = 'Combinação indisponível'; }
          return;
        }
        if (campoId) campoId.value = v.id;
        var tc = totalCombo();
        if (tc && tc.total > 0) {
          /* o preço vem da composição real que vai para o carrinho, não do
             produto do módulo — é o mesmo número que o checkout vai cobrar */
          var pixPct = parseFloat(raiz.getAttribute('data-mp-pix-pct'));
          if (isNaN(pixPct)) pixPct = 0;
          var pix = Math.round(tc.total * (1 - pixPct / 100));
          if (elPix) elPix.textContent = dinheiro(pix);
          if (elUn) elUn.textContent = dinheiro(Math.round(pix / (tc.pecas || 1)));
          var elDe = raiz.querySelector('.sola-mp__de');
          if (elDe) elDe.textContent = dinheiro(tc.cheio);
        } else {
          if (elPix) elPix.textContent = v.pix;
          if (elUn) elUn.textContent = v.un;
        }
        if (typeof atualizarTotal === 'function') atualizarTotal();
        if (cta) cta.disabled = !v.d;
        if (ctaTxt) ctaTxt.textContent = v.d ? textoCta : 'Esgotado';
      }

      for (var i = 0; inputs.length > i; i++) inputs[i].addEventListener('change', atualizar);
      atualizar();

      /* galeria: miniatura leva o palco até a foto, e o arrasto marca a miniatura */
      var palco = raiz.querySelector('[data-mp-tira]');
      var minis = raiz.querySelectorAll('[data-mp-mini]');
      function marcarMini(i) {
        for (var k = 0; minis.length > k; k++) {
          if (k === i) minis[k].setAttribute('aria-current', 'true');
          else minis[k].removeAttribute('aria-current');
        }
      }
      for (var m = 0; minis.length > m; m++) {
        (function (btn, idx) {
          btn.addEventListener('click', function () { irPara(idx); });
        })(minis[m], m);
      }
      if (palco && minis.length) {
      }

      /* ─── um passo por gesto ───
         scroll-snap sozinho não impede o embalo do trackpad de pular 5 fotos.
         A roda é interceptada e move exatamente um; o toque é limitado a ±1
         em relação ao índice onde o gesto começou. */
      var trilho = raiz.querySelector('[data-mp-trilho]');
      var idxPalco = 0;
      function idxAtual() { return idxPalco; }
      function desenhar(px) {
        if (!trilho) return;
        var base = -idxPalco * 100;
        trilho.style.transform = px
          ? 'translate3d(calc(' + base + '% + ' + Math.round(px) + 'px), 0, 0)'
          : 'translate3d(' + base + '%, 0, 0)';
      }
      /* O vídeo toca quando o slide dele entra, e para quando sai. Sempre mudo:
         navegador nenhum deixa tocar com som sem gesto, e o play falharia calado. */
      function tocarDoSlide(i) {
        if (!trilho || raiz.getAttribute('data-mp-autoplay') !== '1') return;
        var itens = trilho.children;
        for (var k = 0; itens.length > k; k++) {
          var v = itens[k].querySelector('video');
          if (!v) continue;
          if (k === i) {
            v.muted = true;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});   /* política do navegador: segue a vida */
          } else if (!v.paused) {
            v.pause();
          }
        }
      }
      function irPara(i) {
        var max = minis.length - 1;
        if (i > max) i = max;
        if (0 > i) i = 0;
        idxPalco = i;
        desenhar(0);
        marcarMini(i);
        atualizarSetas();
        tocarDoSlide(i);
      }
      /* setas: mesma função do gesto, então uma coisa só decide o índice */
      var setas = raiz.querySelectorAll('[data-mp-seta]');
      function atualizarSetas() {
        if (!setas.length) return;
        var i = idxAtual(), max = minis.length - 1;
        for (var s = 0; setas.length > s; s++) {
          var passo = parseInt(setas[s].getAttribute('data-mp-seta'), 10);
          setas[s].disabled = (0 > passo && 0 >= i) || (passo > 0 && i >= max);
        }
      }
      for (var s2 = 0; setas.length > s2; s2++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            irPara(idxAtual() + parseInt(btn.getAttribute('data-mp-seta'), 10));
            setTimeout(atualizarSetas, 460);
          });
        })(setas[s2]);
      }

      /* Zoom seguindo o ponteiro. Marcamos com atributo em vez de estilo inline para
         a transição de saída existir — tirar o transform inline cortaria a volta. */
      function ligarZoom(alvo) {
        if (!alvo || alvo.getAttribute('data-zoom-pronto')) return;
        alvo.setAttribute('data-zoom-pronto', '1');
        alvo.addEventListener('mousemove', function (e) {
          var img = alvo.querySelector('img');
          if (!img) return;
          var c = alvo.getBoundingClientRect();
          img.style.transformOrigin =
            (((e.clientX - c.left) / c.width) * 100) + '% ' + (((e.clientY - c.top) / c.height) * 100) + '%';
        });
        alvo.addEventListener('mouseenter', function () {
          if (alvo.querySelector('img')) alvo.setAttribute('data-zoom', '1');
        });
        alvo.addEventListener('mouseleave', function () { alvo.removeAttribute('data-zoom'); });
      }
      if (raiz.getAttribute('data-mp-zoom') === '1') {
        var itens = raiz.querySelectorAll('.sola-mp__item');
        for (var z2 = 0; itens.length > z2; z2++) ligarZoom(itens[z2]);
      }

      if (palco) {
        atualizarSetas();
        var travaRoda = false;
        palco.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;   /* rolagem vertical: deixa passar */
          e.preventDefault();
          if (travaRoda) return;
          travaRoda = true;
          irPara(idxAtual() + (e.deltaX > 0 ? 1 : -1));
          setTimeout(function () { travaRoda = false; }, 430);
        }, { passive: false });

        /* Arrasto próprio. `arrastando` só vira true quando o movimento é claramente
           horizontal, senão a pessoa não consegue mais rolar a página com o dedo em
           cima da foto. A decisão sai no touchend e é sempre ±1: distância acima do
           limiar OU velocidade alta (flick curto e rápido também tem que virar página). */
        var x0 = 0, y0 = 0, t0 = 0, dx = 0, arrastando = false, decidiu = false;
        palco.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
          t0 = Date.now(); dx = 0; arrastando = false; decidiu = false;
        }, { passive: true });

        palco.addEventListener('touchmove', function (e) {
          if (e.touches.length !== 1) return;
          var ax = e.touches[0].clientX - x0, ay = e.touches[0].clientY - y0;
          if (!decidiu) {
            if (6 > Math.abs(ax) && 6 > Math.abs(ay)) return;   /* ainda não dá para saber */
            decidiu = true;
            arrastando = Math.abs(ax) > Math.abs(ay);
            if (arrastando && trilho) trilho.setAttribute('data-arrastando', '1');
          }
          if (!arrastando) return;
          e.preventDefault();                     /* segura a rolagem da página */
          dx = ax;
          /* resistência nas pontas, para a foto não descolar do fim do carretel */
          if ((0 >= idxPalco && dx > 0) || (idxPalco >= minis.length - 1 && 0 > dx)) dx = dx * 0.32;
          desenhar(dx);
        }, { passive: false });

        function soltar() {
          if (!arrastando) return;
          arrastando = false;
          if (trilho) trilho.removeAttribute('data-arrastando');
          var larg = palco.clientWidth || 1;
          var vel = Math.abs(dx) / Math.max(1, Date.now() - t0);   /* px por ms */
          var passou = Math.abs(dx) > larg * 0.18 || vel > 0.45;
          irPara(idxPalco + (passou ? (0 > dx ? 1 : -1) : 0));
          dx = 0;
        }
        palco.addEventListener('touchend', soltar, { passive: true });
        palco.addEventListener('touchcancel', soltar, { passive: true });
      }

      /* ─── vídeo: play/pause e volume próprios ─── */
      function ligarVideo(caixa) {
        var vid = caixa.querySelector('video');
        var btn = caixa.querySelector('[data-mp-play]');
        var mudo = caixa.querySelector('[data-mp-mudo]');
        var faixa = caixa.querySelector('[data-mp-volume]');
        if (!vid) return;
        vid.muted = true; vid.volume = 0;
        if (mudo) mudo.setAttribute('data-mudo', '1');

        function pintar() {
          if (!btn) return;
          if (vid.paused) btn.removeAttribute('data-tocando');
          else btn.setAttribute('data-tocando', '1');
          btn.setAttribute('aria-label', vid.paused ? 'Reproduzir vídeo' : 'Pausar vídeo');
        }
        function alternar(e) {
          if (e) { e.preventDefault(); e.stopPropagation(); }
          if (vid.paused) vid.play(); else vid.pause();
        }
        /* No palco, clicar no vídeo abre o lightbox — quem dá play/pause é a bolinha.
           Dentro do lightbox não há para onde expandir, então o clique alterna. */
        if (btn) btn.addEventListener('click', alternar);
        if (caixa.closest('.sola-mp-lb')) vid.addEventListener('click', alternar);
        vid.addEventListener('play', pintar);
        vid.addEventListener('pause', pintar);
        vid.addEventListener('ended', pintar);
        if (mudo) {
          mudo.addEventListener('click', function (e) {
            e.stopPropagation();
            vid.muted = !vid.muted;
            if (!vid.muted && vid.volume === 0) vid.volume = 0.7;
            if (faixa) faixa.value = vid.muted ? 0 : Math.round(vid.volume * 100);
            if (vid.muted) mudo.setAttribute('data-mudo', '1'); else mudo.removeAttribute('data-mudo');
            mudo.setAttribute('aria-label', vid.muted ? 'Ativar som' : 'Silenciar');
          });
        }
        if (faixa) {
          faixa.addEventListener('click', function (e) { e.stopPropagation(); });
          faixa.addEventListener('input', function () {
            vid.volume = faixa.value / 100;
            vid.muted = vid.volume === 0;
            if (mudo) { if (vid.muted) mudo.setAttribute('data-mudo', '1'); else mudo.removeAttribute('data-mudo'); }
          });
        }
        pintar();
      }
      var caixasVideo = raiz.querySelectorAll('.sola-mp__item--video');
      for (var cv = 0; caixasVideo.length > cv; cv++) ligarVideo(caixasVideo[cv]);

      /* ─── lightbox ─── */
      var lb = raiz.parentElement && raiz.parentElement.querySelector('[data-mp-lb]');
      var midia = [];
      var fonteMidia = raiz.querySelector('[data-mp-midia]');
      if (fonteMidia) { try { midia = JSON.parse(fonteMidia.textContent); } catch (e) {} }

      if (lb && midia.length) {
        lb.removeAttribute('hidden');
        var lbPalco = lb.querySelector('[data-mp-lb-palco]');
        var lbConta = lb.querySelector('[data-mp-lb-contador]');
        var lbIdx = 0, focoAnterior = null;

        var retomar = null;   /* {t: segundos, tocando: bool} vindo do palco */

        var lbParado = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        function montarLb(i, de) {
          var m = midia[i];
          if (!m) return;
          lbIdx = i;
          lbPalco.innerHTML = '';
          var caixa = document.createElement('div');
          caixa.className = 'sola-mp-lb__midia';
          if (m.t === 'img') {
            var img = document.createElement('img');
            img.src = m.src; img.alt = m.alt || '';
            caixa.appendChild(img);
          } else if (m.t === 'video') {
            var v = document.createElement('video');
            v.setAttribute('playsinline', ''); v.preload = 'metadata';
            if (m.poster) v.poster = m.poster;
            for (var f = 0; m.srcs.length > f; f++) {
              var src = document.createElement('source');
              src.src = m.srcs[f].u; src.type = m.srcs[f].m;
              v.appendChild(src);
            }
            if (retomar) {
              var alvoT = retomar.t, deveTocar = retomar.tocando;
              retomar = null;
              v.addEventListener('loadedmetadata', function () {
                try { v.currentTime = alvoT; } catch (e) {}
                if (deveTocar) v.play();
              }, { once: true });
              v.preload = 'auto';
            }
            caixa.appendChild(v);
            caixa.insertAdjacentHTML('beforeend', raiz.querySelector('[data-mp-play]') ?
              raiz.querySelector('[data-mp-play]').outerHTML : '');
            var vol = raiz.querySelector('[data-mp-vol]');
            if (vol) caixa.insertAdjacentHTML('beforeend', vol.outerHTML);
          } else if (m.t === 'externo') {
            caixa.innerHTML = m.html;
          }
          lbPalco.appendChild(caixa);
          if (m.t === 'video') ligarVideo(caixa);
          /* o lightbox é montado a cada abertura, então o zoom se liga aqui e não
             junto com o palco — a caixa nem existia quando a página carregou */
          else if (raiz.getAttribute('data-mp-zoom') === '1') ligarZoom(caixa);
          if (lbConta) lbConta.textContent = (i + 1) + ' / ' + midia.length;
          /* A que entra chega do lado de onde veio o gesto. Vale tambem para as setas
             e para o teclado: um so caminho decide o movimento, entao os tres andam igual. */
          if (de && !lbParado) {
            var larg = lb.clientWidth || 1;
            caixa.style.transform = 'translate3d(' + Math.round(de * larg * 0.55) + 'px,0,0)';
            caixa.style.opacity = '0';
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                caixa.setAttribute('data-lb-solto', '1');
                caixa.style.transform = '';
                caixa.style.opacity = '';
              });
            });
          }
        }
        function abrirLb(i) {
          /* pausa o vídeo do palco e leva o ponto dele para o lightbox */
          var itensV = raiz.querySelectorAll('.sola-mp__item');
          if (itensV[i]) {
            var vp = itensV[i].querySelector('video');
            if (vp) {
              retomar = { t: vp.currentTime || 0, tocando: !vp.paused };
              vp.pause();
            }
          }
          focoAnterior = document.activeElement;
          montarLb(i);
          lb.setAttribute('data-aberto', '1');
          document.documentElement.style.overflow = 'hidden';
          var fechar = lb.querySelector('[data-mp-lb-fechar]');
          if (fechar) fechar.focus();
        }
        function fecharLb() {
          var v = lbPalco.querySelector('video'); if (v) v.pause();
          lb.removeAttribute('data-aberto');
          document.documentElement.style.overflow = '';
          lbPalco.innerHTML = '';
          if (focoAnterior && focoAnterior.focus) focoAnterior.focus();
        }
        function andar(d) {
          var v = lbPalco.querySelector('video'); if (v) v.pause();
          var i = lbIdx + d;
          if (0 > i) i = midia.length - 1;
          if (i > midia.length - 1) i = 0;
          montarLb(i, d);
        }

        var itens = raiz.querySelectorAll('.sola-mp__item');
        for (var it = 0; itens.length > it; it++) {
          (function (el, idx) {
            el.addEventListener('click', function (e) {
              /* a bolinha de play tem o clique dela; o resto do vídeo expande */
              if (e.target.closest && e.target.closest('[data-mp-play]')) return;
              e.preventDefault();
              abrirLb(idx);
            });
          })(itens[it], it);
        }
        var fecharBtn = lb.querySelector('[data-mp-lb-fechar]');
        if (fecharBtn) fecharBtn.addEventListener('click', fecharLb);
        var antBtn = lb.querySelector('[data-mp-lb-ant]');
        if (antBtn) antBtn.addEventListener('click', function () { andar(-1); });
        var proxBtn = lb.querySelector('[data-mp-lb-prox]');
        if (proxBtn) proxBtn.addEventListener('click', function () { andar(1); });
        lb.addEventListener('click', function (e) { if (e.target === lb) fecharLb(); });

        /* ─── arrastar para o lado ───
           O palco monta uma midia por vez, entao nao existe trilho para deslizar:
           quem segue o dedo e a propria caixa. Ponteiro em vez de toque porque assim
           o mesmo codigo atende dedo e mouse, que era o pedido. Limiar igual ao do
           carrossel do palco: 16% da largura OU um flick rapido — um puxao curto e
           veloz tambem tem que virar a foto. */
        var gX0 = 0, gY0 = 0, gT0 = 0, gDx = 0, gArr = false, gDec = false;
        var gId = null, gMoveu = 0, gOcupado = false;
        function gCaixa() { return lbPalco.querySelector('.sola-mp-lb__midia'); }

        lbPalco.addEventListener('pointerdown', function (e) {
          if (gOcupado) return;
          if (e.button && e.button !== 0) return;
          /* o controle de volume tem o arrasto dele */
          if (e.target.closest && e.target.closest('[data-mp-volume]')) return;
          gId = e.pointerId; gX0 = e.clientX; gY0 = e.clientY; gT0 = Date.now();
          gDx = 0; gArr = false; gDec = false;
          var c = gCaixa();
          if (c) { c.removeAttribute('data-lb-solto'); c.style.transition = ''; }
        });

        lbPalco.addEventListener('pointermove', function (e) {
          if (gId === null || e.pointerId !== gId) return;
          var ax = e.clientX - gX0, ay = e.clientY - gY0;
          if (!gDec) {
            if (6 > Math.abs(ax) && 6 > Math.abs(ay)) return;   /* ainda nao da para saber */
            gDec = true;
            gArr = Math.abs(ax) > Math.abs(ay);
            if (gArr) {
              try { lbPalco.setPointerCapture(gId); } catch (err) {}
              var cz = gCaixa();
              if (cz) cz.removeAttribute('data-zoom');   /* zoom e arrasto nao convivem */
            }
          }
          if (!gArr) return;
          e.preventDefault();
          gDx = ax;
          var c = gCaixa();
          if (c) c.style.transform = 'translate3d(' + Math.round(gDx) + 'px,0,0)';
        });

        function gSoltar(e) {
          if (gId === null) return;
          var eraArr = gArr;
          try { if (lbPalco.releasePointerCapture) lbPalco.releasePointerCapture(gId); } catch (err) {}
          gId = null; gArr = false;
          var c = gCaixa();
          if (!eraArr) { if (c) c.style.transform = ''; return; }
          gMoveu = Date.now();                       /* engole o clique que vem atras do arrasto */
          var larg = lb.clientWidth || 1;
          var vel = Math.abs(gDx) / Math.max(1, Date.now() - gT0);   /* px por ms */
          var passou = Math.abs(gDx) > larg * 0.16 || vel > 0.4;
          if (!passou) {
            if (c) { c.setAttribute('data-lb-solto', '1'); c.style.transform = ''; }
            gDx = 0;
            return;
          }
          var d = 0 > gDx ? 1 : -1;
          gDx = 0;
          if (c && !lbParado) {
            /* a que sai continua o movimento do dedo ate a borda, e so entao a
               proxima e montada. `gOcupado` segura um segundo gesto nesse meio. */
            gOcupado = true;
            c.style.transition = 'transform .16s ease-out, opacity .16s ease-out';
            c.style.transform = 'translate3d(' + Math.round(-d * larg * 0.7) + 'px,0,0)';
            c.style.opacity = '0';
            setTimeout(function () { gOcupado = false; andar(d); }, 150);
          } else {
            andar(d);
          }
        }
        lbPalco.addEventListener('pointerup', gSoltar);
        lbPalco.addEventListener('pointercancel', gSoltar);

        /* Sem isto o fim de um arrasto vira clique: fecharia o lightbox se soltasse
           sobre o veu, ou daria play no video se soltasse sobre ele. */
        /* No `document` e nao no proprio lightbox: quando o clique cai no veu, o alvo
           E o lightbox, e no alvo os ouvintes disparam por ordem de registro — o que
           fecha foi registrado antes e passaria na frente. Um degrau acima resolve. */
        document.addEventListener('click', function (e) {
          if (!lb.hasAttribute('data-aberto')) return;
          if (320 > Date.now() - gMoveu) { e.preventDefault(); e.stopPropagation(); }
        }, true);

        document.addEventListener('keydown', function (e) {
          if (!lb.hasAttribute('data-aberto')) return;
          if (e.key === 'Escape') fecharLb();
          if (e.key === 'ArrowLeft') andar(-1);
          if (e.key === 'ArrowRight') andar(1);
        });
      }

      /* Barra fixa: aparece quando o botão principal NÃO está na tela.
         Tem que ser "não visível", não "já passou": para a maior parte deste
         tráfego o botão está ABAIXO e nunca é alcançado. */
      var barra = (raiz.parentElement && raiz.parentElement.querySelector('[data-mp-barra]')) || null;
      if (barra) {
        barra.removeAttribute('hidden');
        /* O gatilho pode ser um seletor (a seção que a barra deve seguir) ou, sem
           seletor, a enésima seção da página. E o disparo não é "a seção saiu inteira
           da tela": é ela passar de um ponto configurável da própria altura — assim a
           barra chega enquanto a pessoa ainda está saindo da seção, não depois. */
        var sel = barra.getAttribute('data-mp-gatilho');
        var gatilho = sel ? document.querySelector(sel) : null;
        if (!gatilho) {
          var aposN = parseInt(barra.getAttribute('data-mp-apos'), 10) || 2;
          var secoes = document.querySelectorAll('#MainContent [id^="shopify-section-"], main [id^="shopify-section-"]');
          gatilho = secoes.length >= aposN ? secoes[aposN - 1] : null;
        }
        var ponto = parseInt(barra.getAttribute('data-mp-ponto'), 10);
        if (isNaN(ponto)) ponto = 100;

        var moduloNaTela = false;
        var elModulo = document.querySelector('.sola-mp__grid');
        if (elModulo && 'IntersectionObserver' in window) {
          /* Enquanto o módulo está à vista, a barra flutuante some: os dois oferecem a
             mesma ação no mesmo instante e disputam a atenção. Ela volta assim que ele sai. */
          new IntersectionObserver(function (ent) {
            moduloNaTela = ent[0].isIntersecting;
            avaliarBarra();
          }, { rootMargin: '-70px 0px -40px 0px', threshold: 0 }).observe(elModulo);
        }
        function avaliarBarra() {
          if (!gatilho) return;
          if (moduloNaTela) { barra.removeAttribute('data-visivel'); return; }
          var cx = gatilho.getBoundingClientRect();
          /* ponto = 50 significa "quando metade da seção já subiu além do topo" */
          var passou = cx.top + (cx.height * ponto / 100) <= 0;
          var gav = document.querySelector('cart-drawer');
          var gavAberta = gav && /active|is-open/.test(gav.className);
          if (passou && !gavAberta) barra.setAttribute('data-visivel', '1');
          else barra.removeAttribute('data-visivel');
        }
        var irBarra = barra.querySelector('[data-mp-barra-btn]');
        if (irBarra) irBarra.addEventListener('click', function () {
          var alvo = document.querySelector(barra.getAttribute('data-mp-barra-ir') || '#modulo');
          if (!alvo) return;
          var topo = alvo.getBoundingClientRect().top + window.pageYOffset
            - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mp-topo'), 10) || 96);
          window.scrollTo({ top: topo, behavior: 'smooth' });
        });

        window.addEventListener('scroll', avaliarBarra, { passive: true });
        window.addEventListener('resize', avaliarBarra);
        avaliarBarra();

        var gav2 = document.querySelector('cart-drawer');
        if (gav2 && 'MutationObserver' in window) {
          new MutationObserver(avaliarBarra).observe(gav2, { attributes: true, attributeFilter: ['class'] });
        }
      }

      /* "2.419 avaliações" leva para a seção de avaliações da página */
      var irAval = raiz.querySelector('[data-mp-ir-avaliacoes]');
      if (irAval) {
        irAval.addEventListener('click', function () {
          var sel = raiz.getAttribute('data-mp-alvo-avaliacoes');
          var alvo = sel ? document.querySelector(sel) : null;
          if (!alvo) {
            var todas = document.querySelectorAll('[id^="shopify-section-"]');
            for (var z = 0; todas.length > z; z++) {
              if (/review|avalia|konfidency|judge|loox/i.test(todas[z].id + ' ' + todas[z].className)) { alvo = todas[z]; break; }
            }
          }
          if (!alvo) return;
          var topo = parseInt(getComputedStyle(raiz).getPropertyValue('--mp-topo'), 10) || 96;
          var y = alvo.getBoundingClientRect().top + window.pageYOffset - topo;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });
      }

      /* "+N" revela as combinações restantes */
      var btnMais = raiz.querySelector('[data-mp-mais]');
      if (btnMais) {
        var caixaSw = raiz.querySelector('[data-mp-swatches]');
        var tempoFecha = null;
        var tempoAltura = null;

        /* Anima a altura da grade: sem isto o total, o botão e a galeria dão um
           salto quando a segunda linha entra ou sai. */
        /* medir: função que deixa a caixa no estado FINAL só para ler a altura.
           aplicar: função que deixa a caixa no estado que deve ficar durante a animação. */
        function animarAltura(medir, aplicar, dur) {
          var antes = caixaSw.offsetHeight;
          medir();
          caixaSw.style.height = 'auto';
          var depois = caixaSw.offsetHeight;
          aplicar();
          if (antes === depois) { caixaSw.style.height = ''; return; }
          caixaSw.setAttribute('data-animando', '1');
          caixaSw.style.height = antes + 'px';
          caixaSw.offsetHeight;                 /* força o reflow */
          caixaSw.style.transition = 'height ' + dur + 'ms cubic-bezier(.22,.61,.36,1)';
          caixaSw.style.height = depois + 'px';
          if (tempoAltura) clearTimeout(tempoAltura);
          tempoAltura = setTimeout(function () {
            caixaSw.style.transition = '';
            caixaSw.style.height = '';
            caixaSw.removeAttribute('data-animando');
          }, dur + 30);
        }

        btnMais.addEventListener('click', function () {
          if (tempoFecha) { clearTimeout(tempoFecha); tempoFecha = null; }
          var aberto = caixaSw.hasAttribute('data-aberto') && !caixaSw.hasAttribute('data-fechando');

          if (aberto) {
            /* mede recolhida, mas mantém aberta+fechando para o fade rodar junto */
            animarAltura(
              function () { caixaSw.removeAttribute('data-aberto'); },
              function () { caixaSw.setAttribute('data-aberto', '1'); caixaSw.setAttribute('data-fechando', '1'); },
              280);
            tempoFecha = setTimeout(function () {
              /* só encerra se o fechamento ainda estiver valendo */
              if (caixaSw.hasAttribute('data-fechando')) {
                caixaSw.removeAttribute('data-fechando');
                caixaSw.removeAttribute('data-aberto');
              }
              tempoFecha = null;
            }, 285);
              btnMais.setAttribute('aria-expanded', 'false');
          } else {
            animarAltura(
              function () { caixaSw.removeAttribute('data-fechando'); caixaSw.setAttribute('data-aberto', '1'); },
              function () {},
              340);
            btnMais.setAttribute('aria-expanded', 'true');
          }
        });
      }

      /* quantidade — e o total acompanha */
      var campoQtd = raiz.querySelector('.sola-mp__qtd-num');
      var botoesQtd = raiz.querySelectorAll('[data-mp-qtd]');
      var kitQtd = parseInt(raiz.getAttribute('data-mp-kit'), 10) || 1;
      var pixMult = parseFloat(raiz.getAttribute('data-mp-pixmult')) || 1;
      var resumo1 = raiz.getAttribute('data-mp-resumo') || '';
      var resumoN = raiz.getAttribute('data-mp-resumo-multi') || '';
      var elResumo = raiz.querySelector('[data-mp-resumo-alvo]');

      function dinheiro(centavos) {
        var v = Math.round(centavos) / 100;
        var inteiro = Math.floor(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        var frac = Math.round((v - Math.floor(v)) * 100);
        return 'R$ ' + inteiro + ',' + (10 > frac ? '0' + frac : frac);
      }

      /* A foto da barra acompanha a combinação. A fonte é a própria imagem do swatch
         que já está no DOM — nada de mapa paralelo em JSON, que sairia do ar sozinho
         no dia em que o cliente trocasse uma foto no personalizador. */
      var barraFoto = document.querySelector('[data-mp-barra-foto] img');
      var fotoInicial = barraFoto ? (barraFoto.getAttribute('src') || '') : '';
      function atualizarFotoBarra() {
        if (!barraFoto) return;
        var escolhida = null;
        for (var i = 0; inputs.length > i; i++) {
          if (!inputs[i].checked) continue;
          var lab = raiz.querySelector('label[for="' + inputs[i].id + '"]');
          var im = lab ? lab.querySelector('.sola-mp__sw-img img') : null;
          if (im) escolhida = im;
        }
        var src = escolhida ? (escolhida.currentSrc || escolhida.getAttribute('src')) : fotoInicial;
        if (!src || barraFoto.getAttribute('src') === src) return;
        barraFoto.setAttribute('src', src);
        barraFoto.removeAttribute('srcset');    /* senão o srcset antigo vence o src novo */
      }

      function atualizarTotal() {
        var qtd = parseInt(campoQtd ? campoQtd.value : 1, 10) || 1;
        var sel = escolhidos();
        var v = acha(sel);
        /* Quando existe combo, o preço é o da COMPOSIÇÃO que vai para o carrinho —
           não o da variante do produto do módulo. Sem isto o topo mostrava o preço do
           combo e o total logo acima do botão mostrava o preço do produto antigo, dois
           números diferentes na mesma tela para a mesma coisa. */
        var tcT = (typeof totalCombo === 'function') ? totalCombo() : null;
        var baseUm = (tcT && tcT.total > 0) ? Math.round(tcT.total * pixMult)
                                            : (v ? v.p * pixMult : 0);
        var pecasUm = (tcT && tcT.pecas) ? tcT.pecas : kitQtd;
        if (elTotal && (v || tcT)) {
          elTotal.innerHTML = dinheiro(baseUm * qtd) +
            ' <span class="sola-mp__pix-mini">no pix</span>';
        }
        var bTot = document.querySelector('[data-mp-barra-total]');
        var bUn = document.querySelector('[data-mp-barra-un]');
        if (bTot && (v || tcT)) bTot.textContent = dinheiro(baseUm * qtd);
        if (bUn && (v || tcT)) bUn.textContent = dinheiro(Math.round(baseUm / pecasUm)) + '/un';
        if (elResumo) {
          elResumo.textContent = (qtd > 1 && resumoN)
            ? resumoN.replace('{pecas}', kitQtd * qtd).replace('{kits}', qtd)
            : resumo1;
        }
      }

      for (var q = 0; botoesQtd.length > q; q++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            var n = parseInt(campoQtd.value, 10) || 1;
            n = n + parseInt(btn.getAttribute('data-mp-qtd'), 10);
            if (1 > n) n = 1;
            campoQtd.value = n;
            atualizarTotal();
          });
        })(botoesQtd[q]);
      }
      if (campoQtd) {
        campoQtd.addEventListener('change', atualizarTotal);
        campoQtd.addEventListener('input', atualizarTotal);
      }
      atualizarTotal();

      /* Adicionar ao carrinho abre a GAVETA do tema em vez de ir para /cart.
         Usa a API do próprio cart-drawer (Dawn): renderContents já abre a gaveta. */
      var form = raiz.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', function (ev) {
          var gaveta = document.querySelector('cart-drawer');
          if (!gaveta) return;                       /* sem gaveta: deixa o POST normal */
          ev.preventDefault();
          if (cta) { cta.disabled = true; cta.setAttribute('aria-busy', 'true'); }
          if (ctaTxt) ctaTxt.textContent = raiz.getAttribute('data-mp-cta-carregando') || 'Adicionando';

          var dados = new FormData(form);
          if (typeof gaveta.getSectionsToRender === 'function') {
            var ids = [];
            var secoes = gaveta.getSectionsToRender();
            for (var z = 0; secoes.length > z; z++) ids.push(secoes[z].id);
            dados.append('sections', ids.join(','));
            dados.append('sections_url', window.location.pathname);
          }
          var raiz_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          /* Redesenha a gaveta INTEIRA pela API de seções e alinha a classe `is-empty`
             do <cart-drawer> ao carrinho real. Nunca navega.

             Por que não confiar só no renderContents(json) do tema: sem `sections` na
             resposta do add ele não tem o que desenhar — e quem limpa o `is-empty` do
             host no add do Dawn é o product-form.js (~linha 112), que esta LP não usa.
             Resultado no PRIMEIRO add com carrinho vazio: o host seguia `is-empty`, o
             CSS do drawer escondia header, barra, itens e rodapé, e a gaveta abria em
             branco só com o upsell. Medido ao vivo em 11/09.

             O alvo da troca é o #CartDrawer — o mesmo que o renderContents do tema usa —
             e a URL é a da página, não a raiz, pelo mesmo motivo do cart.js: o escopo do
             Order Bump V2 lê page.handle. */
          function recarregarGaveta() {
            var url = (window.location && window.location.pathname ? window.location.pathname : raiz_url) + '?sections=cart-drawer';
            return fetch(url)
              .then(function (r) { return r.json(); })
              .then(function (sec) {
                var html = sec && sec['cart-drawer'];
                if (!html) return;
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var novo = doc.querySelector('#CartDrawer');
                var atual = gaveta.querySelector('#CartDrawer');
                if (novo && atual) {
                  atual.innerHTML = novo.innerHTML;
                  /* o overlay foi recriado: religa o fechar-ao-clicar-fora (igual o tema) */
                  var overlay = gaveta.querySelector('#CartDrawer-Overlay');
                  if (overlay && typeof gaveta.close === 'function') overlay.addEventListener('click', gaveta.close.bind(gaveta));
                } else {
                  var novoInner = doc.querySelector('.drawer__inner');
                  var atualInner = gaveta.querySelector('.drawer__inner');
                  if (novoInner && atualInner) atualInner.innerHTML = novoInner.innerHTML;
                }
                /* is-empty vem do que a seção devolveu, não de suposição */
                var vazio = !doc.querySelector('.cart-item');
                gaveta.classList.toggle('is-empty', vazio);
                var lista = gaveta.querySelector('cart-drawer-items');
                if (lista) lista.classList.toggle('is-empty', vazio);
              })
              .catch(function () {});
          }

          /* Rede de segurança: se depois de aberta a gaveta tiver linha de item e ainda
             estiver `is-empty` (medido ao vivo em 11/09: host "drawer is-empty animate
             active", 2 .cart-item, cart-drawer-items display:none), corrige — não importa
             quem recolocou a classe. */
          function garantirNaoVazia() {
            try {
              if (gaveta.querySelector('.cart-item')) {
                gaveta.classList.remove('is-empty');
                var lista = gaveta.querySelector('cart-drawer-items');
                if (lista) lista.classList.remove('is-empty');
              }
            } catch (e) {}
          }

          function abrirGaveta(json) {
            var abrir = function () {
              if (typeof gaveta.open === 'function') gaveta.open();
              else gaveta.classList.add('active');
              document.body.classList.add('overflow-hidden');
              garantirNaoVazia();
              setTimeout(garantirNaoVazia, 400);
              setTimeout(garantirNaoVazia, 1500);
            };
            /* Só delega ao tema quando a resposta traz a seção — aí o renderContents tem
               o que desenhar. E limpa o is-empty do host antes, como o product-form.js. */
            var temSecao = json && json.sections && json.sections['cart-drawer'];
            if (temSecao && typeof gaveta.renderContents === 'function') {
              try {
                gaveta.classList.remove('is-empty');
                gaveta.renderContents(json); /* abre sozinho */
                setTimeout(garantirNaoVazia, 400);
                setTimeout(garantirNaoVazia, 1500);
                return;
              } catch (e) { /* o tema falhou: caminho manual abaixo */ }
            }
            recarregarGaveta().then(abrir);
          }

          /* ---------------------------------------------------------------
             Combo. A oferta da loja deixou de ser um produto "kit": o add posta
             as camisetas AVULSAS e uma Shopify Function desconta o slot e zera o
             brinde. Quem converte é `combo-cart-sync`, que já roda em toda a loja
             e reescreve `/cart/add` quando vê `_kit_variant_id` nas linhas — ele
             troca por `_combo_id` e anexa a carteira sozinho.

             Por isso NÃO montamos aqui o brinde nem o id do combo: só traduzimos
             a combinação escolhida nas variantes avulsas certas. Se eles mudarem
             o desconto ou o brinde, a página acompanha sem tocar em nada.

             Se a tradução falhar por qualquer motivo, `body` continua sendo o
             FormData de antes: a compra nunca fica bloqueada por causa disto. */
          var corpo = dados, cabecalhos = { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' };
          var itensCombo = montarCombo(dados.get('quantity'));
          if (itensCombo) {
            window.__kitExplodeLastQty = itensCombo.kits;   /* o script lê daqui quantos brindes anexar */
            corpo = JSON.stringify({
              items: itensCombo.itens.map(function (it) {
                return { id: it.id, quantity: it.quantity, properties: it.properties };
              }),
              sections: dados.get('sections') ? String(dados.get('sections')).split(',') : undefined,
              sections_url: window.location.pathname
            });
            cabecalhos = { 'Content-Type': 'application/json', 'Accept': 'application/javascript' };
          }

          fetch(raiz_url + 'cart/add.js', {
            method: 'POST',
            headers: cabecalhos,
            body: corpo
          })
            .then(function (r) { return r.json(); })
            .then(function (json) {
              if (json.status) {                     /* erro da Shopify */
                if (ctaTxt) ctaTxt.textContent = json.description || 'Não foi possível adicionar';
                return;
              }
              abrirGaveta(json);
            })
            .catch(function () {
              /* rede caiu. NÃO navegar: o item pode já ter entrado e o cliente
                 perderia a página. Só devolve o botão e avisa. */
              if (ctaTxt) ctaTxt.textContent = 'Tente de novo';
            })
            .then(function () {
              if (cta) { cta.disabled = false; cta.removeAttribute('aria-busy'); }
              if (ctaTxt) ctaTxt.textContent = textoCta;
            });
        });
      }

      /* O link ao lado do rótulo. Ele deixou de ser a porta do provador: essa porta
         é a faixa abaixo do seletor, que é onde o olho para. Aqui fica a tabela —
         consulta, não decisão. O destino é setting, para trocar sem mexer no código. */
      var linkTam = raiz.querySelector('[data-mp-sizebay]');
      if (linkTam) {
        var acaoLink = linkTam.getAttribute('data-mp-sizebay') || 'tabela';
        linkTam.addEventListener('click', function () {
          if (acaoLink === 'provador') abrirProvador();
          else abrirTabela();
        });
      }

      /* Prazo de entrega: duas datas a partir de HOJE, no fuso de quem está lendo.
         `{de}` e `{ate}` são trocados no texto vindo do personalizador. */
      var elEntrega = raiz.querySelector('[data-mp-entrega]');
      if (elEntrega) {
        (function () {
          /* Dia ÚTIL, não dia corrido — é assim que a página atual deles conta, e as duas
             precisam prometer a mesma data para o A/B comparar página, não oferta.
             `setHours(12)` antes de somar: no horário de verão a meia-noite escorrega
             para o dia anterior e a data sai um dia menor. */
          var uteis = elEntrega.getAttribute('data-uteis') === '1';
          var dias = function (n) {
            var d = new Date(); d.setHours(12, 0, 0, 0);
            if (uteis) {
              var somados = 0;
              while (n > somados) {
                d.setDate(d.getDate() + 1);
                var s = d.getDay();
                if (s !== 0 && s !== 6) somados++;
              }
            } else {
              d.setDate(d.getDate() + n);
            }
            return d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' });
          };
          var de = dias(parseInt(elEntrega.getAttribute('data-de'), 10) || 2);
          var ate = dias(parseInt(elEntrega.getAttribute('data-ate'), 10) || 6);
          var alvo = elEntrega.querySelector('.sola-mp__entrega-1');
          if (alvo) {
            alvo.innerHTML = alvo.textContent
              .replace('{de}', '<b>' + de + '</b>')
              .replace('{ate}', '<b>' + ate + '</b>');
          }
          elEntrega.hidden = false;
        })();
      }

      /* galeria: miniatura troca a foto grande */
      var minis = raiz.querySelectorAll('[data-mp-mini]');
      var principal = raiz.querySelector('.sola-mp__principal img');
      var itens = raiz.querySelectorAll('.sola-mp__item img');
      for (var m = 0; minis.length > m; m++) {
        (function (btn, idx) {
          btn.addEventListener('click', function () {
            for (var k = 0; minis.length > k; k++) minis[k].removeAttribute('aria-current');
            btn.setAttribute('aria-current', 'true');
            var fonte = itens[idx] || btn.querySelector('img');
            if (principal && fonte) {
              principal.src = fonte.currentSrc || fonte.src;
              if (fonte.srcset) principal.srcset = fonte.srcset;
            }
          });
        })(minis[m], m);
      }

      /* pontinhos acompanham o arrasto da tira */
      var tira = raiz.querySelector('[data-mp-tira]');
      var pontos = raiz.querySelector('[data-mp-pontos]');
      if (tira && pontos && pontos.children.length) {
        tira.addEventListener('scroll', function () {
          var largura = tira.scrollWidth / pontos.children.length;
          var i = Math.round(tira.scrollLeft / largura);
          if (i > pontos.children.length - 1) i = pontos.children.length - 1;
          for (var k = 0; pontos.children.length > k; k++) {
            pontos.children[k].className = (k === i) ? 'on' : '';
          }
        }, { passive: true });
      }
    }

    /* O cabeçalho da loja é sticky. Sem isto a galeria grudada entra por baixo dele. */
    function ajustarTopo() {
      /* O cabeçalho da loja são DOIS elementos grudados (barra de aviso + header).
         Medir a altura de um só erra por ~35px — o que vale é a BASE do conjunto. */
      var altura = 0;
      var cands = document.querySelectorAll('header, .header-wrapper, .shopify-section-header, .announcement-bar, [class*="header"], [class*="announcement"]');
      for (var i = 0; cands.length > i; i++) {
        var c = getComputedStyle(cands[i]);
        if (c.position !== 'sticky' && c.position !== 'fixed') continue;
        var r = cands[i].getBoundingClientRect();
        if (r.height < 4 || r.height > 220) continue;
        if (r.top > 90) continue;
        if (r.bottom > altura) altura = r.bottom;
      }
      var lista = document.querySelectorAll('.sola-mp');
      for (var k = 0; lista.length > k; k++) {
        var folga = parseInt(lista[k].getAttribute('data-mp-folga'), 10) || 34;
        lista[k].style.setProperty('--mp-topo', (altura ? Math.round(altura + folga) : 96 + folga) + 'px');
      }
    }


    /* ---------------------------------------------------------------------
       Prazo. UM relógio só, compartilhado pelo popup e pela barra de aviso.

       O prazo mora no localStorage, não na memória da página: refresh não
       devolve 15:00. O popup que a loja usa hoje reseta a cada carga — é
       exatamente isso que entrega que o número é enfeite. Aqui, se a pessoa
       voltar em 3 minutos, o relógio marca 12.

       A barra de aviso é do header group, compartilhada com a loja inteira.
       Não se edita aquele arquivo: a gente toma a barra por JS, e este JS só
       existe onde esta seção está. Fora desta página nada muda. Ao zerar, o
       conteúdo original volta — inclusive o frete grátis.
       --------------------------------------------------------------------- */
    function criarPrazo() {
      var raiz = document.querySelector('.sola-mp[data-prazo-min]');
      if (!raiz) return null;
      var min = parseInt(raiz.getAttribute('data-prazo-min'), 10) || 0;
      if (0 >= min) return null;

      var chave = raiz.getAttribute('data-prazo-chave') || 'sola-prazo';
      var teste = !!document.querySelector('[data-cap-teste]');
      var fim = 0;
      try { fim = parseInt(localStorage.getItem(chave), 10) || 0; } catch (e) {}
      /* O modo de teste faz o POPUP reaparecer a cada refresh — mas não mexe no relógio.
         Antes zerava junto, e o efeito era o refresh devolver 15:00: exatamente o defeito
         do popup da loja que a gente estava corrigindo. Só reinicia se já venceu. */
      if (!fim || (teste && 0 >= fim - Date.now()) || fim - Date.now() > min * 60000) {
        fim = Date.now() + min * 60000;
        try { localStorage.setItem(chave, String(fim)); } catch (e) {}
      }

      var reinicia = raiz.getAttribute('data-prazo-reinicia') === '1';
      var ouvintes = [], zerou = false;
      function resta() { return Math.max(0, fim - Date.now()); }
      function dois(n) { return (10 > n ? '0' : '') + n; }
      function pintar() {
        var s = Math.floor(resta() / 1000);
        var mm = dois(Math.floor(s / 60)), ss = dois(s % 60);
        var a = document.querySelectorAll('[data-prazo-mm]'), b = document.querySelectorAll('[data-prazo-ss]');
        for (var i = 0; a.length > i; i++) a[i].textContent = mm;
        for (var j = 0; b.length > j; j++) b[j].textContent = ss;
        if (!zerou && 0 >= resta()) {
          zerou = true;
          for (var k = 0; ouvintes.length > k; k++) { try { ouvintes[k](); } catch (e) {} }
          /* Reinicia sozinho. Sem isto o relógio morre em 00:00 e fica assim até alguém
             recarregar — e um contador parado em zero desmente a própria oferta, que é o
             defeito que a gente estava corrigindo no popup da loja.
             A ordem importa: os ouvintes rodam ANTES (o 'retravar' apaga a chave do
             navegador), e só então o novo prazo é gravado por cima. */
          if (reinicia) {
            fim = Date.now() + min * 60000;
            try { localStorage.setItem(chave, String(fim)); } catch (e) {}
            zerou = false;
          }
        }
      }
      pintar();
      setInterval(pintar, 500);
      return {
        resta: resta,
        pintar: pintar,
        aoZerar: function (fn) { if (zerou) fn(); else ouvintes.push(fn); }
      };
    }
    /* Criado na carga, como sempre foi. Se o script rodar ANTES do HTML da secao
       existir, `criarPrazo` devolve null aqui — e o `iniciar()`, que so roda com o
       DOM pronto, tenta de novo. Sem isso, um unico null no momento errado matava o
       relogio da pagina inteira em silencio: o cartao ficava em "--:--", a barra do
       topo saia na primeira linha de `assumirBarra` e o popup de saida escondia o
       contador. O `prazo_min` sempre esteve certo (15) — quebrava era a ordem. */
    var Prazo = criarPrazo();

    /* Barra de aviso. O relógio não SUBSTITUI o conteúdo: ele entra por cima, varrendo
       da esquerda para a direita, e o "FRETE GRÁTIS ACIMA DE R$ 500" fica visível à
       frente da varredura até ser coberto.

       Feito com `clip-path: inset(0 100% 0 0)` animado até `inset(0)`. É a única forma
       que revela sem mover nada: largura animada empurraria o texto, e `transform`
       arrastaria a capa inteira em vez de descobri-la.

       Capa sobreposta em vez de troca de innerHTML também resolve a volta: ao zerar,
       basta varrer de volta e remover — o conteúdo original nunca foi tocado.

       Tudo com !important: o esquema de cores do tema declara fundo e cor com
       !important, e inline puro perde — o sintoma é a barra continuar cinza. */
    function assumirBarra(animar) {
      if (!Prazo || 0 >= Prazo.resta()) return;
      var raiz = document.querySelector('.sola-mp[data-prazo-barra]');
      if (!raiz) return;
      var barra = document.querySelector('.announcement-bar');
      if (!barra) return;
      var util = barra.closest ? barra.closest('.utility-bar') : null;
      if (!util || util.getAttribute('data-sola-tomada')) return;
      util.setAttribute('data-sola-tomada', '1');
      try { localStorage.setItem(raiz.getAttribute('data-prazo-chave') + '-barra', '1'); } catch (e) {}

      var rotulo = raiz.getAttribute('data-prazo-rotulo') || 'OFERTA EXCLUSIVA';
      var marca = getComputedStyle(raiz).getPropertyValue('--mp-marca') || '#F4762F';
      var dur = raiz.getAttribute('data-prazo-varrida') || '850';

      if (getComputedStyle(util).position === 'static') util.style.setProperty('position', 'relative');

      var capa = document.createElement('div');
      capa.setAttribute('data-sola-capa', '1');
      capa.style.cssText = 'position:absolute;inset:0;z-index:3;display:flex;align-items:center;'
        + 'justify-content:center;background:#141413;overflow:hidden;'
        + '-webkit-clip-path:inset(0 100% 0 0);clip-path:inset(0 100% 0 0);'
        /* De volta à curva original: acelera no começo e assenta no fim. Testamos
           `linear` e uma curva de entrada; esta foi a que ficou. */
        + 'transition:clip-path ' + dur + 'ms cubic-bezier(.62,.02,.34,1),'
        + '-webkit-clip-path ' + dur + 'ms cubic-bezier(.62,.02,.34,1)';
      capa.innerHTML =
        '<p style="margin:0;display:flex;align-items:center;justify-content:center;gap:9px;'
        + 'font-size:12px;letter-spacing:.1em;text-transform:uppercase;font-weight:700;'
        + 'color:#fff !important;line-height:1;white-space:nowrap">'
        + '<span style="color:#fff !important">' + rotulo + '</span>'
        + '<span style="color:#fff !important;opacity:.35">&middot;</span>'
        + '<span style="color:' + marca + ' !important;font-variant-numeric:tabular-nums;'
        + 'font-feature-settings:&quot;tnum&quot; 1;letter-spacing:.04em">'
        + '<b data-prazo-mm>--</b>:<b data-prazo-ss>--</b></span>'
        + '</p>';
      util.appendChild(capa);
      Prazo.pintar();

      if (animar === false) {
        capa.style.transition = 'none';
        capa.style.webkitClipPath = capa.style.clipPath = 'inset(0)';
      } else {
        /* dois quadros: o navegador precisa pintar o estado fechado antes de animar */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            capa.style.webkitClipPath = capa.style.clipPath = 'inset(0)';
          });
        });
      }

      Prazo.aoZerar(function () {
        capa.style.webkitClipPath = capa.style.clipPath = 'inset(0 0 0 100%)';   /* sai pela direita */
        util.removeAttribute('data-sola-tomada');
        try { localStorage.removeItem(raiz.getAttribute('data-prazo-chave') + '-barra'); } catch (e) {}
        setTimeout(function () { if (capa.parentElement) capa.parentElement.removeChild(capa); }, parseInt(dur, 10) + 60);
      });
    }

    /* Captura de e-mail. Regras, em ordem de importância:
       1) nunca aparece antes de a pessoa ver a oferta;
       2) nunca trava a rolagem;
       3) some para sempre depois de fechada ou enviada;
       4) não aparece para quem já colocou no carrinho — a essa altura já ganhamos. */
    function iniciarCaptura() {
      var cap = document.querySelector('[data-cap]');
      if (!cap || cap.getAttribute('data-cap-pronto')) { assumirBarra(); return; }
      cap.setAttribute('data-cap-pronto', '1');

      /* ══ MODO "POPUP DO CLIENTE" ══
         Enquanto o fluxo do WhatsApp não estiver resolvido do nosso lado, quem capta é o
         formulário do Klaviyo deles — que já funciona inteiro. O nosso fica no DOM,
         escondido, e nada dele roda. A única coisa nossa que continua: quando o popup
         deles FECHA, a barra do topo assume com o relógio, que é o gesto que a gente
         desenhou para esse momento. */
      if (cap.getAttribute('data-cap-deles') === '1') {
        var idDeles = cap.getAttribute('data-cap-kl-form');
        if (!idDeles) { assumirBarra(); return; }
        try { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', idDeles]); } catch (e) {}
        var viuDeles = false, encerrado = false;
        function fechouDeles() {
          if (encerrado) return;
          encerrado = true;
          try { obsDeles.disconnect(); } catch (e) {}
          document.documentElement.style.overflow = '';   /* o popup deles trava a rolagem */
          assumirBarra(true);
        }
        /* "sumiu do DOM" é o sinal de fechamento: o Klaviyo remove a camada inteira.
           Também vale se ela continuar no DOM mas invisível. */
        var obsDeles = new MutationObserver(function () {
          var fk = document.querySelector('form.klaviyo-form');
          if (fk) { viuDeles = true; return; }
          if (viuDeles) fechouDeles();
        });
        obsDeles.observe(document.body, { childList: true, subtree: true });
        var vigia = setInterval(function () {
          var fk = document.querySelector('form.klaviyo-form');
          if (fk) { viuDeles = true; if (fk.offsetParent === null) fechouDeles(); }
          else if (viuDeles) fechouDeles();
          if (encerrado) clearInterval(vigia);
        }, 600);
        /* se o formulário deles nunca aparecer, a barra assume sozinha e a página não
           fica devendo o relógio */
        setTimeout(function () { if (!viuDeles) { clearInterval(vigia); fechouDeles(); } }, 25000);
        return;
      }

      var chave = cap.getAttribute('data-cap-chave') || 'sola-cap';
      var teste = cap.getAttribute('data-cap-teste') === '1';   /* ignora tudo e mostra sempre */
      var raizPrazo = document.querySelector('.sola-mp[data-prazo-min]');
      var liberado = false;                                     /* já mandou o e-mail */
      function jaFoi() { if (teste) return false; try { return localStorage.getItem(chave) === '1'; } catch (e) { return false; } }
      function marcar() { if (teste) return; try { localStorage.setItem(chave, '1'); } catch (e) {} }

      /* volta do envio do formulário nativo da Shopify */
      if (/customer_posted=true/.test(window.location.search)) {
        var ok = cap.querySelector('[data-cap-ok]'), fm = cap.querySelector('[data-cap-form]');
        if (ok && fm) { fm.hidden = true; ok.hidden = false; }
        cap.removeAttribute('hidden');
        cap.setAttribute('data-visivel', '1');
        marcar();
        setTimeout(function () { cap.removeAttribute('data-visivel'); assumirBarra(); }, 6000);
        return;
      }
      if (jaFoi()) { assumirBarra(); return; }

      /* `|| 35` engolia o ZERO: quem configurava "aparecer na entrada" recebia
         silenciosamente 35% de rolagem e 20 segundos de espera, e o popup nunca vinha.
         Zero é uma configuração legítima, não ausência de configuração. */
      var precisaScroll = parseInt(cap.getAttribute('data-cap-scroll'), 10);
      if (isNaN(precisaScroll)) precisaScroll = 35;
      var espera = parseInt(cap.getAttribute('data-cap-espera'), 10);
      if (isNaN(espera)) espera = 20;
      espera = espera * 1000;
      if (teste) { precisaScroll = 0; espera = 0; }
      var desde = Date.now();
      var mostrada = false;

      function temNoCarrinho() {
        var b = document.querySelector('.cart-count-bubble, [class*="cart-count"]');
        return b && /[1-9]/.test(b.textContent || '');
      }
      function avaliar() {
        if (mostrada || jaFoi()) return;
        if (!teste && temNoCarrinho()) return;
        var alt = document.documentElement.scrollHeight - window.innerHeight;
        var pct = alt > 0 ? (window.pageYOffset / alt) * 100 : 0;
        if (pct >= precisaScroll && Date.now() - desde >= espera) {
          /* Não abrir com buraco. O Klaviyo pode levar segundos para desenhar o campo
             — na máquina do cliente chegou a OITO. Aqui a gente espera ele ficar pronto
             antes de mostrar o cartão, com teto de 6s para nunca travar a captação por
             causa de um formulário que não veio. */
          if (embedId) {
            var jaTem = cap.querySelector('.klaviyo-form-' + embedId + ' form');
            if (!jaTem) {
              if (!avaliar._esperaEmbed) avaliar._esperaEmbed = Date.now();
              /* 10s: o cliente relatou 8 segundos numa máquina com cache frio, e um teto
                 menor faria o popup abrir justamente sem o campo — encurtando o buraco em
                 vez de eliminá-lo. */
              if (10000 > Date.now() - avaliar._esperaEmbed) return;
              /* Esgotado o prazo, o formulário dele não vem. Em vez de abrir um cartão
                 com um vazio no meio, a gente usa o NOSSO formulário, que está aqui no
                 DOM desde sempre. A captação acontece de todo jeito. */
              var meu = cap.querySelector('[data-cap-form]');
              var caixaKl = cap.querySelector('.sola-cap__embed');
              if (meu && meu.hasAttribute('hidden')) {
                meu.removeAttribute('hidden');
                if (caixaKl) caixaKl.style.display = 'none';
                cap.setAttribute('data-cap-reserva', '1');
              }
            }
          }
          mostrada = true;
          cap.removeAttribute('hidden');
          /* dois quadros: o navegador precisa pintar o estado inicial antes da transição */
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { cap.setAttribute('data-visivel', '1'); travar(true); montarEmbed(); });
          });
        }
      }
      window.addEventListener('scroll', avaliar, { passive: true });
      setInterval(avaliar, 250);   /* barato, e é o que decide quando o cartão abre */

      var ehCentro = cap.className.indexOf('--centro') >= 0;
      function travar(v) {
        if (!ehCentro) return;
        document.documentElement.style.overflow = v ? 'hidden' : '';
      }
      function fechar() {
        if (!cap.hasAttribute('data-visivel')) return;
        /* Marca a hora do fechamento. O popup de SAÍDA lê isto e se cala por um tempo:
           quem acabou de deixar o e-mail e fechou a tela de obrigado estava sendo
           recebido, no mesmo segundo, por outro popup dizendo "não vá embora". */
        try { window.__solaCapFechouEm = Date.now(); } catch (e) {}
        cap.removeAttribute('data-visivel'); travar(false); marcar();
        setTimeout(function () { cap.hidden = true; }, 500);
        assumirBarra();                          /* o relógio continua na barra */
      }
      cap.addEventListener('click', function (e) { if (e.target === cap) fechar(); });  /* só o fundo */
      document.addEventListener('sola:fechar-sobreposicoes', fechar);
      var x = cap.querySelector('[data-cap-fechar]');
      if (x) x.addEventListener('click', fechar);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });
      /* Envio por fetch, não POST nativo. O formulário de cliente da Shopify recarrega
         a página e volta na âncora do próprio formulário — que fica no rodapé. Era isso
         que jogava a pessoa lá para baixo depois de deixar o e-mail: não era rolagem
         nossa, era navegação. Sem recarga, ela continua exatamente onde estava. */
      /* ══════════════════════════════════════════════════════════════════════════
         MODO "FORMULÁRIO": em vez de imitar o que o formulário do cliente manda, a
         gente USA o formulário dele — carregado escondido — e só digita nele.

         Por que isto é melhor que imitar: o formulário do Klaviyo faz dezenas de
         coisas que só aparecem quando faltam (evento de gatilho, opt-in do formulário,
         analytics, versão do formulário, consentimento com origem). Passei a noite
         descobrindo essas coisas uma a uma. Aqui não há o que descobrir: quem executa
         é o código deles, então o resultado é igual por construção.

         A pessoa continua vendo só o nosso popup.
         ══════════════════════════════════════════════════════════════════════════ */
      var modoForm = cap.getAttribute('data-cap-kl-modo') === 'formulario';
      var klForm = null;

      /* Esconder por seletor não funcionou: a camada do Klaviyo é uma pilha de divs com
         classes geradas, e a de cima interceptava os cliques do NOSSO popup. Então subo
         a partir do formulário até o elemento que é filho do <body> e escondo AQUELE,
         com estilo inline — sem depender de adivinhar seletor.
         Fora da tela, e não `display:none`: escondido de verdade, o Klaviyo entende que
         o formulário não está visível e recusa o envio. */
      function esconderKl() {
        var f = document.querySelector('form.klaviyo-form');
        if (!f) return;
        var raiz = f;
        while (raiz.parentElement && raiz.parentElement !== document.body) raiz = raiz.parentElement;
        if (raiz.getAttribute('data-sola-oculto')) return;
        raiz.setAttribute('data-sola-oculto', '1');
        raiz.style.cssText += ';position:fixed !important;left:-99999px !important;top:0 !important;' +
          'width:390px !important;height:700px !important;opacity:0.01 !important;' +
          'pointer-events:none !important;z-index:-1 !important;visibility:visible !important';
        /* o formulário deles trava a rolagem da página ao abrir; como ele está oculto,
           quem manda na rolagem continua sendo o nosso popup */
        document.documentElement.style.overflow = 'hidden';
      }

      function abrirKlOculto() {
        if (!modoForm) return;
        var id = cap.getAttribute('data-cap-kl-form');
        if (!id) return;
        esconderKl();
        try { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', id]); } catch (e) {}
        var obs = new MutationObserver(function () {
          var f = document.querySelector('form.klaviyo-form');
          if (f) { klForm = f; esconderKl(); }
        });
        obs.observe(document.body, { childList: true, subtree: true });
        /* o observador fica: a cada troca de etapa o Klaviyo remonta a camada, e ela
           voltaria a cobrir a tela */
        var reforco = setInterval(esconderKl, 400);
        setTimeout(function () { clearInterval(reforco); obs.disconnect(); }, 120000);
      }

      /* Campos do Klaviyo são React: mexer no `.value` direto não registra. Tem de ser
         pelo setter nativo do protótipo, seguido do evento de input. */
      function digitar(el, valor) {
        if (!el) return false;
        var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
        if (setter && setter.set) setter.set.call(el, valor); else el.value = valor;
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      function klCampo(tipos) {
        var f = klForm || document.querySelector('form.klaviyo-form');
        if (!f) return null;
        var ins = f.querySelectorAll('input');
        for (var i = 0; ins.length > i; i++) {
          if (tipos.indexOf(ins[i].type) > -1 && ins[i].offsetParent !== null) return ins[i];
        }
        for (var j = 0; ins.length > j; j++) if (tipos.indexOf(ins[j].type) > -1) return ins[j];
        return null;
      }

      function klEnviar(valor, tipos) {
        var f = klForm || document.querySelector('form.klaviyo-form');
        if (!f) return false;
        var campo = klCampo(tipos);
        if (!campo || !digitar(campo, valor)) return false;
        var bt = f.querySelector('button[type="submit"]') || f.querySelector('button');
        if (!bt) return false;
        /* `.click()` sozinho não bastou: o React do Klaviyo escuta a sequência de
           ponteiro. Mandamos a sequência inteira, e o `click` por último. */
        setTimeout(function () {
          try {
            ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (t) {
              var ev = t.indexOf('pointer') === 0
                ? new PointerEvent(t, { bubbles: true, cancelable: true, pointerId: 1, isPrimary: true })
                : new MouseEvent(t, { bubbles: true, cancelable: true, view: window });
              bt.dispatchEvent(ev);
            });
          } catch (e) { try { bt.click(); } catch (e2) {} }
        }, 200);
        return true;
      }

      /* ─── uma porta só para o Klaviyo ───
         A etapa 1 assina o e-mail; a etapa 2 volta aqui com o MESMO e-mail mais o
         telefone. Mandar o e-mail de novo é o que faz o Klaviyo reconhecer o perfil e
         só acrescentar o SMS, em vez de criar um segundo. */
      function klaviyo(email, fone) {
        var emp = cap.getAttribute('data-cap-kl-empresa');
        var lst = cap.getAttribute('data-cap-kl-lista');
        if (!emp || !lst || !email) return;
        var perfil = { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
        if (fone) {
          perfil.phone_number = fone;
          perfil.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
          /* Canal separado no Klaviyo. O formulário do cliente coleta só SMS, então por
             padrão a gente faz igual. Se o fluxo do WhatsApp exigir o consentimento
             próprio, é este interruptor — e aí o aviso legal precisa citar WhatsApp. */
          if (cap.getAttribute('data-cap-kl-whats') === '1') {
            perfil.subscriptions.whatsapp = { marketing: { consent: 'SUBSCRIBED' } };
          }
        }
        /* `custom_source` é o mesmo texto do formulário DELES de propósito. Se algum
           fluxo lá dentro filtrar por origem, um valor novo faria o fluxo simplesmente
           não disparar — e a gente descobriria pela ausência de e-mail, que é o pior
           jeito de descobrir. A atribuição da nossa página vai numa propriedade à
           parte, que não interfere em gatilho nenhum. */
        var fonte = cap.getAttribute('data-cap-kl-fonte');
        var origem = cap.getAttribute('data-cap-kl-origem');
        var formId = cap.getAttribute('data-cap-kl-form');
        var formVer = parseInt(cap.getAttribute('data-cap-kl-formver'), 10);

        /* ─── por que tem tanta coisa aqui ───
           Espelhei o que o formulário do cliente manda, capturado da rede. Assinar a
           lista NÃO dispara fluxo: o gatilho é o evento **"Form submitted by profile"**
           com o `form_id`, que vai junto no mesmo pedido. Sem ele, o contato entra na
           lista, recebe a confirmação de assinatura e mais nada — foi exatamente o que
           acontecia: e-mail chegava, WhatsApp não. */
        perfil.properties = {
          $consent_method: 'Klaviyo Form',
          $timezone_offset: -3
        };
        if (formId) {
          perfil.properties.$consent_form_id = formId;
          if (!isNaN(formVer)) perfil.properties.$consent_form_version = formVer;
        }
        if (origem) perfil.properties.origem_lp = origem;

        var pacote = {
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: perfil } },
              custom_source: fonte || undefined
            },
            relationships: { list: { data: { type: 'list', id: lst } } }
          }
        };
        if (formId) {
          var evProps = { form_id: formId, page: window.location.href,
                          device_type: (720 > window.innerWidth ? 'mobile' : 'desktop'),
                          $use_ip: true, $is_session_activity: true, $is_client_event: false };
          if (!isNaN(formVer)) evProps.form_version_id = formVer;
          var ev = {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Form submitted by profile', service: 'api' } } },
              profile: { data: { type: 'profile', attributes: { email: email, properties: { $email: email } } } },
              properties: evProps
            },
            relationships: { form: { data: { id: formId, type: 'form' } } }
          };
          if (!isNaN(formVer)) ev.relationships['form-version'] = { data: { id: formVer, type: 'form-version' } };
          pacote.data.attributes.events = { data: [ev] };
          pacote.data.relationships.form = { data: { type: 'form', id: formId } };
          if (!isNaN(formVer)) pacote.data.relationships['form-version'] = { data: { type: 'form-version', id: formVer } };
        }
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(emp), {
          method: 'POST',
          /* A VERSÃO IMPORTA. Em `2024-10-15` o Klaviyo recusa o corpo inteiro com
             "'subscriptions' is not a valid field for the resource 'profile'" — 400, e o
             lead se perde. Em `2025-01-15` o mesmo corpo passa. Conferido contra a conta
             deles usando uma lista inexistente, que valida o formato sem inscrever
             ninguém: a única reclamação que sobra é "List not found". */
          headers: { 'Content-Type': 'application/json', 'revision': '2025-01-15' },
          body: JSON.stringify(pacote)
        }).then(function (r) {
          cap.setAttribute(fone ? 'data-cap-kl-fone' : 'data-cap-kl-email', String(r.status));
          pintarDiag();
        }).catch(function () {
          cap.setAttribute(fone ? 'data-cap-kl-fone' : 'data-cap-kl-email', 'erro');
          pintarDiag();
        });
      }

      /* "(11) 98765-4321" → "+5511987654321". O Klaviyo só aceita E.164, e número
         malformado faz a chamada INTEIRA ser recusada — por isso, na dúvida, devolve
         vazio e o perfil segue só com o e-mail. */
      function paraE164(v, ddi) {
        var d = String(v || '').replace(/\D/g, '');
        var c = String(ddi || '55').replace(/\D/g, '') || '55';
        if (!d) return '';
        d = d.replace(/^0+/, '');                       /* "0 11 9..." é hábito de telefone fixo */
        if (d.indexOf(c) === 0 && d.length > c.length + 7) d = d.slice(c.length);   /* já veio com DDI */
        if (7 > d.length || d.length > 13) return '';   /* fora disso não é número: manda só o e-mail */
        return '+' + c + d;
      }

      /* Em tema NÃO PUBLICADO a Shopify não cria cliente por formulário — medido: o
         formulário de newsletter do próprio tema falha no preview e funciona no ar, com
         o mesmo código. Então aqui o "falhou" não quer dizer nada, e a tarja precisa
         avisar isso, senão vira alarme falso a cada teste. */
      var temaPreview = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');

      /* Escreve os três status na tela quando o modo de teste está ligado. */
      function pintarDiag() {
        var d = cap.querySelector('[data-cap-diag]');
        if (!d) return;
        function v(x) { return cap.getAttribute(x) || '…'; }
        var linha = 'Shopify ' + v('data-cap-shopify') +
                    ' · Klaviyo e-mail ' + v('data-cap-kl-email') +
                    ' · Klaviyo fone ' + v('data-cap-kl-fone');
        if (temaPreview) linha += '  ⚠ tema de preview: a Shopify não cria cliente aqui — só depois de publicado';
        d.textContent = linha;
      }

      /* No modo embed não há nada nosso para enviar: o formulário do Klaviyo cuida de
         tudo. A gente só garante que ele seja montado quando o popup abre — se a div
         nasceu escondida, o Klaviyo pode ter passado por ela sem renderizar. */
      /* ⚠️ O formulário só é montado QUANDO O POPUP ABRE.
         Montando na carga da página, ele nascia dentro de um popup ainda fechado: o
         container é `position:fixed; inset:0` com opacidade 0, então o formulário ficava
         INVISÍVEL (opacidade não se sobrescreve de dentro) e mesmo assim CLICÁVEL, porque
         o Klaviyo põe `pointer-events` nos próprios elementos. Uma camada de captura
         transparente por cima da página inteira. */
      var embedId = cap.getAttribute('data-cap-embed');
      /* ── acompanhar as etapas do formulário do Klaviyo ──
         Ele troca de tela por conta própria; a nossa moldura precisa acompanhar, senão
         a pessoa vê a copy do e-mail enquanto digita o telefone, e no fim recebe um
         "Thanks for subscribing" em inglês no meio do nosso popup. */
      function seguirEtapasEmbed() {
        var caixa = cap.querySelector('.sola-cap__embed');
        if (!caixa) return;
        var txt = cap.querySelector('[data-cap-cabeca] .sola-cap__texto');
        var textoEmail = txt ? txt.textContent : '';
        var textoTel = cap.getAttribute('data-cap-tel-texto') || '';
        function olhar() {
          /* Com o popup fechado o embed é `display:none`, então todo campo fica
             invisível e a checagem concluía "acabou" sozinha — marcando o fluxo como
             concluído sem ninguém ter preenchido nada. */
          if (!cap.hasAttribute('data-visivel')) { olhar._vazioDesde = 0; return; }
          /* Não depende do <form> existir: ao terminar, o Klaviyo às vezes REMOVE o
             formulário inteiro em vez de trocar o conteúdo dele. Exigir o form aqui
             fazia a checagem desistir justamente no momento que interessa. */
          var temTel = !!caixa.querySelector('input[type="tel"]');
          var temEmail = !!caixa.querySelector('input[type="email"]');
          /* Existe um `input[type=submit]` com display:none que NUNCA sai do DOM.
             Contá-lo como campo fazia a checagem achar que o formulário ainda estava
             lá, e a tela final nunca chegava. Só conta campo que a pessoa vê. */
          var temCampo = false;
          var listaC = caixa.querySelectorAll('input');
          for (var ci = 0; listaC.length > ci; ci++) {
            var tp = (listaC[ci].type || '').toLowerCase();
            if (tp === 'hidden' || tp === 'submit') continue;
            if (listaC[ci].offsetParent === null) continue;
            temCampo = true; break;
          }
          var dito = (caixa.textContent || '').trim();
          if (caixa.querySelector('form')) olhar._teveForm = true;
          /* O fim pode ser de dois jeitos: ele troca o formulário por uma mensagem, ou
             simplesmente ESVAZIA o contêiner. O segundo caso deixava o popup mostrando
             só o cabeçalho, sem nada embaixo. Guardar que já houve formulário é o que
             permite reconhecer os dois. */
          var temAlgo = olhar._teveForm || dito.length > 8;
          /* O Klaviyo também some com o formulário quando o envio FALHA, e a mensagem
             de erro fica no lugar. Sem esta guarda a gente mostrava "Pronto, obrigado!"
             para quem não conseguiu se inscrever — mentira na cara da pessoa. */
          var deuErro = /error|erro|try again|tente|inv[aá]lid|failed/i.test(dito);
          if (temTel && !temEmail && txt && textoTel) txt.textContent = textoTel;
          else if (temEmail && txt && textoEmail) txt.textContent = textoEmail;
          /* sem campo nenhum = ele chegou na tela de agradecimento dele.
             A nossa entra no lugar, com o logo e o botão que leva de volta à oferta. */
          /* ⚠️ Entre uma etapa e outra existe um instante SEM campo nenhum: o Klaviyo já
             tirou o e-mail e ainda não desenhou o telefone. Concluir ali pulava a etapa do
             WhatsApp direto para o agradecimento. Agora o vazio precisa DURAR: só depois
             de 2 segundos seguidos sem campo é que a gente aceita que acabou. */
          if (temTel) olhar._teveTel = true;
          if (temCampo) olhar._vazioDesde = 0;
          else if (!olhar._vazioDesde) olhar._vazioDesde = Date.now();
          /* A espera existe só para o vão ENTRE etapas. Depois que a etapa do telefone
             apareceu, ela é a última — some campo, acabou, e a tela de obrigado entra na
             hora. Esperar ali deixava o cartão dois segundos com só o relógio, que é
             exatamente o quadro que a gente não quer congelar. */
          var esperaMin = olhar._teveTel ? 0 : 2000;
          var vazioFirme = olhar._vazioDesde && (Date.now() - olhar._vazioDesde) >= esperaMin;

          if (!temCampo && vazioFirme && temAlgo && !deuErro && !cap.hasAttribute('data-cap-fim')) {
            cap.setAttribute('data-cap-fim', '1');
            var okF = cap.querySelector('[data-cap-ok]');
            var cabeca = cap.querySelector('[data-cap-cabeca]');
            if (okF) okF.hidden = false;
            if (cabeca) cabeca.hidden = true;
          }
        }
        new MutationObserver(olhar).observe(caixa, { childList: true, subtree: true });
        setInterval(olhar, 700);

        /* O jeito certo de saber que terminou: o próprio Klaviyo avisa. Adivinhar pelo
           DOM é frágil — ele remove o formulário tanto no sucesso quanto no erro. */
        document.addEventListener('klaviyoForms', function (ev) {
          var det = (ev && ev.detail) || {};
          if (det.formId && embedId && det.formId !== embedId) return;
          if (det.type !== 'submit') return;
          if (cap.hasAttribute('data-cap-fim')) return;
          cap.setAttribute('data-cap-fim', '1');
          var okF = cap.querySelector('[data-cap-ok]');
          var cabeca = cap.querySelector('[data-cap-cabeca]');
          if (okF) okF.hidden = false;
          if (cabeca) cabeca.hidden = true;
          marcar();
        });
      }

      function montarEmbed() {
        if (!embedId || montarEmbed._feito) return;
        montarEmbed._feito = true;
        seguirEtapasEmbed();
        /* Observador em vez de ronda: o formulário aparece de uma vez, e esperar até
           400ms para perceber era o que sobrava entre ele ficar pronto e o cartão abrir. */
        try {
          var caixaEsp = cap.querySelector('.klaviyo-form-' + embedId) || cap;
          var obsPronto = new MutationObserver(function () {
            var f = cap.querySelector('.klaviyo-form-' + embedId + ' form');
            if (!f) return;
            obsPronto.disconnect();
            try { avaliar(); } catch (e) {}
          });
          obsPronto.observe(caixaEsp, { childList: true, subtree: true });
        } catch (e) {}

        var tentou = 0;
        var acorda = setInterval(function () {
          tentou++;
          var alvo = cap.querySelector('.klaviyo-form-' + embedId);
          if (alvo && alvo.querySelector('form')) {
            clearInterval(acorda);
            /* Avisa na hora. Sem isto o popup esperava a próxima volta da verificação
               — o formulário ficava pronto em 1,2s e o cartão só abria em 2,5s. */
            try { avaliar(); } catch (e) {}
            return;
          }
          try { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', embedId]); } catch (e) {}
          if (tentou > 12) clearInterval(acorda);
        }, 400);   /* era 900ms: a ronda é barata e cada volta atrasa a abertura */
      }

      /* O formulário é montado JÁ NO CARREGAMENTO, não na abertura: o Klaviyo leva um
         instante para desenhar, e quem tem conexão mais lenta via o cartão abrir com um
         buraco onde deveria estar o campo. É seguro montar cedo porque o popup fechado
         é `display:none` e nada lá dentro recebe clique — as duas travas que a gente
         colocou depois do episódio do formulário invisível. */
      if (embedId) montarEmbed();

      abrirKlOculto();

      /* NOSSO formulário, não o do Klaviyo. Com o incorporado no cartão, um
         `querySelector('form')` solto pegava o DELE — e a gente saía pendurando os
         nossos ouvintes no formulário do cliente. */
      var f = cap.querySelector('[data-cap-form] form');
      if (f) {
        /* ─── por que NÃO é fetch ───
           A Shopify protege os formulários de `{% form %}` contra robô, e o token dessa
           proteção é injetado no submit DE VERDADE. Mandando por fetch o pedido chega
           sem token e a loja recusa — foi o que devolvia 400/403 e fazia o cliente nunca
           aparecer em Clientes. Aqui o envio é o nativo, só que mirando um iframe
           escondido: o navegador posta de verdade, a proteção roda, e a página não sai
           do lugar, então o popup continua nas três etapas. */
        var quadro = document.getElementById('sola-cap-envio');
        if (!quadro) {
          quadro = document.createElement('iframe');
          quadro.id = 'sola-cap-envio';
          quadro.name = 'sola-cap-envio';
          quadro.setAttribute('aria-hidden', 'true');
          quadro.setAttribute('tabindex', '-1');
          quadro.style.cssText = 'position:absolute;width:0;height:0;border:0;left:-9999px;top:-9999px';
          document.body.appendChild(quadro);
        }
        /* no elemento, não no submit: assim qualquer caminho de envio — inclusive um
           `form.submit()` disparado por script do tema — cai no iframe */
        f.target = 'sola-cap-envio';

        var enviando = false;
        function avancar() {
          var ok = cap.querySelector('[data-cap-ok]'), fm = cap.querySelector('[data-cap-form]');
          var passoTel = cap.querySelector('[data-cap-tel-passo]');
          if (fm && passoTel) { fm.hidden = true; passoTel.hidden = false; }
          else if (ok && fm) {
            fm.hidden = true; ok.hidden = false;
            var cb = cap.querySelector('[data-cap-cabeca]');
            if (cb) cb.hidden = true;
          }
          var envio = f.querySelector('button[type="submit"]');
          if (envio) envio.disabled = false;
          enviando = false;
        }

        /* O iframe é do mesmo domínio, então dá para ler o resultado: a Shopify volta
           com `customer_posted=true` quando criou o cliente. */
        function lerQuadro() {
          try {
            var u = (quadro.contentWindow && quadro.contentWindow.location.href) || '';
            if (!u || u === 'about:blank') return null;
            if (/customer_posted=true/.test(u)) return 'CRIADO';
            var corpo = (quadro.contentDocument && quadro.contentDocument.body && quadro.contentDocument.body.innerText) || '';
            if (/verified|captcha|robot|verifica/i.test(corpo)) return 'BLOQUEADO pela loja';
            if (/invalid parameters/i.test(corpo)) return 'RECUSADO (parâmetros)';
            return 'respondeu, sem confirmação';
          } catch (e) {
            /* Cross-origin: não dá para ler. Já vi este caso terminar com o cliente
               criado normalmente, então nem "enviado" nem "bloqueado" — a única
               afirmação honesta é que daqui não dá para saber. Quem responde é a tela
               de Clientes. */
            return 'resposta ilegível — confira em Clientes';
          }
        }
        quadro.addEventListener('load', function () {
          var r = lerQuadro();
          if (r) { cap.setAttribute('data-cap-shopify', r); pintarDiag(); }
          /* a resposta pode chegar em dois passos (POST → redirect) */
          /* POST → redirect chega em dois tempos; e em rede lenta pode demorar mais */
          [1500, 4000].forEach(function (t) {
            setTimeout(function () {
              var r2 = lerQuadro();
              if (r2) { cap.setAttribute('data-cap-shopify', r2); pintarDiag(); }
            }, t);
          });
        });

        function enviar(ev) {
          var campo = f.querySelector('input[type="email"]');
          if (campo && !campo.checkValidity()) {
            if (campo.reportValidity) campo.reportValidity();
            if (ev) ev.preventDefault();
            return;
          }
          if (enviando) { if (ev) ev.preventDefault(); return; }
          enviando = true;
          marcar(); liberado = true;

          var envio = f.querySelector('button[type="submit"]');
          if (envio) envio.disabled = true;

          /* o e-mail entra no Klaviyo já nesta etapa: se a pessoa abandonar a etapa do
             WhatsApp, o lead continua sendo nosso */
          if (campo) {
            var emailValor = campo.value;
            var pelaForma = modoForm && klEnviar(emailValor, ['email', 'text']);
            cap.setAttribute('data-cap-kl-email', pelaForma ? 'form' : '…');
            if (!pelaForma) klaviyo(emailValor, '');
            else {
              /* Rede de segurança: se o formulário deles não concluir em 7s — botão
                 continua desabilitado, que é o sinal de travado — a gente manda pela
                 API assim mesmo. Pior caso, o contato entra duas vezes e o Klaviyo
                 junta pelo e-mail. Melhor um perfil duplicado que um lead perdido. */
              setTimeout(function () {
                var ff = klForm || document.querySelector('form.klaviyo-form');
                var bt = ff && (ff.querySelector('button[type="submit"]') || ff.querySelector('button'));
                if (bt && bt.disabled) {
                  cap.setAttribute('data-cap-kl-email', 'form travou → API');
                  klaviyo(emailValor, '');
                }
              }, 7000);
            }
            pintarDiag();
          }

          /* IMPORTANTE: nada de preventDefault aqui. O submit precisa acontecer de
             verdade para a proteção da Shopify entrar. A tela troca em seguida. */
          setTimeout(avancar, 250);
        }

        f.addEventListener('submit', enviar);
      }

      /* ─── etapa 2: o WhatsApp ───
         Enviar e pular levam ao mesmo lugar. O botão nunca trava a pessoa nesta tela:
         ela já cumpriu a parte dela na etapa 1. */
      (function () {
        var passoTel = cap.querySelector('[data-cap-tel-passo]');
        if (!passoTel) return;
        var campoTel = cap.querySelector('[data-cap-tel]');
        var okTel = cap.querySelector('[data-cap-ok]');
        var indo = false;
        function seguir(mandar) {
          if (indo) return;
          indo = true;
          if (mandar && campoTel) {
            var email = f && f.querySelector('input[type="email"]');
            var ddi = cap.querySelector('[data-cap-ddi]');
            var fone = paraE164(campoTel.value, ddi ? ddi.value : '55');
            if (fone) {
              var pelaForma = modoForm && klEnviar(fone, ['tel', 'text']);
              cap.setAttribute('data-cap-kl-fone', pelaForma ? 'form' : '…');
              if (!pelaForma && email && email.value) klaviyo(email.value, fone);
              else if (pelaForma && email && email.value) {
                setTimeout(function () {
                  var ff = klForm || document.querySelector('form.klaviyo-form');
                  var bt = ff && (ff.querySelector('button[type="submit"]') || ff.querySelector('button'));
                  if (bt && bt.disabled) {
                    cap.setAttribute('data-cap-kl-fone', 'form travou → API');
                    klaviyo(email.value, fone);
                  }
                }, 7000);
              }
              pintarDiag();
            }
          }
          passoTel.hidden = true;
          var cabeca = cap.querySelector('[data-cap-cabeca]');
          if (cabeca) cabeca.hidden = true;        /* a tela final tem o logo e a mensagem dela */
          if (okTel) okTel.hidden = false;
        }
        var bt = cap.querySelector('[data-cap-tel-enviar]');
        if (bt) bt.addEventListener('click', function () { seguir(true); });
        if (campoTel) campoTel.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); seguir(true); }
        });
      })();

      /* "Aproveitar a oferta" só fecha: a pessoa já está na página da oferta. */
      var aproveitar = cap.querySelector('[data-cap-aproveitar]');
      if (aproveitar) aproveitar.addEventListener('click', fechar);

      /* Ao zerar: ou a página volta a pedir o e-mail (o relógio passa a ser verdade,
         porque a gente cumpre), ou não acontece nada além da barra voltar ao normal.
         Quem já deu o e-mail, ou já tem algo no carrinho, nunca é retravado. */
      if (Prazo && raizPrazo && raizPrazo.getAttribute('data-prazo-acao') === 'retravar') {
        Prazo.aoZerar(function () {
          if (liberado || temNoCarrinho()) return;
          try { localStorage.removeItem(chave); localStorage.removeItem(chave + '-barra'); } catch (e) {}
          cap.removeAttribute('hidden');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { cap.setAttribute('data-visivel', '1'); travar(true); montarEmbed(); });
          });
        });
      }
    }


    /* ---------------------------------------------------------------------
       Popup de recuperação. Dispara por PROXIMIDADE de um alvo — a seção de
       garantia, no fim da página — e não por tempo nem por saída de mouse.

       Por que assim: quem chega ao fim e não comprou já leu tudo. Não falta
       informação, falta motivo para decidir agora. E `mouseleave` não existe
       em toque, que é de onde vem a maior parte deste tráfego.

       IntersectionObserver com rootMargin positivo no topo faz o disparo
       acontecer ANTES de o alvo entrar na tela — "um pouquinho antes da
       garantia" é literalmente isso.

       Guarda de sessão, não de sempre: quem voltar amanhã vê de novo.
       --------------------------------------------------------------------- */
    function iniciarRecuperacao() {
      var rec = document.querySelector('[data-rec]');
      if (!rec || rec.getAttribute('data-rec-pronto')) return;
      rec.setAttribute('data-rec-pronto', '1');

      var teste = rec.getAttribute('data-rec-teste') === '1';
      var chave = rec.getAttribute('data-rec-chave') || 'sola-rec';
      /* localStorage, não sessionStorage: "só uma vez" é uma vez por pessoa, não uma
         vez por aba. Com sessão, voltar no dia seguinte mostrava de novo. */
      function jaViu() { if (teste) return false; try { return localStorage.getItem(chave) === '1'; } catch (e) { return false; } }
      function marcar() { if (teste) return; try { localStorage.setItem(chave, '1'); } catch (e) {} }
      if (jaViu()) return;

      var cap = document.querySelector('[data-cap]');
      function temNoCarrinho() {
        var b = document.querySelector('.cart-count-bubble, [class*="cart-count"]');
        return b && /[1-9]/.test(b.textContent || '');
      }

      var aberta = false, agendada = false;
      var espera = parseInt(rec.getAttribute('data-rec-espera'), 10);
      if (isNaN(espera)) espera = 1800;

      function abrir() {
        if (aberta || jaViu()) return;
        /* nunca por cima da captura de e-mail, e nunca para quem já resolveu */
        if (cap && cap.hasAttribute('data-visivel')) return;
        /* Nem logo depois dela: 5 segundos de trégua. O problema nunca foi o popup de
           saída existir para quem deixou o e-mail — era ele chegar NO MESMO SEGUNDO em
           que a pessoa fechou a tela de obrigado. Passados 5 segundos, o gesto de sair
           é um gesto novo, e ele volta a fazer sentido. */
        try {
          if (window.__solaCapFechouEm && 5000 > (Date.now() - window.__solaCapFechouEm)) return;
        } catch (e) {}
        if (!teste && rec.getAttribute('data-rec-pula-carrinho') === '1' && temNoCarrinho()) { marcar(); return; }
        aberta = true; marcar();

        /* o relógio só entra se ainda houver prazo: 00:00 desmente a mensagem */
        var caixa = rec.querySelector('[data-rec-prazo]');
        if (caixa) {
          if (Prazo && Prazo.resta() > 0) { caixa.hidden = false; Prazo.pintar(); }
          else caixa.hidden = true;
        }

        rec.removeAttribute('hidden');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            rec.setAttribute('data-visivel', '1');
            document.documentElement.style.overflow = 'hidden';
          });
        });
      }

      /* Aparecer no mesmo quadro em que a seção entra na tela dá susto: a pessoa ainda
         está lendo o que acabou de chegar. A espera é o tempo de ela pousar o olho. */
      function agendar() {
        if (agendada || aberta || jaViu()) return;
        agendada = true;
        setTimeout(abrir, espera);
      }
      function fechar() {
        if (!rec.hasAttribute('data-visivel')) return;
        rec.removeAttribute('data-visivel');
        document.documentElement.style.overflow = '';
        setTimeout(function () { rec.hidden = true; }, 500);
      }

      rec.addEventListener('click', function (e) { if (e.target === rec) fechar(); });
      document.addEventListener('sola:fechar-sobreposicoes', fechar);
      var x = rec.querySelector('[data-rec-fechar]');
      if (x) x.addEventListener('click', fechar);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });

      var botao = rec.querySelector('[data-rec-ir-btn]');
      if (botao) botao.addEventListener('click', function () {
        var alvo = document.querySelector(rec.getAttribute('data-rec-ir') || '#modulo');
        fechar();
        if (!alvo) return;
        /* espera o overflow do <html> voltar: rolar com a página travada não anda */
        setTimeout(function () {
          var topo = alvo.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mp-topo'), 10) || 96);
          window.scrollTo({ top: topo, behavior: 'smooth' });
        }, 60);
      });

      var modo = rec.getAttribute('data-rec-modo') || 'saida';
      var alvo = modo === 'saida' ? null : document.querySelector(rec.getAttribute('data-rec-alvo') || '');
      if (modo !== 'saida' && alvo && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (ent, obs) {
          if (!ent[0].isIntersecting) return;
          obs.disconnect(); agendar();
        }, { rootMargin: '0px 0px -20% 0px' }).observe(alvo);
      } else if (modo !== 'saida') {
        /* sem alvo na página, cai para profundidade de rolagem */
        var fundo = parseInt(rec.getAttribute('data-rec-fundo'), 10) || 85;
        var olhar = function () {
          var alt = document.documentElement.scrollHeight - window.innerHeight;
          if (alt > 0 && (window.pageYOffset / alt) * 100 >= fundo) { window.removeEventListener('scroll', olhar); agendar(); }
        };
        window.addEventListener('scroll', olhar, { passive: true });
      }

      /* Intenção de saída. O cursor sair pelo TOPO é o único sinal honesto: sair pelos
         lados é trocar de aba na barra lateral, pelo rodapé nem é sair. `relatedTarget`
         nulo confirma que o ponteiro deixou o documento, e não entrou num iframe.
         Sem equivalente em toque — o gatilho de rolagem cobre o mobile. */
      if (rec.getAttribute('data-rec-saida') === '1') {
        document.addEventListener('mouseout', function (e) {
          if (e.relatedTarget || e.clientY > 8) return;
          abrir();                        /* aqui não espera: a pessoa já está de saída */
        });
      }
    }

    /* ---------------------------------------------------------------------
       Provador virtual. Quem manda na loja inteira é o prescript.js da própria
       Sizebay, e ele foi escrito para PDP:

         getPermalink(): `https://minimalclub.com.br/${document.querySelector('product-info')?.getAttribute('data-product-id')}`
         getAnchor():    'fieldset:has(input[name*="Tamanho"])'

       Nesta página não existe <product-info> — quem fornecia era a seção
       featured-product, que desligamos. O permalink virava ".../undefined" e a
       implantação morria calada: os scripts carregam, o CSS carrega, e nenhum
       botão aparece. Também não existe <fieldset> em volta dos tamanhos.

       Em vez de fabricar um <product-info> falso (é custom element do Dawn, tem
       connectedCallback e efeito colateral), chamamos a API pública deles com o
       payload correto. Roda depois, então sobrescreve o que o prescript fez.

       O permalink é `dominio/<id numérico>`, NÃO a URL do produto: mandar
       `/products/<handle>` faz a Sizebay responder "Product not found." — o
       catálogo deles é indexado pelo id que o <product-info> expõe na PDP.
       --------------------------------------------------------------------- */
    /* Os dois gatilhos do provador (a faixa e o link do rótulo) precisam da mesma
       busca, e ela não é trivial: a Sizebay injeta `vfr__button` e `chart__button`
       com texto variável. Preferimos os que caíram DENTRO da nossa seção; sem eles,
       vale qualquer um da página (o featured-product abaixo também os recebe). */
    function acharBotao(tipo) {
      var raiz = document.querySelector('.sola-mp');
      var seletor = tipo === 'tabela'
        ? '[class*="chart__button"],[class*="vfr__button"]'
        : '[class*="vfr__button"],[class*="chart__button"]';
      var re = tipo === 'tabela' ? /tabela|chart|medida/i : /provador|vfr|fitting|prova/i;
      var listas = [];
      if (raiz) listas.push(raiz.querySelectorAll(seletor));
      listas.push(document.querySelectorAll(seletor));
      for (var l = 0; listas.length > l; l++) {
        var alvos = listas[l];
        for (var z = 0; alvos.length > z; z++) {
          if (re.test((alvos[z].textContent || '') + ' ' + alvos[z].className)) return alvos[z];
        }
        if (alvos.length && tipo !== 'tabela') return alvos[0];
      }
      return null;
    }
    function acharBotaoProvador() { return acharBotao('provador'); }
    function abrirProvador() { var b = acharBotao('provador'); if (b) b.click(); return !!b; }

    /* A tabela: primeiro a nossa, que é HTML puro e sobrevive ao webview do Instagram;
       o modal do app só entra se o acordeão não existir nesta página. */
    function abrirTabela() {
      var acc = document.querySelector('.sola-mp__acc--grade');
      if (acc) {
        acc.open = true;
        var topo = 0, mp = document.querySelector('.sola-mp');
        if (mp) topo = parseInt(getComputedStyle(mp).getPropertyValue('--mp-topo'), 10) || 0;
        window.scrollTo({ top: acc.getBoundingClientRect().top + window.pageYOffset - topo - 12, behavior: 'smooth' });
        return true;
      }
      var b = acharBotao('tabela');
      if (b) { b.click(); return true; }
      return false;
    }

    function iniciarProvador() {
      var raiz = document.querySelector('.sola-mp[data-sb-permalink]');
      if (!raiz || raiz.getAttribute('data-sb-pronto')) return;
      var permalink = raiz.getAttribute('data-sb-permalink');
      if (!permalink) return;
      raiz.setAttribute('data-sb-pronto', '1');

      var tentativas = 0, feito = false;
      function implantar() {
        if (feito) return;                          /* o evento e a chamada direta se cruzam */
        if (!window.Sizebay || typeof window.Sizebay.Implantation !== 'function') {
          if (++tentativas > 40) return;            /* 40 × 250ms = 10s e desiste */
          return setTimeout(implantar, 250);
        }
        feito = true;
        window.Sizebay.Implantation({
          permalink: permalink,
          tenantId: parseInt(raiz.getAttribute('data-sb-tenant'), 10) || 1269,
          buttons: { order: [{ name: 'vfr', text: null }, { name: 'chart', text: null }],
                     position: 'before', class: 'vfr__button--clean' },
          anchor: { web: '.sola-mp__sizebay-anchor', mobile: '.sola-mp__sizebay-anchor' },
          lang: 'br',
          recommendation: { default: 'Recomendamos o tamanho {size}',
                            simplified: 'Recomendamos o tamanho {size}' }
        });
      }
      window.addEventListener('sizebay:loaded', implantar);
      implantar();

      /* A recomendação. A Sizebay escreve "Recomendamos o tamanho XGG" solto no DOM,
         sem classe que dê para mirar com confiança — e o texto aparece só depois de a
         pessoa terminar o provador, que é dentro de um iframe. Então a gente observa a
         subárvore e reage ao TEXTO, não à marcação: se eles trocarem as classes
         amanhã, continua funcionando. */
      var bloco = raiz.querySelector('[data-mp-vfr]');
      if (!bloco) return;
      var elTam = bloco.querySelector('[data-mp-vfr-tam]');
      var btnUsar = bloco.querySelector('[data-mp-vfr-usar]');
      var btnAbrir = bloco.querySelector('[data-mp-vfr-abrir]');
      var RE = /recomendamos\s+o\s+tamanho\s+([\wÀ-ú]{1,5})/i;

      /* O convite só entra quando os botões do app existem de verdade. Eles são
         escondidos por CSS nesta seção (o gatilho visível é nosso), então o que se
         procura é a presença no DOM, não a visibilidade. A Sizebay demora — daí a
         espera curta e repetida, que desiste depois de 20s em vez de ficar rodando. */
      var esperas = 0;
      function procurarConvite() {
        if (bloco.getAttribute('data-estado') === 'resultado') return;
        if (acharBotaoProvador()) { bloco.hidden = false; return; }
        if (++esperas > 50) return;                 /* 50 × 400ms = 20s */
        setTimeout(procurarConvite, 400);
      }
      procurarConvite();

      if (btnAbrir) btnAbrir.addEventListener('click', function () { abrirProvador(); });

      function radiosTamanho() {
        return raiz.querySelectorAll('input[type="radio"][name*="Tamanho"]');
      }
      function conferirIgual(tam) {
        var rs = radiosTamanho();
        for (var i = 0; rs.length > i; i++) {
          if (rs[i].checked && rs[i].value.trim().toUpperCase() === tam) { bloco.setAttribute('data-igual', '1'); return; }
        }
        bloco.removeAttribute('data-igual');
      }
      function mostrar(tam) {
        elTam.textContent = tam;
        bloco.hidden = false;
        bloco.setAttribute('data-estado', 'resultado');
        bloco.setAttribute('data-tam', tam);
        conferirIgual(tam);
      }
      if (btnUsar) btnUsar.addEventListener('click', function () {
        var tam = bloco.getAttribute('data-tam'), rs = radiosTamanho();
        for (var i = 0; rs.length > i; i++) {
          if (rs[i].value.trim().toUpperCase() === tam) {
            rs[i].click();                       /* click, não checked: precisa disparar o change */
            conferirIgual(tam);
            return;
          }
        }
      });
      raiz.addEventListener('change', function () {
        var tam = bloco.getAttribute('data-tam');
        if (tam) conferirIgual(tam);
      });

      /* ATENÇÃO: este observador escreve DENTRO da árvore que ele observa. Sem
         desligar antes de escrever, cada escrita dispara uma nova varredura, que
         escreve de novo — laço infinito, aba travada, "a página não responde".
         Foi exatamente o que aconteceu ao fechar o provador. Duas travas:
         desligar o observador enquanto mexe, e não mexer se nada mudou. */
      var obsRec = null, ultimoTam = null;
      function ligarObs() {
        if (obsRec) obsRec.observe(raiz, { childList: true, subtree: true, characterData: true });
      }
      function varrer() {
        /* Procura o elemento MAIS INTERNO cujo texto casa. Exigir `children.length === 0`
           não funciona: eles escrevem "Recomendamos o tamanho <b>XGG</b>", então o
           elemento que tem a frase inteira sempre tem um filho. */
        var todos = raiz.querySelectorAll('p,div,span,b,strong,em,small'), interno = null;
        for (var i = 0; todos.length > i; i++) {
          var e = todos[i];
          if (e === bloco || bloco.contains(e) || e.contains(bloco)) continue;
          if (!RE.test(e.textContent || '')) continue;
          if (!interno || interno.contains(e)) interno = e;
        }
        if (!interno) return;
        var m = RE.exec(interno.textContent || '');
        if (!m) return;

        /* sobe enquanto o pai não acrescenta nada além da frase, para esconder a caixa
           inteira e não deixar um invólucro vazio ocupando altura */
        var caixa = interno;
        while (caixa.parentElement && caixa.parentElement !== raiz &&
               !caixa.parentElement.contains(bloco) &&
               caixa.parentElement.textContent.trim() === caixa.textContent.trim()) {
          caixa = caixa.parentElement;
        }
        var tam = m[1].toUpperCase();
        if (tam === ultimoTam && caixa.style.display === 'none') return;   /* nada novo */
        ultimoTam = tam;

        if (obsRec) obsRec.disconnect();          /* silencia antes de escrever */
        try {
          caixa.style.setProperty('display', 'none', 'important');
          mostrar(tam);
        } finally {
          ligarObs();                             /* e volta a ouvir, sem os registros da própria escrita */
        }
      }
      obsRec = new MutationObserver(varrer);
      varrer();
      ligarObs();
    }

    /* ---------------------------------------------------------------------
       Brinde coerente com o carrinho.

       O `combo-cart-sync` ANEXA o brinde a cada add, mas nada o remove quando a
       composição desmancha. Dois defeitos medidos no carrinho real:
         · tirar as camisetas deixava a carteira sozinha — e aí ela deixa de ser
           brinde e passa a CObRAR R$ 147,90, porque a Function só zera com a
           composição completa;
         · adicionar de novo somava outra carteira, e ficavam duas.

       A regra aqui é uma só: **uma carteira por composição fechada**. Zero peças,
       zero carteiras. Oito peças, duas. É recalculado a cada mudança do carrinho,
       então vale para qualquer caminho — o nosso botão, a lixeira da gaveta, o
       mais/menos, ou o carrinho vindo de outra aba.
       --------------------------------------------------------------------- */
    function sincronizarBrinde() {
      var raiz = document.querySelector('.sola-mp[data-mp-brinde]');
      if (!raiz) return Promise.resolve();
      if (sincronizarBrinde._rodando) return Promise.resolve();
      var idBrinde = String(raiz.getAttribute('data-mp-brinde') || '');
      var slot = String(raiz.getAttribute('data-mp-slot') || '').split(',').filter(Boolean);
      var porComposicao = parseInt(raiz.getAttribute('data-mp-combo-qtd'), 10) || 4;
      if (!idBrinde || !slot.length) return Promise.resolve();

      sincronizarBrinde._rodando = true;
      var raiz_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(raiz_url + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var pecas = 0, tem = 0, variante = null;
          (c.items || []).forEach(function (it) {
            var pid = String(it.product_id);
            if (pid === idBrinde) { tem += it.quantity; variante = it.variant_id; }
            else if (slot.indexOf(pid) >= 0) pecas += it.quantity;
          });
          var deveria = Math.floor(pecas / porComposicao);
          if (!variante || tem === deveria) return null;
          /* A linha do brinde some AGORA, antes da ida e volta ao servidor. Sem isto
             ela ficava dois ou três segundos na tela exibindo o preço cheio, como se a
             pessoa fosse pagar pela carteira — o pior quadro possível para congelar. */
          if (tem > deveria) {                 /* vai sair brinde: esconde já */
            var gavJa = document.querySelector('cart-drawer');
            if (gavJa) gavJa.setAttribute('data-sola-brinde-saindo', '1');
          }
          /* `update.js` por VARIANTE, não `change.js` por linha.
             O tema remove itens por índice de linha; quando a nossa correção
             mexia no carrinho ao mesmo tempo, os índices dele saíam do lugar e a
             remoção falhava com "O parâmetro line é inválido" — foi o erro que
             apareceu ao tirar a última camiseta. `updates` é por id de variante:
             não existe índice para desencontrar, e repetir a mesma chamada não
             muda o resultado. */
          var updates = {};
          updates[String(variante)] = deveria;
          /* Pedimos as seções junto e mandamos o tema redesenhar com o resultado.
             É o passo que faltava: a gaveta do tema opera por ÍNDICE de linha, e
             quando a carteira sai do carrinho a camiseta muda de índice. Sem o
             redesenho, o próximo clique no menos mandava o índice velho e a
             Shopify respondia 422 — "O parâmetro line é inválido". */
          return fetch(raiz_url + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              updates: updates,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (json) {
              var gav = document.querySelector('cart-drawer');
              try {
                if (gav && typeof gav.renderContents === 'function') gav.renderContents(json);
              } catch (e) { /* o tema falhou ao redesenhar: o carrinho já está certo */ }
              if (gav) gav.removeAttribute('data-sola-brinde-saindo');
              /* Carrinho zerado: o tema mostra o "seu carrinho está vazio" pela classe
                 `is-empty`, e o redesenho por seção não a devolve — era daí que vinha a
                 gaveta em branco. Repomos a classe e, se ainda assim ficar sem conteúdo,
                 buscamos a seção inteira, que é o que o tema faz ao carregar. */
              try {
                if (gav && json && json.item_count === 0) {
                  gav.classList.add('is-empty');
                  var vazio = gav.querySelector('.drawer__inner-empty');
                  if (!vazio) {
                    fetch(raiz_url + '?sections=cart-drawer')
                      .then(function (r) { return r.json(); })
                      .then(function (sec) {
                        var html = sec && sec['cart-drawer'];
                        if (!html) return;
                        var molde = document.createElement('div');
                        molde.innerHTML = html;
                        var nova = molde.querySelector('cart-drawer');
                        if (nova) { gav.innerHTML = nova.innerHTML; gav.classList.add('is-empty'); }
                      }).catch(function () {});
                  }
                } else if (gav) {
                  gav.classList.remove('is-empty');
                }
              } catch (e) {}
              /* Limpa o aviso de erro da gaveta DEPOIS de um ajuste nosso, porque
                 nesse ponto o carrinho acabou de ser conferido e está coerente.
                 ⚠️ Não cobre o caso de esvaziar o carrinho até zero pelo botão de
                 menos: ali o aviso é do próprio tema e aparece igual na loja no ar,
                 sem nada nosso — medido. Corrigir aquilo é mexer no tema. */
              try {
                var avisos = gav ? gav.querySelectorAll('.cart-item__error-text, [id*="CartDrawer-LineItemError"], [id*="Cart-LineItemError"]') : [];
                for (var i = 0; avisos.length > i; i++) avisos[i].textContent = '';
              } catch (e) {}
              return json;
            });
        })
        .catch(function () { return null; })
        .then(function (mudou) {
          sincronizarBrinde._rodando = false;
          return mudou;
        });
    }

    /* Marca a linha do brinde na gaveta para o CSS poder tratá-la como brinde, e
       não como mais um item. A gaveta é recriada pelo tema a cada mudança, então
       a marcação é reaplicada junto com a vigilância — e é idempotente. */
    function marcarBrindeNaGaveta() {
      var raiz = document.querySelector('.sola-mp[data-mp-brinde]');
      var gav = document.querySelector('cart-drawer');
      if (!raiz || !gav) return;
      var handle = raiz.getAttribute('data-mp-brinde-handle');
      if (!handle) return;
      var linhas = gav.querySelectorAll('.cart-item, .drawer__cart-item, tr[class*="cart-item"]');
      for (var i = 0; linhas.length > i; i++) {
        var a = linhas[i].querySelector('a[href*="/products/"]');
        var eh = a && a.getAttribute('href').indexOf('/products/' + handle) >= 0;
        if (eh) {
          linhas[i].setAttribute('data-sola-brinde', '1');
        } else linhas[i].removeAttribute('data-sola-brinde');
      }
    }

    /* Roda a cada mudança da gaveta. O observador é desligado enquanto a própria
       correção acontece, senão a escrita dispara nova varredura e vira laço. */
    function vigiarBrinde() {
      if (!document.querySelector('.sola-mp[data-mp-brinde]')) return;
      /* A gaveta NÃO é o único lugar onde se tira item: existe a página /cart, e lá
         nada disto rodava — a carteira ficava sozinha até um refresh. Era essa a
         lacuna. Agora os dois lugares são vigiados pelo mesmo código. */
      var alvos = [];
      var gv = document.querySelector('cart-drawer');
      if (gv) alvos.push(gv);
      var pag = document.querySelector('cart-items, #main-cart-items, .cart-items, form[action$="/cart"]');
      if (pag) alvos.push(pag);
      for (var v = 0; alvos.length > v; v++) vigiarUm(alvos[v]);
    }

    function vigiarUm(gav) {
      if (!gav || gav.getAttribute('data-sola-brinde-vigia')) return;
      gav.setAttribute('data-sola-brinde-vigia', '1');

      /* ─── esconder pela INTENÇÃO, não pela resposta ───
         Esperar o servidor confirmar deixava a carteira dois segundos sozinha na tela,
         exibindo o preço cheio como se a pessoa fosse pagar por ela. Agora, no instante
         em que alguém clica para remover ou diminuir uma camiseta, a linha do brinde já
         sai — a correção de verdade vem logo atrás e confirma. Se por algum motivo não
         vier, o atributo é removido no fim e a linha volta. */
      gav.addEventListener('click', function (e) {
        var alvo = e.target && e.target.closest &&
          e.target.closest('cart-remove-button, .cart-remove-button, a[href*="quantity=0"], button[name="minus"], .quantity__button');
        if (!alvo) return;
        var linha = alvo.closest('.cart-item');
        if (!linha) return;
        var raizB = document.querySelector('.sola-mp[data-mp-brinde]');
        var handle = raizB && raizB.getAttribute('data-mp-brinde-handle');
        /* a própria linha do brinde não conta: quem some é ele */
        if (handle && linha.querySelector('a[href*="/products/' + handle + '"]')) return;
        gav.setAttribute('data-sola-brinde-saindo', '1');
      }, true);
      var pendente = null;
      var obs = new MutationObserver(function () {
        if (sincronizarBrinde._rodando) return;
        clearTimeout(pendente);
        marcarBrindeNaGaveta();
        /* 700ms sem novas mutações. A gaveta se redesenha em etapas quando o tema
           remove um item, e agir no meio disso é o que criava a corrida. */
        pendente = setTimeout(function () {
          sincronizarBrinde().then(function (mudou) {
            if (mudou) document.dispatchEvent(new CustomEvent('sola:brinde-ajustado'));
          });
        }, 260);   /* era 700ms: com o brinde já escondido, esperar tanto só atrasa */
      });
      obs.observe(gav, { childList: true, subtree: true });
      /* Uma passada na chegada: quem entra em /cart com o carrinho já incoerente — por
         ter mexido em outra aba, por exemplo — não precisa mexer em nada para consertar. */
      setTimeout(function () {
        if (sincronizarBrinde._rodando) return;
        marcarBrindeNaGaveta();
        sincronizarBrinde();
      }, 900);
    }

    /* O PRIMEIRO add.js depois de uma publicação leva ~1,1s porque a Shopify precisa
       renderizar a seção do carrinho do zero; os seguintes levam ~25ms. Medido: com um
       GET `?sections=cart-drawer` disparado antes, o primeiro add cai para 27ms.
       Roda ocioso, não compete com o carregamento da página, e não muda nada na tela. */
    function aquecerGaveta() {
      if (!document.querySelector('cart-drawer')) return;
      var raiz_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var vai = function () { fetch(raiz_url + '?sections=cart-drawer').catch(function () {}); };
      if ('requestIdleCallback' in window) requestIdleCallback(vai, { timeout: 3000 });
      else setTimeout(vai, 1200);
    }

    /* O título do item vem como "Camiseta Minimal - Compre 3 e leve 4 + Carteira",
       uma string só. Separar exige JS; o resto da gaveta é CSS porque o Dawn recria
       tudo a cada mudança de item e CSS sobrevive a isso. Este pedaço é reaplicado
       por observador, e é idempotente: se já separou, sai fora. */
    /* Upsell: imagem em resolução decente e carrossel que dá a volta.
       A imagem vem pedida em 200×200 e é desenhada em 56 — em tela retina isso é o
       limite, e de longe aparece serrilhado. A URL da CDN da Shopify aceita a largura
       por parâmetro, então dá para pedir maior sem tocar no snippet do tema. */
    function arrumarUpsell() {
      if (!document.querySelector('.sola-mp[data-mp-gaveta-estilo]')) return;

      var imgs = document.querySelectorAll('cart-drawer .cart-upsell__image img');
      for (var i = 0; imgs.length > i; i++) {
        var im = imgs[i];
        if (im.getAttribute('data-sola-nitida')) continue;
        var src = im.getAttribute('src') || '';
        if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) continue;
        var novo = src.replace(/([?&])width=\d+/, '$1width=440').replace(/([&?])height=\d+/, '$1height=440');
        if (novo === src) novo = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=440';
        im.setAttribute('data-sola-nitida', '1');
        im.removeAttribute('srcset');
        im.setAttribute('src', novo);
      }

      /* A largura dos <select> do upsell saía daqui (medirTexto/larguraDoSelect/
         medirSelect, removidos). Hoje quem mede é o PRÓPRIO componente, em
         assets/global.js (sizeSelects), pra toda a loja e não só nesta página.
         Manter as duas era o problema: as duas escreviam `style.width` no mesmo
         <select>, a de lá escrevia também o `flex` do <label> que embrulha o campo, e
         as medidas discordavam por uns pixels — o campo ficava de um tamanho e a caixa
         que o segura de outro, e o cartão quebrava. */

      /* Largura dos cartões. Em vez de calcular no papel quanto o texto ocupa, a gente
         PERGUNTA À PÁGINA: aplica uma largura, olha se algum título quebrou, e se
         quebrou alarga um degrau. Régua de texto errava — a altura do <h3> é a única
         fonte de verdade sobre quebra (contar `getClientRects` não serve: elemento de
         bloco devolve um retângulo só, mesmo com duas linhas de texto).
         Uma largura para todos, teto de 88% para o próximo continuar espiando. */
      var lista = document.querySelector('cart-drawer slider-component > ul');
      if (lista && lista.children.length) {
        var disp = lista.clientWidth - 28;
        var minL = Math.round(disp * 0.68), maxL = Math.round(disp * 0.88);

        function aplicarLargura(px) {
          for (var k = 0; lista.children.length > k; k++) {
            var li = lista.children[k];
            li.style.setProperty('flex', '0 0 ' + px + 'px', 'important');
            li.style.setProperty('width', px + 'px', 'important');
            li.style.setProperty('min-width', px + 'px', 'important');
            li.style.setProperty('max-width', px + 'px', 'important');
          }
        }
        function algoQuebrou() {
          var ts = lista.querySelectorAll('.cart-upsell__title');
          for (var i = 0; ts.length > i; i++) {
            var lh = parseFloat(getComputedStyle(ts[i]).lineHeight) || 17;
            if (ts[i].getBoundingClientRect().height > lh * 1.4) return true;
          }
          return false;
        }

        var largura = minL;
        aplicarLargura(largura);
        var voltas = 0;
        while (algoQuebrou() && maxL > largura && 8 > voltas) {
          largura = Math.min(maxL, largura + 16);
          aplicarLargura(largura);
          voltas++;
        }
      }

      var ul = document.querySelector('cart-drawer slider-component > ul');
      var prox = document.querySelector('cart-drawer .slider-button--next');
      var ant = document.querySelector('cart-drawer .slider-button--prev');
      if (!ul || !prox || !ant) return;
      function soltar() { prox.removeAttribute('disabled'); ant.removeAttribute('disabled'); }
      soltar();
      if (ul.getAttribute('data-sola-laco')) return;
      ul.setAttribute('data-sola-laco', '1');

      /* ── Navegação do upsell ───────────────────────────────────────────────
         Um índice, um trilho, três destinos possíveis. O laço é feito movendo o
         cartão de uma ponta para a outra no DOM e compensando o índice no mesmo
         quadro, sem transição — o olho não vê o remendo e a próxima puxada
         continua para o mesmo lado. */
      var idxU = 0, giro = 0, arrastandoU = false;
      function nU() { return ul.children.length; }
      function passoLargura() {
        var pri = ul.children[0];
        if (!pri) return 0;
        /* lê o vão do CSS em vez de repetir o número aqui: mudar o gap no estilo
           não pode desalinhar o passo */
        var vao = parseFloat(getComputedStyle(ul).columnGap || getComputedStyle(ul).gap) || 0;
        return pri.getBoundingClientRect().width + vao;
      }
      function posicionar(anim, extra) {
        ul.style.transition = anim ? 'transform .42s cubic-bezier(.22,.61,.36,1)' : 'none';
        ul.style.transform = 'translate3d(' + (-idxU * passoLargura() + (extra || 0)) + 'px,0,0)';
      }
      function numeroAtual() { var n = nU() || 1; return ((giro % n) + n) % n + 1; }
      function pintarContador() {
        var el = document.querySelector('cart-drawer .slider-counter--current');
        if (el && el.textContent != numeroAtual()) el.textContent = numeroAtual();
      }
      var alvoConta = document.querySelector('cart-drawer .slider-counter--current');
      if (alvoConta && !alvoConta.getAttribute('data-sola-conta')) {
        alvoConta.setAttribute('data-sola-conta', '1');
        new MutationObserver(pintarContador).observe(alvoConta, { childList: true, characterData: true, subtree: true });
      }

      /* Rotação por `order`, NUNCA movendo nós no DOM.
         Mover um <custom-cart-upsell> de lugar dispara disconnected/connectedCallback:
         o componente se reinicializa e passa a ter ouvintes de clique duplicados — era
         isso que fazia o botão de adicionar disparar dois adds. `order` muda só a ordem
         VISUAL do flex — o elemento continua conectado e intacto. */
      var desloc = 0;
      function aplicarOrdem() {
        var n = nU();
        for (var i = 0; n > i; i++) {
          ul.children[i].style.order = ((i - desloc) % n + n) % n;
        }
      }
      var animando = false;
      function passoU(dir) {
        if (2 > nU() || animando) return;
        animando = true;
        var dur = 420;
        if (dir > 0) {
          idxU = 1; posicionar(true);
          setTimeout(function () {
            desloc = (desloc + 1) % nU();
            aplicarOrdem();
            idxU = 0; posicionar(false);
            animando = false;
          }, dur);
        } else {
          desloc = (desloc - 1 + nU()) % nU();
          aplicarOrdem();
          idxU = 1; posicionar(false); void ul.offsetWidth;
          idxU = 0; posicionar(true);
          setTimeout(function () { animando = false; }, dur);
        }
        giro += dir;
        pintarContador();
      }
      aplicarOrdem();
      prox.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); passoU(1); }, true);
      ant.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); passoU(-1); }, true);

      /* arrasto com o dedo, mesma regra da galeria: um cartão por gesto */
      var ux0 = 0, uy0 = 0, ut0 = 0, udx = 0, udecidiu = false;
      ul.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        ux0 = e.touches[0].clientX; uy0 = e.touches[0].clientY;
        ut0 = Date.now(); udx = 0; arrastandoU = false; udecidiu = false;
      }, { passive: true });
      ul.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        var ax = e.touches[0].clientX - ux0, ay = e.touches[0].clientY - uy0;
        if (!udecidiu) {
          if (6 > Math.abs(ax) && 6 > Math.abs(ay)) return;
          udecidiu = true; arrastandoU = Math.abs(ax) > Math.abs(ay);
        }
        if (!arrastandoU) return;
        e.preventDefault();
        udx = ax;
        posicionar(false, udx);
      }, { passive: false });
      ul.addEventListener('touchend', function () {
        if (!arrastandoU) return;
        var dir = 0 > udx ? 1 : -1;
        var vel = Math.abs(udx) / Math.max(1, Date.now() - ut0);
        var passou = Math.abs(udx) > passoLargura() * 0.22 || vel > 0.45;
        arrastandoU = false; udx = 0;
        if (passou) passoU(dir); else posicionar(true);
      }, { passive: true });

      posicionar(false);
      pintarContador();
    }

    /* Copy do resumo. Os rótulos vêm do snippet do tema (arquivo compartilhado), então
       a troca é feita aqui, no cliente, e só nesta página. "Total de descontos" é
       linguagem de nota fiscal; "Você economiza" é a mesma informação virada para quem
       está decidindo. O percentual sai da divisão dos dois valores que já estão na tela
       — nada inventado. */
    function arrumarResumo() {
      var raizG = document.querySelector('.sola-mp[data-mp-gaveta-estilo]');
      if (!raizG) return;
      var rod = document.querySelector('cart-drawer .cart-drawer-footer-discounts-content');
      if (!rod) return;

      function trocar(sel, novo) {
        var p = rod.querySelector(sel);
        if (!p || !novo) return null;
        var s = p.querySelector('span');
        if (s && s.textContent.trim() !== novo) s.textContent = novo;
        return p;
      }
      trocar('.cart-drawer__foot_subtotal_without_discounts', raizG.getAttribute('data-res-sub'));
      var pTot = trocar('.cart-drawer__foot_total_pix', raizG.getAttribute('data-res-total'));
      var pEco = trocar('.cart-drawer__foot_total_discounts', raizG.getAttribute('data-res-eco'));

      /* percentual da economia, calculado dos números já exibidos */
      if (pEco && !pEco.querySelector('.sola-pct')) {
        var pSub = rod.querySelector('.cart-drawer__foot_subtotal_without_discounts span:last-child');
        var vEco = pEco.querySelector('span:last-child');
        function num(el) {
          if (!el) return 0;
          return parseFloat((el.textContent || '').replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
        }
        var a = Math.abs(num(pSub)), d = Math.abs(num(vEco));
        if (a > 0 && d > 0) {
          var pct = Math.round(d / a * 100);
          if (pct > 0 && 100 > pct) {
            var marca = document.createElement('span');
            marca.className = 'sola-pct';
            marca.textContent = ' · ' + pct + '%';
            vEco.appendChild(marca);
          }
        }
      }

      /* reasseguramento embaixo do botão */
      var ctas = document.querySelector('cart-drawer .cart__ctas');
      var texto = raizG.getAttribute('data-res-garantias');
      if (ctas && texto && !ctas.parentElement.querySelector('.sola-garantias')) {
        var linha = document.createElement('p');
        linha.className = 'sola-garantias';
        var partes = texto.split('|');
        var caminhao = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';
        /* o mesmo escudo da frase "Errou o tamanho? Troca grátis em 30 dias" da seção
           de caimento — dois lugares falando da mesma garantia usam o mesmo símbolo */
        var troca = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.4-3 8.3-7.5 9.5-4.5-1.2-7.5-5.1-7.5-9.5V6z"/><path d="M9 12l2.2 2.2L15.5 10"/></svg>';
        var html = '';
        for (var i = 0; partes.length > i; i++) {
          var txt = partes[i].trim();
          if (!txt) continue;
          /* o ícone segue o TEXTO, não a ordem: com um item só, escolher pelo índice
             mostrava o caminhão numa frase sobre troca */
          html += '<span>' + (/frete|entrega/i.test(txt) ? caminhao : troca) + '<b>' + txt + '</b></span>';
        }
        linha.innerHTML = html;
        ctas.parentElement.insertBefore(linha, ctas.nextSibling);
      }
    }

    /* Stories: troca os controles nativos pelos nossos e deixa o toque no vídeo
       dar play/pause, como a pessoa já espera de vídeo vertical. Só nesta página. */
    function arrumarStories() {
      /* sem Liquid aqui: o bloco {% javascript %} é servido como asset e não passa
         por Liquid — a chave sairia literal e o seletor quebraria. Não precisa de
         escopo: este arquivo só é carregado onde esta seção existe. */
      var pops = document.querySelectorAll('insta-stories-popup');
      for (var i = 0; pops.length > i; i++) {
        var pop = pops[i];
        if (pop.getAttribute('data-sola-pronto')) continue;
        var caixa = pop.querySelector('.blocks-videos__list-item--popup-video');
        var vid = caixa ? caixa.querySelector('video') : null;
        if (!vid) continue;
        pop.setAttribute('data-sola-pronto', '1');
        vid.removeAttribute('controls');
        vid.controls = false;
        vid.setAttribute('playsinline', '');

        var toque = document.createElement('div');
        toque.className = 'sola-st__toque';
        caixa.appendChild(toque);

        var ctrl = document.createElement('div');
        ctrl.className = 'sola-st__ctrl';
        var bPlay = document.createElement('button');
        bPlay.type = 'button'; bPlay.className = 'sola-st__btn';
        bPlay.setAttribute('aria-label', 'Pausar ou reproduzir');
        var bSom = document.createElement('button');
        bSom.type = 'button'; bSom.className = 'sola-st__btn';
        bSom.setAttribute('aria-label', 'Ligar ou desligar o som');
        ctrl.appendChild(bPlay); ctrl.appendChild(bSom);
        caixa.appendChild(ctrl);

        var iPlay = '<svg width="18" height="18" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';
        var iPause = '<svg width="18" height="18" viewBox="0 0 24 24"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg>';
        var iSom = '<svg width="18" height="18" viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 0 1 0 7" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>';
        var iMudo = '<svg width="18" height="18" viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9.5l5 5M21 9.5l-5 5" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round"/></svg>';

        (function (v, bp, bs, t) {
          function pintar() {
            bp.innerHTML = v.paused ? iPlay : iPause;
            bs.innerHTML = v.muted ? iMudo : iSom;
          }
          function alternar() { if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause(); }
          bp.addEventListener('click', function (e) { e.stopPropagation(); alternar(); });
          t.addEventListener('click', alternar);
          bs.addEventListener('click', function (e) {
            e.stopPropagation();
            v.muted = !v.muted;
            /* som só existe depois de um gesto; garantir que esteja tocando */
            if (!v.muted && v.paused) { var pr2 = v.play(); if (pr2 && pr2.catch) pr2.catch(function () {}); }
            pintar();
          });
          v.addEventListener('play', pintar);
          v.addEventListener('pause', pintar);
          v.addEventListener('volumechange', pintar);
          pintar();
        })(vid, bPlay, bSom, toque);
      }
    }

    /* Direção do deslize. O tema troca o `display` dos popups sem avisar, então a
       gente marca a direção no clique e carimba o popup que ficou visível logo depois. */
    var direcaoStory = 'baixo';
    function ligarDeslizeStories() {
      if (document.documentElement.getAttribute('data-sola-st-nav')) return;
      var alguma = document.querySelector('.blocks-videos__list-item--popup-next');
      if (!alguma) return;
      document.documentElement.setAttribute('data-sola-st-nav', '1');

      function carimbar() {
        setTimeout(function () {
          var pops = document.querySelectorAll('insta-stories-popup');
          for (var i = 0; pops.length > i; i++) {
            var visivel = getComputedStyle(pops[i]).display !== 'none';
            if (!visivel) { pops[i].removeAttribute('data-sola-entra'); continue; }
            pops[i].removeAttribute('data-sola-entra');
            void pops[i].offsetWidth;                 /* reinicia a animação */
            pops[i].setAttribute('data-sola-entra', direcaoStory);
          }
        }, 20);
      }
      document.addEventListener('click', function (e) {
        var alvo = e.target.closest ? e.target.closest('.blocks-videos__list-item--popup-next, .blocks-videos__list-item--popup-prev') : null;
        if (!alvo) return;
        direcaoStory = alvo.className.indexOf('next') >= 0 ? 'baixo' : 'cima';
        carimbar();
      }, true);
    }

    /* ------------------------------------------------------------------------
       Navegação do story: arrastar para cima vai para o próximo, para baixo volta,
       e a loja atrás fica parada.

       O popup não rola nada por dentro, então o toque nele estava sendo entregue à
       página — a pessoa tentava trocar de vídeo e a loja andava atrás. Duas travas,
       porque uma só não basta: `touch-action:none` no CSS impede o navegador de
       começar a rolagem antes de o JS ver o gesto, e `overflow:hidden` no <html>
       segura o resto (roda do mouse, teclado, barra de rolagem).

       A abertura é observada por atributo, não por clique: quem abre e fecha o popup
       é o app, e ele mexe em `class`, `active` e `style` sem avisar ninguém.
       ------------------------------------------------------------------------ */
    function ligarGestosStories() {
      var pops = document.querySelectorAll('insta-stories-popup');
      if (!pops.length || document.documentElement.getAttribute('data-sola-st-gesto')) return;
      document.documentElement.setAttribute('data-sola-st-gesto', '1');

      function abertoAgora() {
        var ps = document.querySelectorAll('insta-stories-popup');
        for (var i = 0; ps.length > i; i++) {
          if (getComputedStyle(ps[i]).display !== 'none') return ps[i];
        }
        return null;
      }

      var travado = false;
      function conferirTrava() {
        var tem = !!abertoAgora();
        if (tem === travado) return;
        travado = tem;
        if (tem) document.documentElement.setAttribute('data-sola-st-aberto', '1');
        else document.documentElement.removeAttribute('data-sola-st-aberto');
      }
      var obs = new MutationObserver(conferirTrava);
      for (var i = 0; pops.length > i; i++) {
        obs.observe(pops[i], { attributes: true, attributeFilter: ['class', 'active', 'style'] });
      }
      conferirTrava();

      function trocar(pop, adiante) {
        var bt = pop.querySelector(adiante
          ? '.blocks-videos__list-item--popup-next'
          : '.blocks-videos__list-item--popup-prev');
        if (bt) bt.click();
      }

      /* toque */
      var y0 = null, pop = null, arrastou = false;
      document.addEventListener('touchstart', function (e) {
        pop = e.target.closest ? e.target.closest('insta-stories-popup') : null;
        if (!pop) return;
        y0 = e.touches[0].clientY;
        arrastou = false;
      }, { passive: true });

      document.addEventListener('touchmove', function (e) {
        if (!pop || y0 === null) return;
        if (Math.abs(e.touches[0].clientY - y0) > 6) {
          arrastou = true;
          if (e.cancelable) e.preventDefault();     /* a loja atrás não anda */
        }
      }, { passive: false });

      document.addEventListener('touchend', function (e) {
        if (!pop || y0 === null) { pop = null; return; }
        var dy = e.changedTouches[0].clientY - y0;
        y0 = null;
        var alvo = pop; pop = null;
        /* toque curto continua sendo play/pause; só o arrasto de verdade troca */
        if (!arrastou || Math.abs(dy) < 45) return;
        trocar(alvo, dy < 0);
      }, { passive: true });

      /* roda do mouse, para o desktop ter o mesmo gesto */
      var ultimaRoda = 0;
      document.addEventListener('wheel', function (e) {
        var p = e.target.closest ? e.target.closest('insta-stories-popup') : null;
        if (!p) return;
        if (e.cancelable) e.preventDefault();
        var agora = (e.timeStamp || 0);
        if (agora - ultimaRoda < 600) return;       /* um vídeo por gesto, não vinte */
        if (Math.abs(e.deltaY) < 12) return;
        ultimaRoda = agora;
        trocar(p, e.deltaY > 0);
      }, { passive: false });

      /* seta do teclado, de graça e boa para acessibilidade */
      document.addEventListener('keydown', function (e) {
        var p = abertoAgora();
        if (!p) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); trocar(p, true); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); trocar(p, false); }
      });
    }

    function arrumarTituloGaveta() {
      if (!document.querySelector('.sola-mp[data-mp-gaveta-estilo]')) return;
      var gav = document.querySelector('cart-drawer');
      var faixa = document.querySelector('#CartDrawer-Progress .progress-container');
      if (faixa && !faixa.getAttribute('data-sola-cheia')) {
        /* Só anima o traço enchendo quando o frete grátis JÁ foi alcançado: com a barra
           pela metade, animar até 100% mostraria uma conquista que não existe. */
        var cheio = faixa.querySelector('.progress-fill');
        var trilha = faixa.querySelector('.progress-bar');
        if (cheio && trilha &&
            cheio.getBoundingClientRect().width >= trilha.getBoundingClientRect().width - 3) {
          faixa.setAttribute('data-sola-cheia', '1');
        }
      }
      if (gav && !gav.getAttribute('data-sola-ja-correu') && faixa) {
        setTimeout(function () { gav.setAttribute('data-sola-ja-correu', '1'); }, 2700);
      }
      var nomes = document.querySelectorAll('cart-drawer .cart-item__name');
      for (var i = 0; nomes.length > i; i++) {
        var el = nomes[i];
        if (el.querySelector('.sola-linha-marca')) continue;
        var txt = (el.textContent || '').trim();
        var corte = txt.indexOf(' - ');
        if (0 >= corte) continue;
        var marca = txt.slice(0, corte).trim(), resto = txt.slice(corte + 3).trim();
        el.textContent = '';
        var m = document.createElement('span');
        m.className = 'sola-linha-marca'; m.textContent = marca;
        el.appendChild(m);
        el.appendChild(document.createTextNode(resto));
      }
    }
    (function () {
      var g = document.querySelector('cart-drawer');
      if (g && 'MutationObserver' in window) {
        new MutationObserver(function () { arrumarTituloGaveta(); arrumarUpsell(); arrumarResumo(); })
          .observe(g, { childList: true, subtree: true });
      }
    })();

    /* ── Rolagem única para todos os CTAs da página ────────────────────────────
       Cada seção tinha o seu `scrollTo`, e o botão do banner era âncora nativa
       (<a href="#modulo">), que salta seco. Aqui um só handler, em fase de captura,
       assume todos: mesma curva, mesma duração, mesmo ponto de parada.
       A parada leva em conta o cabeçalho grudado E um respiro, senão a última faixa
       da seção de cima aparece por baixo do header. */
    function rolarSuave(destinoY, duracao) {
      /* Animação própria, quadro a quadro. `scrollTo({behavior:'smooth'})` funciona no
         Chrome mas cai para salto seco no Safari do iPhone — que é onde este tráfego
         está. É o mesmo motivo pelo qual existem polyfills de smooth scroll; aqui a
         animação é curta o bastante para não valer uma biblioteca.

         Dois cuidados que a primeira versão não tinha e que custaram uma rodada:
         · o relógio começa AGORA (`performance.now()`), não no primeiro quadro. Se o
           primeiro quadro demorar, a curva já entra adiantada em vez de a página ficar
           parada esperando;
         · `scroll-behavior` do documento é desligado durante a animação, senão o
           navegador tenta animar cada passo nosso e o resultado é um arrasto grudento. */
      var inicio = window.pageYOffset;
      var dist = destinoY - inicio;
      if (2 > Math.abs(dist)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, destinoY); return;
      }
      var dur = duracao || 800;
      var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
      var raiz = document.documentElement;
      var antes = raiz.style.scrollBehavior;
      raiz.style.scrollBehavior = 'auto';

      function passo() {
        var agora = (window.performance && performance.now) ? performance.now() : Date.now();
        var p = Math.min(1, (agora - t0) / dur);
        /* easeOutQuart: arranca com corpo e encosta macio, sem freada visível */
        var e = 1 - Math.pow(1 - p, 4);
        window.scrollTo(0, Math.round(inicio + dist * e));
        if (1 > p) requestAnimationFrame(passo);
        else raiz.style.scrollBehavior = antes;
      }
      passo();                                  /* primeiro passo já neste quadro */
      requestAnimationFrame(passo);
    }

    function alvoDosCtas() {
      /* Ancorar na SEÇÃO, não na grade. Com a grade, sobravam 32px acima dela dentro da
         própria seção, e a última faixa do marquee aparecia por baixo do cabeçalho —
         era o traço preto que o cliente via. Parando na borda da seção, nada de cima
         entra na tela e o respiro até o título é o da própria seção. */
      var raizA = document.querySelector('.sola-mp[data-mp-secao]');
      if (raizA && raizA.closest) {
        var sec = raizA.closest('[id^="shopify-section"]');
        if (sec) return sec;
      }
      var id = raizA ? raizA.getAttribute('data-mp-ancora') : null;
      return document.querySelector(id ? '#' + id : '#modulo');
    }

    /* Altura real do que fica grudado no topo. `--mp-topo` chegava vazia e o código caía
       no palpite de 96px, quando o cabeçalho mede 73 no celular: os 23px de diferença
       eram exatamente a faixa que sobrava aparecendo. */
    function alturaGrudada() {
      var maior = 0;
      var cands = document.querySelectorAll('header, [id$="__header"], .utility-bar, .announcement-bar-section, [id*="announcement"]');
      for (var i = 0; cands.length > i; i++) {
        var c = getComputedStyle(cands[i]);
        if (c.position !== 'fixed' && c.position !== 'sticky') continue;
        var r2 = cands[i].getBoundingClientRect();
        if (r2.height > 0 && r2.bottom > maior && 250 > r2.bottom) maior = r2.bottom;
      }
      return Math.round(maior);
    }

    function ligarRolagemCtas() {
      if (document.documentElement.getAttribute('data-sola-rolagem')) return;
      document.documentElement.setAttribute('data-sola-rolagem', '1');
      var SELETORES = '[data-mc-ir],[data-tam-ir],[data-mot-ir],[data-uc-ir],[data-of-ir],'
        + '[data-mp-barra-btn],[data-rec-ir-btn],.sola-hero__cta,a[href="#modulo"]';
      document.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest(SELETORES) : null;
        if (!b) return;
        var alvo = alvoDosCtas();
        if (!alvo) return;
        e.preventDefault();
        e.stopPropagation();            /* impede o scrollTo seco de cada seção */
        /* ...e é justamente por isso que o aviso abaixo precisa existir: este ouvinte
           está na fase de CAPTURA, então `stopPropagation` impede o clique de chegar ao
           handler do próprio botão. Era o que deixava o popup de saída aberto enquanto a
           página rolava por baixo dele: o `fechar()` daquele botão nunca rodava.
           Em vez de abrir exceção para cada popup aqui, avisamos — e quem estiver aberto
           se fecha com a própria lógica. Rolar com uma sobreposição na frente é sempre
           errado, qualquer que seja ela. */
        document.dispatchEvent(new CustomEvent('sola:fechar-sobreposicoes'));
        var raizB = document.querySelector('.sola-mp[data-mp-secao]');
        var folga = parseInt(raizB && raizB.getAttribute('data-mp-parada'), 10);
        if (isNaN(folga)) folga = 14;
        var y = alvo.getBoundingClientRect().top + window.pageYOffset - alturaGrudada() - folga;
        var dur = parseInt(raizB && raizB.getAttribute('data-mp-rolagem'), 10) || 800;
        rolarSuave(Math.max(0, y), dur);
      }, true);
    }

    function todos() {
      var lista = document.querySelectorAll('.sola-mp');
      for (var i = 0; lista.length > i; i++) iniciar(lista[i]);
      ajustarTopo();
      /* a barra não espera o popup se já tinha assumido numa visita anterior */
      var rp = document.querySelector('.sola-mp[data-prazo-chave]');
      if (rp) {
        var lembrou = false;
        try { lembrou = localStorage.getItem(rp.getAttribute('data-prazo-chave') + '-barra') === '1'; } catch (e) {}
        if (lembrou) assumirBarra(false);
      }
      iniciarCaptura();
      iniciarRecuperacao();
      iniciarProvador();
      aquecerGaveta();
      arrumarTituloGaveta();
      arrumarUpsell();
      arrumarResumo();
      arrumarStories();
      ligarDeslizeStories();
      ligarGestosStories();
      ligarRolagemCtas();
      vigiarBrinde();
      marcarBrindeNaGaveta();
      sincronizarBrinde();
    }
    window.addEventListener('resize', ajustarTopo);
    window.addEventListener('load', ajustarTopo);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos);
    else todos();
    /* o personalizador recria a seção sem recarregar a página */
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sola-marca"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var pl = e.target.closest ? e.target.closest('[data-mc-play]') : null;
      if (pl) {
        var v = pl.parentElement.querySelector('video');
        if (!v) return;
        e.preventDefault();
        if (v.paused) { v.play(); pl.setAttribute('data-tocando', '1'); }
        else { v.pause(); pl.removeAttribute('data-tocando'); }
        return;
      }
      var b = e.target.closest ? e.target.closest('[data-mc-ir]') : null;
      if (!b) return;
      var alvo = document.querySelector(b.getAttribute('data-mc-ir'));
      if (!alvo) return;
      e.preventDefault();
      var topo = 0, mp = document.querySelector('.sola-mp');
      if (mp) topo = parseInt(getComputedStyle(mp).getPropertyValue('--mp-topo'), 10) || 0;
      window.scrollTo({ top: alvo.getBoundingClientRect().top + window.pageYOffset - topo, behavior: 'smooth' });
    });

    /* Tarja. O CSS so esconde quando `data-mc-anima` esta na foto, e quem escreve
       esse atributo e este script: assim, se ele nao rodar, a tarja fica visivel em
       vez de sumir. Depois o observador espera a foto entrar de verdade na tela
       (35% dela) e solta a subida uma unica vez. */
    function ligarTarjas(raiz) {
      var tarjas = (raiz || document).querySelectorAll('[data-mc-tarja]');
      if (!tarjas.length) return;
      /* O gatilho é o RODAPÉ da foto, não uma fração dela — é de lá que a tarja sobe,
         e é lá que o olho está quando ela sobe.

         Duas tentativas que não servem, para ninguém refazer:
         · fração da foto (`threshold`): aqui a foto já nasce meio na tela e a subida
           acontecia enquanto a pessoa ainda olhava o banner; e numa foto mais alta que
           a janela a fração exigida nunca é atingida e a tarja não sobe nunca;
         · observar a própria tarja: ela está fora da foto enquanto escondida, e o
           IntersectionObserver aplica o recorte dos ancestrais — a foto tem
           `overflow:hidden`, então a área de interseção é sempre zero. Medido.

         Então o observador só responde "a foto encostou na tela"; quem decide é a
         geometria, conferida na rolagem. `r.bottom <= altura - folga` também cobre a
         foto que já passou (bottom negativo), senão quem recarrega a página no meio
         dela ficaria com a tarja escondida para sempre. */
      var pendentes = [], ouvindo = false, agendado = false;

      /* O gatilho é o CENTRO da foto cruzando uma linha da tela — não o rodapé dela.
         Mirar no rodapé fazia a tarja subir com a foto ainda entrando por baixo, quase
         na borda; mirando no centro, ela sobe com a foto enquadrada no meio, que é onde
         o olho está. A linha é setting (`tarja_ponto`): 50 = meio da tela, menos = mais
         cedo, mais = mais tarde. */
      function chegou(midia) {
        var r = midia.getBoundingClientRect();
        var h = window.innerHeight || document.documentElement.clientHeight;
        var ponto = parseFloat(midia.getAttribute('data-mc-ponto')) || 52;
        return (r.top + r.height / 2) <= h * (ponto / 100);
      }
      function conferir() {
        agendado = false;
        for (var i = pendentes.length - 1; i >= 0; i--) {
          if (!chegou(pendentes[i])) continue;
          pendentes[i].setAttribute('data-mc-visivel', '1');
          pendentes.splice(i, 1);
        }
        if (!pendentes.length && ouvindo) {
          window.removeEventListener('scroll', naRolagem);
          window.removeEventListener('resize', naRolagem);
          ouvindo = false;
        }
      }
      function naRolagem() {
        if (agendado) return;
        agendado = true;
        (window.requestAnimationFrame || setTimeout)(conferir, 16);
      }
      function vigiar(midia) {
        if (chegou(midia)) { midia.setAttribute('data-mc-visivel', '1'); return; }
        pendentes.push(midia);
        if (ouvindo) return;
        ouvindo = true;
        window.addEventListener('scroll', naRolagem, { passive: true });
        window.addEventListener('resize', naRolagem, { passive: true });
      }

      var temIO = 'IntersectionObserver' in window;
      var obs = temIO ? new IntersectionObserver(function (entradas, o) {
        for (var k = 0; entradas.length > k; k++) {
          if (!entradas[k].isIntersecting) continue;
          o.unobserve(entradas[k].target);
          vigiar(entradas[k].target);
        }
      }, { threshold: 0 }) : null;

      for (var i = 0; tarjas.length > i; i++) {
        var midia = tarjas[i].parentElement;
        if (!midia || midia.getAttribute('data-mc-obs')) continue;
        midia.setAttribute('data-mc-obs', '1');
        /* rede: se o script em linha não rodou (o personalizador recriando a seção,
           por exemplo), o interruptor do CSS entra aqui mesmo */
        midia.setAttribute('data-mc-anima', '1');
        if (obs) obs.observe(midia);
        else vigiar(midia);
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ligarTarjas(); });
    else ligarTarjas();
    /* o personalizador recria a secao inteira a cada edicao */
    document.addEventListener('shopify:section:load', function (e) { ligarTarjas(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sola-motivos-video"] && !Shopify.designMode) return;
  try {
    
  /* Só o CTA: leva até o módulo de compra. Sintaxe conservadora — 81% deste
     tráfego está em webview de rede social. */
  (function () {
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-mot-ir]') : null;
      if (!b) return;
      var sel = b.getAttribute('data-mot-ir');
      var alvo = sel ? document.querySelector(sel) : null;
      if (!alvo) return;
      e.preventDefault();
      var topo = 0;
      var mp = document.querySelector('.sola-mp');
      if (mp) topo = parseInt(getComputedStyle(mp).getPropertyValue('--mp-topo'), 10) || 0;
      var y = alvo.getBoundingClientRect().top + window.pageYOffset - topo;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sola-motivos"] && !Shopify.designMode) return;
  try {
    
  /* Só o CTA: leva até o módulo de compra. Sintaxe conservadora — 81% deste
     tráfego está em webview de rede social. */
  (function () {
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-mot-ir]') : null;
      if (!b) return;
      var sel = b.getAttribute('data-mot-ir');
      var alvo = sel ? document.querySelector(sel) : null;
      if (!alvo) return;
      e.preventDefault();
      var topo = 0;
      var mp = document.querySelector('.sola-mp');
      if (mp) topo = parseInt(getComputedStyle(mp).getPropertyValue('--mp-topo'), 10) || 0;
      var y = alvo.getBoundingClientRect().top + window.pageYOffset - topo;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sola-tamanho"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var ir = e.target.closest ? e.target.closest('[data-tam-ir]') : null;
      if (ir) {
        var alvo = document.querySelector(ir.getAttribute('data-tam-ir'));
        if (!alvo) return;
        e.preventDefault();
        var topo = 0, mp = document.querySelector('.sola-mp');
        if (mp) topo = parseInt(getComputedStyle(mp).getPropertyValue('--mp-topo'), 10) || 0;
        window.scrollTo({ top: alvo.getBoundingClientRect().top + window.pageYOffset - topo, behavior: 'smooth' });
        return;
      }
      var prov = e.target.closest ? e.target.closest('[data-tam-provador]') : null;
      if (!prov) return;
      e.preventDefault();
      var b = document.querySelectorAll('[class*="vfr__button"]');
      for (var i = 0; b.length > i; i++) {
        if (/provador|vfr|prova/i.test((b[i].textContent || '') + ' ' + b[i].className)) { b[i].click(); return; }
      }
      if (b.length) b[0].click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sola-ultima-chamada"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-uc-ir]') : null;
      if (!b) return;
      var sel = b.getAttribute('data-uc-ir');
      var alvo = sel ? document.querySelector(sel) : null;
      if (!alvo) return;
      e.preventDefault();
      var topo = 0;
      var mp = document.querySelector('.sola-mp');
      if (mp) topo = parseInt(getComputedStyle(mp).getPropertyValue('--mp-topo'), 10) || 0;
      var y = alvo.getBoundingClientRect().top + window.pageYOffset - topo;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
